import React, { Component } from 'react';
import Loader from './cmp/Loader'
import AuthForm from './cmp/authForm'
import TabPanel from './cmp/TabPanel'
import Header from './cmp/header'
import TablesTab from './cmp/tablesTab'
import DeliveryTab from './cmp/DeliveryTab'
import Order from './cmp/Order'
import MsgForm from './cmp/msgForm'
import MsgSound from './cmp/msgSound'
import Calc from './cmp/Calc'
import Keybord from './cmp/Keybord'
import Keybord2 from './cmp/Keybord2'
import Discount from './cmp/Discount'
import BreakCheck from './cmp/BreakCheck'
import Tabfrm from './cmp/Tabfrm'
import RangeForm from './cmp/RangeForm'
import NumberForm from './cmp/NumberForm'
import CatDevices4Viev from './cmp/CatDevices4Viev'
import CatDevices5Viev from './cmp/CatDevices5Viev'
import DeliveryInput from './cmp/DeliveryInput'
import ArrayForm from './cmp/arrayForm'
import SeveralForm from './cmp/SeveralForm'
import PayForm from './cmp/PayForm'
import CheckList from './cmp/CheckList'
import Modifiers from './cmp/Modifiers'
import TimeKeeping from './cmp/TimeKeeping'
import DeliveryForm from './cmp/DeliveryForm'
import NewStatement from './cmp/NewStatement.js';
import GMap from './cmp/GMap.js';

//import logo from './logo.svg';
import sound1 from './sound1.mp3';
import sound2 from './sound2.mp3';
import sound3 from './sound3.mp3';
import sound4 from './sound4.mp3';
import './App.css';

//import {load,localestr,uid,dataContext} from './utils.js'
import { load, report, loaddat, localestr, uid, urlBase64ToUint8Array, dataContext, isNumeric } from './utils.js'
import { print_rawbt, printer_job } from './printing.js'
import { THEME1, THEME2, THEME3, THEME_0, THEME_2, THEME_3, } from './constants.js';
import { playSound } from './helpers/playSoundHelper.js';
import BanquetTab from './cmp/BanquetTab.js';
import BanquetInput from './cmp/BanquetInput.js';
//import { act } from 'react';
//import { Logger } from './helpers/Loger.js';

let db = undefined
let dsc = []
let res_marks = []
let timer = 15
let push_id = null
let ws = null
let w_s = { ws: null }
let sended = null
let busy = false
let apiKey = "";

class App extends Component {
  state = {
    status: '',
    user_id: '',
    user: '',
    rights: {},
    hall: '',
    update: '',
    windows: [],
    orders: [],
    tasks: [],
    jobPrint: [],
    activeWindow: 0,
    modal: '',
    modal2: '',
    modal3: '',
    modal4: '',
    modal5: '',
    modal6: '',
    data: {},
    tabsMode: localStorage.getItem('tabsMode') || '0',
    soundMode: localStorage.getItem('soundMode') || '0',
  }

  tabClick = (idx) => {
    let uid = 0
    const windows = this.state.windows
    if (this.state.activeWindow > 0 && this.state.activeWindow < this.state.windows.length) uid = this.state.windows[this.state.activeWindow].data.uid
    if (idx > 0 && idx < this.state.windows.length) windows[idx].data.news = false
    this.setState({ activeWindow: idx, windows })
    this.modUserDB(this.state.user_id, null, null, this.state.windows[idx].data.uid, null, -1)
    if (uid) this.sendTask(uid)
  }

  tabClose = (idx, activetab) => {
    let active = activetab
    if (idx <= active) active -= 1
    if (this.state.windows.length > 0) active = Math.max(0, active)
    const windows = this.state.windows.filter((item, index) => { return index !== idx })
    const activeWindow = active
    this.setState({ windows, activeWindow })
  }

  setModal = (modal) => {
    this.setState({ modal })
  }

  setModal2 = (modal2) => {
    this.setState({ modal2 })
  }

  setModal3 = (modal3) => {
    this.setState({ modal3 })
  }

  setModal4 = (modal4) => {
    this.setState({ modal4 })
  }

  setModal5 = (modal5) => {
    this.setState({ modal5 })
  }

  setModal6 = (modal6) => {
    this.setState({ modal6 })
  }

  msg = (str, capt, actions) => {
    if (this.state.modal) {
      if (this.state.modal2) {
        if (this.state.modal3) {
          if (this.state.modal4) {
            const modal5 = <MsgForm Text={str} caption={capt} setModal={this.setModal5} actions={actions} id={'5'} />
            this.setState({ modal5 })
          } else {
            const modal4 = <MsgForm Text={str} caption={capt} setModal={this.setModal4} actions={actions} id={'4'} />
            this.setState({ modal4 })
          }
        } else {
          const modal3 = <MsgForm Text={str} caption={capt} setModal={this.setModal3} actions={actions} id={'3'} />
          this.setState({ modal3 })
        }
      } else {
        const modal2 = <MsgForm Text={str} caption={capt} setModal={this.setModal2} actions={actions} id={'2'} />
        this.setState({ modal2 })
      }
    } else {
      const modal = <MsgForm Text={str} caption={capt} setModal={this.setModal} actions={actions} id={'1'} />
      this.setState({ modal })
    }
  }

  msg_sound = (str, capt, sound, actions) => {
    if (this.state.modal) {
      if (this.state.modal2) {
        if (this.state.modal3) {
          if (this.state.modal4) {
            const modal5 = <MsgSound soundMode={this.state.soundMode} Text={str} caption={capt} sound={sound} setModal={this.setModal5} actions={actions} id={'5'} />
            this.setState({ modal5 })
          } else {
            const modal4 = <MsgSound soundMode={this.state.soundMode} Text={str} caption={capt} sound={sound} setModal={this.setModal4} actions={actions} id={'4'} />
            this.setState({ modal4 })
          }
        } else {
          const modal3 = <MsgSound soundMode={this.state.soundMode} Text={str} caption={capt} sound={sound} setModal={this.setModal3} actions={actions} id={'3'} />
          this.setState({ modal3 })
        }
      } else {
        const modal2 = <MsgSound soundMode={this.state.soundMode} Text={str} caption={capt} sound={sound} setModal={this.setModal2} actions={actions} id={'2'} />
        this.setState({ modal2 })
      }
    } else {
      const modal = <MsgSound soundMode={this.state.soundMode} Text={str} caption={capt} sound={sound} setModal={this.setModal} actions={actions} id={'1'} />
      this.setState({ modal })
    }
  }

  gmap = (type, caption, data) => {
    if (type === 'users') {
      let catUsers = data ? data : (this.state.data?.catUsers || []);
      data = (this.state.locations?.users || []).map(u => {
        const cu = (catUsers).find(c => c.id === u.user_id);
        if (!cu) return null;
        return { id: cu.id, name: cu.name, location: u.location, last_upd: u.date };
      }).filter(Boolean);
    }

    if (data.length === 0) {
      this.msg(localestr("Дані відсутні"), localestr('Повідомлення'));
      return;
    }

    if (this.state.modal) {
      if (this.state.modal2) {
        if (this.state.modal3) {
          if (this.state.modal4) {
            const modal5 = <GMap type={type} caption={caption} data={data} googleMapsApiKey={apiKey} setModal={this.setModal5} locations={this.state?.locations} setLocations={(locations) => { this.setState({ locations }) }} id={'5'} />
            this.setState({ modal5 })
          } else {
            const modal4 = <GMap type={type} caption={caption} data={data} googleMapsApiKey={apiKey} setModal={this.setModal4} locations={this.state?.locations} setLocations={(locations) => { this.setState({ locations }) }} id={'4'} />
            this.setState({ modal4 })
          }
        } else {
          const modal3 = <GMap type={type} caption={caption} data={data} googleMapsApiKey={apiKey} setModal={this.setModal3} locations={this.state?.locations} setLocations={(locations) => { this.setState({ locations }) }} id={'3'} />
          this.setState({ modal3 })
        }
      } else {
        const modal2 = <GMap type={type} caption={caption} data={data} googleMapsApiKey={apiKey} setModal={this.setModal2} locations={this.state?.locations} setLocations={(locations) => { this.setState({ locations }) }} id={'2'} />
        this.setState({ modal2 })
      }
    } else {
      const modal = <GMap type={type} caption={caption} data={data} googleMapsApiKey={apiKey} setModal={this.setModal} locations={this.state?.locations} setLocations={(locations) => { this.setState({ locations }) }} id={'1'} />
      this.setState({ modal })
    }
  }

  msg_arr = (str, capt, act) => {
    if (this.state.modal) {
      const modal2 = <ArrayForm Text={str} caption={capt} setModal={this.setModal2} actions={act} id={'2'} />
      this.setState({ modal2 })
    } else {
      const modal = <ArrayForm Text={str} caption={capt} setModal={this.setModal} actions={act} />
      this.setState({ modal })
    }
  }

  inputSeveral = (str, capt, data, act) => {
    if (this.state.modal) {
      const modal2 = <SeveralForm Text={str} caption={capt} data={data} setModal={this.setModal2} action={act} id={'2'} />
      this.setState({ modal2 })
    } else {
      const modal = <SeveralForm Text={str} caption={capt} data={data} setModal={this.setModal} action={act} />
      this.setState({ modal })
    }
  }

  inputRange = (from, to, act) => {
    if (!this.state.modal) {
      const modal = <RangeForm from={from} to={to} setModal={this.setModal} action={act} />
      this.setState({ modal })
    } else if (!this.state.modal2) {
      const modal2 = <RangeForm from={from} to={to} setModal={this.setModal2} action={act} />
      this.setState({ modal2 })
    } else if (!this.state.modal3) {
      const modal3 = <RangeForm from={from} to={to} setModal={this.setModal3} action={act} />
      this.setState({ modal3 })
    } else {
      const modal4 = <RangeForm from={from} to={to} setModal={this.setModal4} action={act} />
      this.setState({ modal4 })
    }
  }

  inputNumber = (capt1, capt2, number, act) => {
    if (!this.state.modal) {
      const modal = <NumberForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal} action={act} />
      this.setState({ modal })
    } else if (!this.state.modal2) {
      const modal2 = <NumberForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal2} action={act} />
      this.setState({ modal2 })
    } else if (!this.state.modal3) {
      const modal3 = <NumberForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal3} action={act} />
      this.setState({ modal3 })
    } else {
      const modal4 = <NumberForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal4} action={act} />
      this.setState({ modal4 })
    }
  }

  inputDelivery = (data, act) => {
    if (!this.state.modal) {
      const modal = <DeliveryInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal })
    } else if (!this.state.modal2) {
      const modal2 = <DeliveryInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal2} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal2 })
    } else if (!this.state.modal3) {
      const modal3 = <DeliveryInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal3} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal3 })
    } else {
      const modal4 = <DeliveryInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal4} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal4 })
    }
  }

  inputBanquet = (data, act) => {
    if (!this.state.modal) {
      const modal = <BanquetInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal })
    } else if (!this.state.modal2) {
      const modal2 = <BanquetInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal2} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal2 })
    } else if (!this.state.modal3) {
      const modal3 = <BanquetInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal3} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal3 })
    } else {
      const modal4 = <BanquetInput data={data} googleMapsApiKey={apiKey} discounts={this.state.data['catDiscounts']} setModal={this.setModal4} action={act} tblClick={(tbl) => tbl} cities={this.state.data['cities']} tables={{ user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }} />
      this.setState({ modal4 })
    }
  }

  getWnd = (wndType, idx) => {
    if (wndType === 'tablesTab') return (<TablesTab userId={this.state.user_id} hall={this.state.hall} setHall={(hall) => { this.setState({ hall }); this.modUserDB(this.state.user_id, hall, null, null, null, -1) }} tblClick={(tbl) => { this.openOrder(tbl) }} Data={this.state.data.catHalls} Orders={this.state.orders} Rights={this.state.rights} />)
    if (wndType === 'deliveryTab') return (<DeliveryTab userId={this.state.user_id} cmdClick={this.openOrderDelivery} Orders={this.state.orders} CourierOrd={this.state.courierOrd} CourierTrn={this.state.courierTrn} Rights={this.state.rights} Consts={this.state.data.const} docType={1} showMap={this.gmap} showMsg={this.msg} runCmd={this.runCmd} />)
    if (wndType === 'pickupTab') return (<DeliveryTab userId={this.state.user_id} cmdClick={this.openOrderPickup} Orders={this.state.orders} Rights={this.state.rights} docType={2} />)
    if (wndType === 'banquetTab') return (<BanquetTab userId={this.state.user_id} wndData={this.state.windows[idx].data} cmdClick={this.openOrderBanquet} Orders={this.state.orders} Rights={this.state.rights} docType={3} />)
    if (wndType === 'orderTab') return (<Order wndData={this.state.windows[idx].data} catMenu={this.state.data.catMenu} fldMenu={this.state.data.fldMenu} Rights={this.state.rights} setWndData={(cmd, data) => { this.modOrder(idx, cmd, data) }} consts={this.state.data.const} catReasons={this.state.data.catReasons} catUsers={this.state.data.catUsers} stoplist={this.state.stoplist || []} />)
    return <div>{wndType}</div>
  }

  getOrderCaption = (order) => {
    let hall = { name: '' }
    let table = { name: '' }
    if (order.table) hall = this.state.data['catHalls'].find(h => order.table && h.id === order.table.owner.id) || { name: '' }
    if (order.table) table = order.table || { name: '' }
    let aut = ''
    let phone = ''
    let num = ' *'
    if (order.phone) phone = order.phone || ''
    if ((this.state.rights.urAdmin || this.state.rights.urOrder) && order.author && (order.author.id !== this.state.user_id)) aut = ' (' + order.author?.name + ')'
    if (order.id) num = ' №' + order.id
    if (order.docType === 1) return 'Д~' + phone.substring(6) + num + aut
    if (order.docType === 2) return 'С~' + phone.substring(6) + num + aut
    if (order.docType === 3) return 'На ' + order.date.substring(8, 10) + '.' + order.date.substring(5, 7) + num + aut
    return (table?.name || '') + ' ' + hall?.name + num + aut
  }

  openOrder = (data) => {
    if (data.uid) {
      const idx = this.state.windows.findIndex(el => el.data.uid === data.uid)
      if (idx !== -1) this.tabClick(idx)
      return
    }
    if (busy) {
      setTimeout(() => this.openOrder(data), 100)
      busy = false
      return
    }
    let guests = 1
    if (this.state.rights.urGuests) guests = 0
    //const order={uid:uid(),sum:0,author:{id:this.state.user_id,name:this.state.user},date:(new Date()).toISOString().substring(0,10),docTable:[],table:data.table}
    const order = { uid: uid(), sum: 0, author: { id: this.state.user_id, name: this.state.user, fio: this.state.user_fio }, date: (new Date()).toISOString().substring(0, 19) + 'Z', docType: 0, guests, userFisSet: localStorage.getItem('user_fiscal'), docTable: [], table: data.table }
    if (data.table && data.table.owner.goods) order.parent = this.state.data.fldMenu.find(el => el.id === data.table.owner.goods)
    const orders = this.state.orders.concat(order)
    //Тут додавання ордера у завдання і збереження ордерів 
    const task = { timer: 10, status: 0, ...order } //0 новий, 1 выдправлено, можна удалити, 2 щось пышло не так
    const tasks = this.state.tasks.concat(task)
    //this.setCurentDB(orders)
    const windows = this.state.windows.concat({ caption: this.getOrderCaption(data), wndType: 'orderTab', data: order })
    this.setState({ tasks, windows, activeWindow: windows.length - 1, orders })
    //Якщо користувач має ввести к-сть гостей
    if (this.state.rights.urGuests) {
      setTimeout(() => {
        this.modOrder(windows.length - 1, 'guests', null)
      }, 300);
    }
  }

  openOrderDelivery = (data) => {
    if (!data) {
      //Викликати окошко ввода телефона ы адреса
      this.inputDelivery({}, this.openOrderDelivery)
      return
    }
    if (data.uid) {
      const idx = this.state.windows.findIndex(el => el.data.uid === data.uid)
      if (idx !== -1) this.tabClick(idx)
      return
    }
    if (busy) {
      setTimeout(() => this.openOrderDelivery(data), 100)
      busy = false
      return
    }
    //Збереження дисконта
    if (data.phone && data.address && !data.discount) this.msg(localestr('Зберегти клієнта?') + "\n" + data?.name || localestr('Доставка') + "\n" + data.phone + "\n" + data.address, undefined, [{ caption: localestr('Так'), action: () => { dsc.push({ name: data?.name || localestr('Доставка'), phone: data.phone, address: data.address, city: data.city, street: data.street }); this.saveDiscount() } }, { caption: localestr('Ні'), action: () => { } }])
    else if (data.phone && data.address && data.discount && !data.discount.address) this.msg(localestr('Зберегти адресу клієнта?') + "\n" + data.discount?.name + "\n" + data.discount.phone + "\n" + data.address, undefined, [{ caption: localestr('Так'), action: () => { dsc.push({ name: data.discount?.name, phone: data.discount.phone, address: data.address, city: data.city, street: data.street }); this.saveDiscount() } }, { caption: localestr('Ні'), action: () => { } }])
    else if (data.phone && data.address && data.discount && data.discount.address !== data.address) this.msg(localestr('Зберегти адресу клієнта?') + "\n" + data.discount?.name + "\n" + data.discount.phone + "\n" + data.address, undefined, [{ caption: localestr('Так'), action: () => { dsc.push({ name: data.discount?.name, phone: data.discount.phone, address: data.address, city: data.city, street: data.street }); this.saveDiscount() } }, { caption: localestr('Ні'), action: () => { } }])
    const order = { uid: uid(), sum: 0, author: { id: this.state.user_id, name: this.state.user, fio: this.state.user_fio }, date: (new Date()).toISOString().substring(0, 19) + 'Z', docTable: [], docType: 1, guests: 1, userFisSet: localStorage.getItem('user_fiscal'), finish_to: data.finishTo, ...data }
    if (!data.finish_to && data.wait) {
      if (isNumeric(data.wait)) {
        const now = new Date()
        now.setMinutes(now.getMinutes() + parseInt(data.wait))
        order.finish_to = now.toLocaleTimeString('uk-UA', { hour12: false, hour: '2-digit', minute: '2-digit' }).substring(0, 5) + "#" + parseInt(data.wait)
      }
    }
    if (data.pickup) order.docType = 2
    else if (data?.table && Object.keys(data.table)) order.docType = 0
    else {
      let deliv = null
      if (this.state.data.catMenu) deliv = this.state.data.catMenu.find(itm => itm.id === this.state.data.const.constDelivery)
      if (deliv && !this.state.data.const.constXprs) setTimeout(() => this.msg(localestr('Додати доставку?'), undefined, [{ caption: localestr('Так'), action: () => this.modOrder(windows.length - 1, 'add', deliv) }, { caption: localestr('Ні'), action: () => { } }]), 300)
    }
    const orders = this.state.orders.concat(order)
    //Тут додавання ордера у завдання і збереження ордерів 
    const task = { timer: 10, status: 0, ...order } //0 новий, 1 выдправлено, можна удалити, 2 щось пышло не так
    const tasks = this.state.tasks.concat(task)
    //this.setCurentDB(orders)
    const windows = this.state.windows.concat({ caption: this.getOrderCaption(order), wndType: 'orderTab', data: order })
    this.setState({ tasks, windows, activeWindow: windows.length - 1, orders })
  }

  openOrderPickup = (data) => {
    if (!data) {
      //Викликати окошко ввода телефона ы адреса
      this.inputDelivery({ address: 'Самовивіз', pickup: true }, this.openOrderPickup)
      return
    }
    if (data.uid) {
      const idx = this.state.windows.findIndex(el => el.data.uid === data.uid)
      if (idx !== -1) this.tabClick(idx)
      return
    }
    if (busy) {
      setTimeout(() => this.openOrderPickup(data), 100)
      busy = false
      return
    }
    //Збереження дисконта
    //if(data.phone && data.address && !data.discount) this.msg(localestr('Зберегти клієнта?')+"\n"+data?.name||localestr('Доставка')+"\n"+data.phone+"\n"+data.address,undefined,[{caption:localestr('Так'),action:()=>{dsc.push({name:data?.name||localestr('Доставка'),phone:data.phone,address:data.address});this.saveDiscount()}},{caption:localestr('Ні'),action:()=>{}}])
    //else if(data.phone && data.address && data.discount && !data.discount.address) this.msg(localestr('Зберегти адресу клієнта?')+"\n"+data.discount?.name+"\n"+data.discount.phone+"\n"+data.address,undefined,[{caption:localestr('Так'),action:()=>{dsc.push({name:data.discount?.name,phone:data.discount.phone,address:data.address});this.saveDiscount()}},{caption:localestr('Ні'),action:()=>{}}])

    const order = { uid: uid(), sum: 0, author: { id: this.state.user_id, name: this.state.user, fio: this.state.user_fio }, date: (new Date()).toISOString().substring(0, 19) + 'Z', docTable: [], docType: 2, guests: 1, userFisSet: localStorage.getItem('user_fiscal'), finish_to: data.finishTo, ...data }
    if (!data.finish_to && data.wait) {
      if (isNumeric(data.wait)) {
        const now = new Date()
        now.setMinutes(now.getMinutes() + parseInt(data.wait))
        order.finish_to = now.toLocaleTimeString('uk-UA', { hour12: false, hour: '2-digit', minute: '2-digit' }).substring(0, 5) + "#" + parseInt(data.wait)
      }
    }
    if (!data.pickup && !data?.table) {
      order.docType = 1
      let deliv = null
      if (this.state.data.catMenu) deliv = this.state.data.catMenu.find(itm => itm.id === this.state.data.const.constDelivery)
      if (deliv && !this.state.data.const.constXprs) setTimeout(() => this.msg(localestr('Додати доставку?'), undefined, [{ caption: localestr('Так'), action: () => this.modOrder(windows.length - 1, 'add', deliv) }, { caption: localestr('Ні'), action: () => { } }]), 300)
    } else if (data?.table && Object.keys(data.table)) {
      order.docType = 0
    }
    const orders = this.state.orders.concat(order)
    //Тут додавання ордера у завдання і збереження ордерів 
    const task = { timer: 10, status: 0, ...order } //0 новий, 1 выдправлено, можна удалити, 2 щось пышло не так
    const tasks = this.state.tasks.concat(task)
    //this.setCurentDB(orders)
    const windows = this.state.windows.concat({ caption: this.getOrderCaption(order), wndType: 'orderTab', data: order })
    this.setState({ tasks, windows, activeWindow: windows.length - 1, orders })
  }

  openOrderBanquet = (data) => {
    if (!data) {
      this.inputBanquet({ address: '', banquet: true }, this.openOrderBanquet)
      return
    }
    if (data.uid) {
      const idx = this.state.windows.findIndex(el => el.data.uid === data.uid)
      if (idx !== -1) this.tabClick(idx)
      return
    }
    if (busy) {
      setTimeout(() => this.openOrderBanquet(data), 100)
      busy = false
      return
    }
    const order = { uid: uid(), sum: 0, author: { id: this.state.user_id, name: this.state.user, fio: this.state.user_fio }, date: data.finish_to.toISOString().substring(0, 19) + 'Z', docTable: [], docType: 3, guests: 1, userFisSet: localStorage.getItem('user_fiscal'), ...data, finish_to: '' }
    /*if (!data.finish_to && data.wait) {
      if (isNumeric(data.wait)) {
        const now = new Date()
        now.setMinutes(now.getMinutes() + parseInt(data.wait))
        order.finish_to = now.toLocaleTimeString('uk-UA', { hour12: false, hour: '2-digit', minute: '2-digit' }).substring(0, 5) + "#" + parseInt(data.wait)
      }
    }*/
    const orders = this.state.orders.concat(order)
    //Тут додавання ордера у завдання і збереження ордерів 
    const task = { timer: 10, status: 0, ...order } //0 новий, 1 выдправлено, можна удалити, 2 щось пышло не так
    const tasks = this.state.tasks.concat(task)
    //this.setCurentDB(orders)
    const windows = this.state.windows.concat({ caption: this.getOrderCaption(order), wndType: 'orderTab', data: order })
    this.setState({ tasks, windows, activeWindow: windows.length - 1, orders })
  }

  printData = async (data) => {
    if (data.print) {
      let tmr = 1;
      //data.print.forEach(d => {
      for (const d of data.print) {
        if (d.type === 'svg') {
          const canvas = document.createElement('canvas');
          //const scale = 3.78;
          const scale = 10;
          canvas.width = d.width * scale;
          canvas.height = d.height * scale;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.fillStyle = 'black';
          //d.data.forEach(el => {
          const promises = d.data.map(el => {
            switch (el.type) {
              case 'text':
                ctx.font = `${el.style?.fontStyle || ''} ${el.style?.fontWeight || ''} ${parseFloat(el.style?.fontSize || '3') * scale}px ${el.style?.fontFamily || 'Arial'}`;
                ctx.textAlign = el.style?.textAnchor === "middle" ? "center"
                  : el.style?.textAnchor === "end" ? "right"
                    : "left";
                ctx.fillText(el.text, el.x * scale, el.y * scale);
                //break;
                return Promise.resolve();
              case 'line':
                ctx.beginPath();
                ctx.moveTo(el.x1 * scale, el.y1 * scale);
                ctx.lineTo(el.x2 * scale, el.y2 * scale);
                ctx.lineWidth = 0.2 * scale;
                ctx.stroke();
                //break;
                return Promise.resolve();
              case 'rect':
                ctx.strokeRect(el.x * scale, el.y * scale, el.width * scale, el.height * scale);
                //break;
                return Promise.resolve();
              case 'img':
                return new Promise((resolve, reject) => {
                  const img = new Image();
                  img.onload = () => {
                    ctx.drawImage(img, el.x * scale, el.y * scale, el.width * scale, el.height * scale);
                    resolve();
                  };
                  img.onerror = reject;
                  img.src = el.src;
                  //break;
                });
              default:
                //break;
                return Promise.resolve();
            }
          });
          await Promise.all(promises);
          const cont = <img src={canvas.toDataURL()} alt="print" style={{ width: d.width + 'mm', height: d.height + 'mm' }} />;
          const buttons = [{ caption: localestr('Закрити'), action: () => { } }];
          if (navigator.canShare) buttons.push({
            caption: localestr('Поділитися'),
            action: () => {
              canvas.toBlob(blob => {
                if (!blob) return;
                const file = new File([blob], 'print.png', { type: 'image/png' });
                navigator.share({ files: [file], title: 'Чек', text: 'Ділюсь чеком' }).catch(err => console.error('Помилка під час поділу:', err));
              });
            }
          })
          setTimeout(() => this.msg(cont, localestr('Друк'), buttons), tmr)
          tmr += 200;
          //if(d.print_cmd) setTimeout(()=>window.print(),300)
        }
        //});
      }
    }
  };

  compareOrder = (ord, orders, tasks, pause = 1) => {
    const orig = orders.find(el => (String(el.uid) === String(ord.uid) || String(el.id) === String(ord.id)))
    if (!orig) return
    orig.docTable.forEach(origItem => {
      const newItem = ord.docTable.find(it => it.uid === origItem.uid);

      if (!newItem) {
        this.modTask2(orig.uid, orig.id, { ...origItem, act: 'del' }, tasks, pause, 'break');
      } else if (origItem.qtt !== newItem.qtt) {
        this.modTask2(orig.uid, orig.id, { ...newItem }, tasks, pause, 'break');
      }
    });
    let gst = 1
    let oldgst = 0
    ord.docTable.forEach(newItem => {
      const existsInOrig = orig.docTable.find(it => (String(it.uid) === String(newItem.uid) || String(it.id) === String(newItem.id)) || (String(it.uid) === String(newItem.uid) && String(it.id) === String(newItem.id)));
      if (!existsInOrig) {
        //newItem.guest=gst
        newItem.id = null
        newItem.pid = null
        this.modTask2(orig.uid, orig.id,
          { ...newItem, guest: gst, id: null, act: 'add' },
          tasks, pause, 'break');
      } else {
        if (oldgst !== existsInOrig.guest) {
          if (oldgst) gst++
          oldgst = existsInOrig.guest
        }
        if (newItem.guest !== gst) {
          newItem.guest = gst
          this.modTask2(orig.uid, orig.id,
            { ...newItem, guest: gst, act: 'mod' },
            tasks, pause, 'break');
        }
      }
    });
    if (orig.guests !== gst) {
      ord.guests = gst
      let o_idx = tasks.findIndex(el => el.uid === ord.uid)
      let task = { uid: ord.uid, id: ord.id, docTable: [] }
      if (o_idx === -1) o_idx = tasks.length
      else task = { ...tasks[o_idx] }
      task.guests = gst
      tasks[o_idx] = { ...task, timer, status: 0 }
    }
  };

  saveDiscount = (d) => {
    if (!dsc.length) return
    if (d) {
      if (d.status === 'error') return
      else if (d.status === 'OffLine') return
      //удалити з масиву по телефону
      dsc = dsc.filter(el => el.phone !== d.data.phone)
      //оновити список дисконтів
      //зберегти в локальну базу
      //if (d.status==='addNA') return //не потрібно оновлювати
      let newData = this.state.data
      let newDiscounts = []
      if (newData['catDiscounts']) newDiscounts = newData['catDiscounts']
      const idx = newDiscounts.findIndex(el => el.id === d.data.id)
      if (idx === -1) newDiscounts.push(d.data)
      else newDiscounts[idx] = { ...d.data }
      newData['catDiscounts'] = newDiscounts
      this.setState({ data: newData })
      this.setStartDB({ catHalls: newData.catHalls, catMenu: newData.catMenu, fldMenu: newData.fldMenu, catDiscounts: newData.catDiscounts, fldDiscounts: newData.fldDiscounts, catDevices: newData.catDevices, catDepartments: newData.catDepartments, const: newData.const, catReasons: newData.catReasons, catTexts: newData.catTexts, catUsers: newData.catUsers, printers: newData.printers, catCashAccs: newData.catCashAccs, catArticles: newData.catArticles, catCounterparties: newData.catCounterparties, cities: newData.cities })
    } else {
      //взяти перший елемент і відправити на сервер
      load('action=addDiscount&data=' + encodeURIComponent(JSON.stringify(dsc[0])), this.saveDiscount)
    }
  }

  getFiscal = (item, fiscal) => {
    if (fiscal === 2) return '0'
    if (!item) {
      if (fiscal === 0) return '0'
      else return this.state.data.const.constFiscalCard || this.state.data.const.constFiscal
    }
    if (item.fiscal) return '' + item.fiscal
    if (!item.id) {
      if (fiscal === 0) return '0'
      else return this.state.data.const.constFiscalCard || this.state.data.const.constFiscal
    }
    if (!item.parent) {
      if (fiscal === 0) return '0'
      else return this.state.data.const.constFiscalCard || this.state.data.const.constFiscal
    }
    if (!item.parent.id) {
      if (fiscal === 0) return '0'
      else return this.state.data.const.constFiscalCard || this.state.data.const.constFiscal
    }
    const fldrs = this.state.data.fldMenu
    const prnt = fldrs.find(el => el.id === item.parent.id)
    return this.getFiscal(prnt, fiscal)
  }

  getPays = (doc_table, fiscal) => {
    let ttl = 0
    let pays = {}
    let pays_str = []
    for (let i = 0; i < doc_table.length; i++) {
      if (parseInt(doc_table[i].refuse || 0)) continue
      const sum = parseFloat(doc_table[i].amount)
      ttl += sum
      const fisc = this.getFiscal(doc_table[i].menu, fiscal)
      if (pays[fisc]) pays[fisc] += sum
      else pays[fisc] = sum
    }
    const devs = this.state.data.catDevices
    Object.keys(pays).forEach(key => {
      let id = '0'
      let name = localestr('Пусто')
      let terminals = null
      if (key) {
        const dv = devs.find(el => el.id === key)
        if (dv) {
          name = dv?.name
          id = dv.id
          if (dv.terminals && dv.terminals.length) terminals = dv.terminals
        }
      }
      let data = { id, name, sum: pays[key].toFixed(2) }
      if (terminals) data.terminals = terminals
      pays_str.push(data)
    })
    return { pays: pays_str.sort((a, b) => a.id.localeCompare(b.id)), ttl }
  }

  localPrint = (rep_type, data, callback) => {
    let printer_type = 3
    if (rep_type === 1 || rep_type === 6) printer_type = parseInt(data.department.printer.type)
    else printer_type = parseInt(data.printer.type)
    const print = printer_job(rep_type, { ...data })
    if (print) setTimeout(() => callback({ status: 'OKCont_l', printer_type, print: [print] }), 50)
    else load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: rep_type, data: { ...data } })), (d) => { callback(d) })
  }

  modStatus = (order, tasks, status, printTable) => {
    let o_idx = tasks.findIndex(el => el.uid === order.uid)
    let task = { uid: order.uid, id: order.id, docTable: [] }
    if (o_idx === -1) o_idx = tasks.length
    else task = { ...tasks[o_idx] }
    let t_docTable = [...task.docTable]
    let docTable = order.docTable
    let mod = false
    const tod = new Date()
    const now = tod.getHours() * 60 + tod.getMinutes()
    for (let i = 0; i < docTable.length; i++) {
      let tabItem = docTable[i]
      if (printTable && printTable.findIndex(el => el.uid === tabItem.uid) === -1) continue
      if (parseInt(tabItem.status) < status) {
        tabItem.status = status
        if (status === 2) tabItem.start = now
        docTable[i] = tabItem
        let t_idx = t_docTable.findIndex(el => el.uid === tabItem.uid)
        let item = {}
        if (t_idx === -1) t_idx = t_docTable.length
        else item = { ...t_docTable[t_idx] }
        item = { ...item, ...tabItem }
        t_docTable[t_idx] = item
        mod = true
      }
    }
    if (!mod) return
    order.docTable = docTable
    task.docTable = t_docTable
    //tasks[o_idx]={...task,timer,status:0}
    tasks[o_idx] = { ...task, timer: 0, status: 0 }
  }

  exist_in_jobs = (doc_uid, doc_id, tbl_uid, tbl_id) => {
    const jobs = this.state.jobPrint
    let o_idx = -1
    if (doc_id) o_idx = jobs.findIndex(el => el.id === doc_id)
    else o_idx = jobs.findIndex(el => el.uid === doc_uid)
    if (o_idx === -1) return
    let docTable = [...jobs[o_idx].docTable]
    let t_idx = -1
    if (tbl_id) t_idx = docTable.findIndex(el => parseInt(el.id) === parseInt(tbl_id))
    else t_idx = docTable.findIndex(el => el.uid === tbl_uid)
    if (t_idx === -1) return
    return true
  }

  modOrder = async (idx, cmd, data) => {
    if (idx >= this.state.windows.length) return
    let order = this.state.windows[idx].data
    let disc = 0
    let disc_mode = 0
    let disc_type = 0
    if (order.discount) { disc = order.discount.prc; disc_mode = order.discount.mode || 0; disc_type = order.discount.type || 0 }
    let tasks = this.state.tasks
    let jobPrint = [...this.state.jobPrint]
    let stoplist = this.state.stoplist || []

    if (busy) {
      setTimeout(() => this.modOrder(idx, cmd, data), 100)
      busy = false
      return
    }

    //if(cmd!=='parent'&&cmd!=='curent') Logger.log(cmd, order,  {idx, data},   'modOrder початок')

    if (cmd === 'parent') order.parent = data
    else if (cmd === 'curent') order.curent = data
    else if (cmd === 'add') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      let indx = -1 //docTable.findIndex(el=>el.menu.id===data.id&&el.status==='0'&&parseInt(el.refuse)!==1)
      if (data.barcode) indx = docTable.findIndex(el => el.menu.id === data.id && parseInt(el.status) < 2 && parseInt(el.refuse) !== 1 && !el.modifiers && el.guest === order.guest)
      let tabItem = {}
      if (indx === -1) {
        let nom = 0
        if (this.state.data.const.constQuePrint) {
          nom = 1
          if (docTable[order.curent || 0]) nom = docTable[order.curent || 0].nom
        }
        if (data.disable_discount || disc_type) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat(data.price || 0).toFixed(2), status: '1', nom }
        else if (disc && disc_mode) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat((data.price || 0) * (100 - disc) / 100).toFixed(2), status: '1', nom }
        else if (disc) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat((data.price || 0) * (100 - disc) / 100).toFixed(2), discount: parseFloat(data.price * (disc) / 100).toFixed(2), status: '1', nom }
        else tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat(data.price || 0).toFixed(2), status: '1', nom }
        //tabItem.guest=order.guests
        tabItem.guest = 1
        if (order.guest) tabItem.guest = order.guest
        tabItem.need_focus = true
        if (docTable[order.curent || 0]) tabItem.guest = docTable[order.curent || 0].guest
        else if (docTable[docTable.length - 1] && docTable[docTable.length - 1].guest > tabItem.guest) tabItem.guest = docTable[docTable.length - 1].guest
        docTable.push(tabItem)
        tasks = this.modTask(order.uid, order.id, tabItem)
        docTable.sort((a, b) => {
          if (a.guest > b.guest) return 1
          if (a.guest < b.guest) return -1
          if (a.nom > b.nom) return 1
          if (a.nom < b.nom) return -1
          if (a.uid > b.uid) return 1
          if (a.uid < b.uid) return -1
          return 0
        })
        order.curent = docTable.findIndex(el => el.need_focus)
        if (order.curent !== -1) delete docTable[order.curent].need_focus

        if (data.ex_good5) this.modOrder(idx, 'ex_mark5_auto', '')
        if (data.ex_good4) this.modOrder(idx, 'ex_mark4_auto', '')
        if (data.ex_good3) this.modOrder(idx, 'ex_mark3_auto', '')
        if (data.ex_good2) this.modOrder(idx, 'ex_mark2_auto', '')
        if (data.ex_good1) this.modOrder(idx, 'ex_mark1_auto', '')
        if (!parseFloat(data.price || 0)) this.modOrder(idx, 'price', '')
        if (data.modifiers && data.modifiers.length && !parseInt(this.state.rights.urNoModifiers||0)) this.modOrder(idx, 'modifiers', '')
        if (data.qtt) this.modOrder(idx, 'setqtt', parseFloat(data.qtt || 0))
      } else {
        tabItem = docTable[indx]
        //перевірити що по акцизках, за потреби зробити новим рядком
        let need_new_row = false
        let marks = this.state.marks || []
        const is_liter = tabItem.menu.ex_good1.unit === 3 ? 1 : 0
        if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
          if (tabItem.mark1) {
            let need_qtt = (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu.ex_good1.qtt || 0)) * 10000
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark1)
            if (idx_ !== -1) {
              if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol
              if (marks[idx_].qtt + need_qtt > 10000) need_new_row = true
            }
          }
          if (tabItem.mark2) {
            let need_qtt = (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu.ex_good2.qtt || 0)) * 10000
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark2)
            if (idx_ !== -1) {
              if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol
              if (marks[idx_].qtt + need_qtt > 10000) need_new_row = true
            }
          }
          if (tabItem.mark3) {
            let need_qtt = (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu.ex_good3.qtt || 0)) * 10000
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark3)
            if (idx_ !== -1) {
              if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol
              if (marks[idx_].qtt + need_qtt > 10000) need_new_row = true
            }
          }
          if (tabItem.mark4) {
            let need_qtt = (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu.ex_good4.qtt || 0)) * 10000
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark4)
            if (idx_ !== -1) {
              if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol
              if (marks[idx_].qtt + need_qtt > 10000) need_new_row = true
            }
          }
          if (tabItem.mark5) {
            let need_qtt = (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu.ex_good5.qtt || 0)) * 10000
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark5)
            if (idx_ !== -1) {
              if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol
              if (marks[idx_].qtt + need_qtt > 10000) need_new_row = true
            }
          }
        }
        if (need_new_row) {
          let nom = 0
          if (this.state.data.const.constQuePrint) {
            nom = 1
            if (docTable[order.curent || 0]) nom = docTable[order.curent || 0].nom
          }
          let price_delta = 0
          if (tabItem.modifiers) tabItem.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
          let price = (parseFloat(data.price) || 0) + price_delta
          if (data.disable_discount || disc_type) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: price.toFixed(2), status: '1', nom }
          else if (disc && disc_mode) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat(price * (100 - disc) / 100).toFixed(2), status: '1', nom }
          else if (disc) tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: parseFloat(price * (100 - disc) / 100).toFixed(2), discount: parseFloat(data.price * (disc) / 100).toFixed(2), status: '1', nom }
          else tabItem = { uid: uid(), act: 'add', menu: data, qtt: 1, amount: price.toFixed(2), status: '1', nom }
          tabItem.guest = 1
          if (order.guest) tabItem.guest = order.guest
          if (docTable[order.curent || 0]) tabItem.guest = docTable[order.curent || 0].guest
          else if (docTable[docTable.length - 1] && docTable[docTable.length - 1].guest > tabItem.guest) tabItem.guest = docTable[docTable.length - 1].guest
          docTable.push(tabItem)
          tasks = this.modTask(order.uid, order.id, tabItem)
          order.curent = docTable.length - 1
          if (data.ex_good5) this.modOrder(idx, 'ex_mark5_auto', '')
          if (data.ex_good4) this.modOrder(idx, 'ex_mark4_auto', '')
          if (data.ex_good3) this.modOrder(idx, 'ex_mark3_auto', '')
          if (data.ex_good2) this.modOrder(idx, 'ex_mark2_auto', '')
          if (data.ex_good1) this.modOrder(idx, 'ex_mark1_auto', '')
        }
        else {
          tabItem.qtt = parseFloat(tabItem.qtt) + 1
          let newAmount = tabItem.qtt * (parseFloat(data.price) || 0) * (100 - disc) / 100
          if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * (parseFloat(data.price) || 0) * (disc) / 100).toFixed(2)
          if (tabItem.menu?.disable_discount || disc_type) {
            newAmount = tabItem.qtt * (parseFloat(tabItem.menu?.price) || 0)
            tabItem.discount = 0
          }
          tabItem.amount = newAmount.toFixed(2)
          if (tabItem.mark1) {
            let need_vol = 1
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark1)
            if (idx_ !== -1) if (is_liter) need_vol = 1000 / marks[idx_].vol
            this.modMarks(order.uid, order.id, tabItem.mark1, tabItem.menu.ex_good1.good, parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good1.qtt || 0)) * 10000 * need_vol)
            tabItem.qtt1 = parseFloat(tabItem.qtt || 1) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good1.qtt || 0)) * 10000 * need_vol
          }
          if (tabItem.mark2) {
            let need_vol = 1
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark2)
            if (idx_ !== -1) if (is_liter) need_vol = 1000 / marks[idx_].vol
            this.modMarks(order.uid, order.id, tabItem.mark2, tabItem.menu.ex_good2.good, parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good2.qtt || 0)) * 10000 * need_vol)
            tabItem.qtt2 = parseFloat(tabItem.qtt || 1) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good2.qtt || 0)) * 10000 * need_vol
          }
          if (tabItem.mark3) {
            let need_vol = 1
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark3)
            if (idx_ !== -1) if (is_liter) need_vol = 1000 / marks[idx_].vol
            this.modMarks(order.uid, order.id, tabItem.mark3, tabItem.menu.ex_good3.good, parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good3.qtt || 0)) * 10000 * need_vol)
            tabItem.qtt3 = parseFloat(tabItem.qtt || 1) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good3.qtt || 0)) * 10000 * need_vol
          }
          if (tabItem.mark4) {
            let need_vol = 1
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark4)
            if (idx_ !== -1) if (is_liter) need_vol = 1000 / marks[idx_].vol
            this.modMarks(order.uid, order.id, tabItem.mark4, tabItem.menu.ex_good4.good, parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good4.qtt || 0)) * 10000 * need_vol)
            tabItem.qtt4 = parseFloat(tabItem.qtt || 1) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good4.qtt || 0)) * 10000 * need_vol
          }
          if (tabItem.mark5) {
            let need_vol = 1
            let idx_ = -1
            idx_ = marks.findIndex(el => el.code === tabItem.mark5)
            if (idx_ !== -1) if (is_liter) need_vol = 1000 / marks[idx_].vol
            this.modMarks(order.uid, order.id, tabItem.mark5, tabItem.menu.ex_good5.good, parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good5.qtt || 0)) * 10000 * need_vol)
            tabItem.qtt5 = parseFloat(tabItem.qtt || 1) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good5.qtt || 0)) * 10000 * need_vol
          }
          docTable[indx] = tabItem
          tasks = this.modTask(order.uid, order.id, tabItem)
          order.curent = indx
        }
      }
      //упаковка
      if ((data.package && order.docType !== 0 && order.docType !== 3)) {
        const indx = docTable.findIndex(el => el.menu.id === data.package && el.status === '1' && parseInt(el.refuse) !== 1)
        if (indx === -1 || data.dont_group) {
          let tabItem = {}
          let nom = 0
          if (this.state.data.const.constQuePrint) {
            nom = 1
            //docTable.forEach(el=>{if(el.nom&&el.nom>nom) nom=el.nom})
            if (docTable[order.curent || 0]) nom = docTable[order.curent || 0].nom
          }
          const datap = this.state.data.catMenu.find(el => el.id === data.package)
          if (datap) {
            if (datap.disable_discount || disc_type) tabItem = { uid: uid(1), act: 'add', menu: datap, qtt: 1, amount: parseFloat(datap.price || 0).toFixed(2), status: '1', nom }
            else if (disc && disc_mode) tabItem = { uid: uid(1), act: 'add', menu: datap, qtt: 1, amount: parseFloat((datap.price || 0) * (100 - disc) / 100).toFixed(2), status: '1', nom }
            else if (disc) tabItem = { uid: uid(1), act: 'add', menu: datap, qtt: 1, amount: parseFloat((datap.price || 0) * (100 - disc) / 100).toFixed(2), discount: parseFloat(datap.price * (disc) / 100).toFixed(2), status: '1', nom }
            else tabItem = { uid: uid(1), act: 'add', menu: datap, qtt: 1, amount: parseFloat(datap.price || 0).toFixed(2), status: '1', nom }
            tabItem.guest = 1
            if (order.guest) tabItem.guest = order.guest
            if (docTable[order.curent || 0]) tabItem.guest = docTable[order.curent || 0].guest
            else if (docTable[docTable.length - 1] && docTable[docTable.length - 1].guest > tabItem.guest) tabItem.guest = docTable[docTable.length - 1].guest
            docTable.push(tabItem)
            tasks = this.modTask(order.uid, order.id, tabItem)
            docTable.sort((a, b) => {
              if (a.guest > b.guest) return 1
              if (a.guest < b.guest) return -1
              if (a.nom > b.nom) return 1
              if (a.nom < b.nom) return -1
              if (a.uid > b.uid) return 1
              if (a.uid < b.uid) return -1
              return 0
            })
          }
        } else {
          tabItem = { ...docTable[indx] }
          tabItem.qtt = parseFloat(tabItem.qtt) + 1
          let newAmount = tabItem.qtt * (parseFloat(tabItem.menu?.price) || 0) * (100 - disc) / 100
          if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * (parseFloat(tabItem.menu?.price) || 0) * (disc) / 100).toFixed(2)
          if (tabItem.menu?.disable_discount || disc_type) {
            newAmount = tabItem.qtt * (parseFloat(tabItem.menu?.price) || 0)
            tabItem.discount = 0
          }
          tabItem.amount = newAmount.toFixed(2)
          if (!tabItem.id) {  //переміщення в кінець списку
            this.modTask2(order.uid, order.id, { ...tabItem, act: 'del' }, tasks)
            tabItem.uid = uid(1)
            docTable.splice(indx, 1)
            docTable.push(tabItem)
            order.curent--
          } else docTable[indx] = tabItem

          this.modTask2(order.uid, order.id, tabItem, tasks)
          //tasks=this.modTask(order.uid,order.id,tabItem)
          //order.curent=indx
        }
      }
      //стоп-лист
      const stop_idx = stoplist.findIndex(el => el.good === data.id)
      if (stop_idx !== -1) {
        stoplist[stop_idx].qtt--
      }
      order.docTable = docTable
      order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
      order.status = 0
    } else if (cmd === 'add_arr') {
      let btns = data.map(el => ({ caption: (el.parent ? (el.parent?.name || '') + ' / ' : '') + (el?.name), action: () => this.modOrder(idx, 'add', { ...el }) }))
      this.msg_arr(localestr('Виберіть товар'), '', btns)
    } else if (cmd === 'setqtt') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (docTable[order.curent].id && !docTable[order.curent].menu) {
        let task = { ...docTable[order.curent], act: 'del' }
        //delete task.menu
        //delete task.qtt
        //delete task.amount
        //delete task.status
        delete task.discount
        delete task.comment
        delete task.refuse
        delete task.pid
        delete task.excise_mark
        delete task.nom
        delete task.guest
        tasks = this.modTask(order.uid, order.id, task)
        docTable.splice(order.curent, 1)
        order.curent--
        if (order.curent < 0) order.curent = 0
        if (docTable.length < order.curent) order.curent = docTable.length
      } else {
        if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
        if (this.exist_in_jobs(order.uid, order.id, docTable[order.curent].uid, docTable[order.curent].id) && parseInt(this.state.rights.urAdmin) === 0) return
        //if(parseInt(docTable[order.curent].status)>1) return
        //if(this.exist_in_jobs(order.uid,order.id,docTable[order.curent].uid,docTable[order.curent].id)) return

        //стоп-лист
        const old_qtt = parseFloat(docTable[order.curent].qtt || 0)
        const old_menu = docTable[order.curent].menu || { id: null }
        const stop_idx = stoplist.findIndex(el => el.good === old_menu.id)
        if (stop_idx !== -1 && parseInt(docTable[order.curent].status) === 1) {
          if (stoplist[stop_idx].qtt < parseFloat(data) - old_qtt && parseFloat(data) > old_qtt) return
          stoplist[stop_idx].qtt -= parseFloat(data) - old_qtt
        }

        if (data === 0) {
          let task = { ...docTable[order.curent], act: 'del' }
          //if(task.mark1) this.modMarks(order.uid,order.id,task.mark1,task.menu.ex_good1.good,-parseFloat(task.qtt)*parseFloat(task.menu.koef||1)*(parseFloat(task.menu.ex_good1.qtt||0))*10000)
          //if(task.mark2) this.modMarks(order.uid,order.id,task.mark2,task.menu.ex_good2.good,-parseFloat(task.qtt)*parseFloat(task.menu.koef||1)*(parseFloat(task.menu.ex_good2.qtt||0))*10000)
          //if(task.mark3) this.modMarks(order.uid,order.id,task.mark3,task.menu.ex_good3.good,-parseFloat(task.qtt)*parseFloat(task.menu.koef||1)*(parseFloat(task.menu.ex_good3.qtt||0))*10000)
          //if(task.mark4) this.modMarks(order.uid,order.id,task.mark4,task.menu.ex_good4.good,-parseFloat(task.qtt)*parseFloat(task.menu.koef||1)*(parseFloat(task.menu.ex_good4.qtt||0))*10000)
          //if(task.mark5) this.modMarks(order.uid,order.id,task.mark5,task.menu.ex_good5.good,-parseFloat(task.qtt)*parseFloat(task.menu.koef||1)*(parseFloat(task.menu.ex_good5.qtt||0))*10000)
          if (task.mark1) this.modMarks(order.uid, order.id, task.mark1, task.menu.ex_good1.good, -parseInt(task.qtt1))
          if (task.mark2) this.modMarks(order.uid, order.id, task.mark2, task.menu.ex_good2.good, -parseInt(task.qtt2))
          if (task.mark3) this.modMarks(order.uid, order.id, task.mark3, task.menu.ex_good3.good, -parseInt(task.qtt3))
          if (task.mark4) this.modMarks(order.uid, order.id, task.mark4, task.menu.ex_good4.good, -parseInt(task.qtt4))
          if (task.mark5) this.modMarks(order.uid, order.id, task.mark5, task.menu.ex_good5.good, -parseInt(task.qtt5))
          delete task.menu
          delete task.qtt
          delete task.amount
          delete task.status
          delete task.discount
          delete task.comment
          delete task.refuse
          delete task.pid
          delete task.excise_mark
          delete task.nom
          delete task.guest
          tasks = this.modTask(order.uid, order.id, task)
          docTable.splice(order.curent, 1)
          order.curent--
          if (order.curent < 0) order.curent = 0
          if (docTable.length < order.curent) order.curent = docTable.length
        } else {
          let tabItem = { ...docTable[order.curent] }
          //--акцизні марки--
          /* якщо кількість більше чим можна по акц марці тоді повідомлення */
          if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
            if (tabItem.mark1) {
              let marks = this.state.marks || []
              let per_unit = parseFloat(tabItem.menu.koef || 1) * parseFloat(tabItem.menu.ex_good1.qtt || 0) * 10000
              const is_liter = tabItem.menu.ex_good1.unit === 3 ? 1 : 0
              let need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit
              if (is_liter && tabItem.qtt) need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * parseInt(tabItem.qtt1 || 0) / parseFloat(tabItem.qtt || 1) //Приблизно
              const idx_ = marks.findIndex(el => el.code === tabItem.mark1)
              if (idx_ !== -1) {
                if (is_liter) need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit * 1000 / marks[idx_].vol //Точно
                if (marks[idx_].qtt + need_qtt > 10000) {
                  this.msg(localestr('Перерозхід по акцизній марці!'))
                  return
                }
              }
              this.modMarks(order.uid, order.id, tabItem.mark1, tabItem.menu.ex_good1.good, need_qtt)
              tabItem.qtt1 = parseInt(tabItem.qtt1) + need_qtt
            }
            if (tabItem.mark2) {
              let marks = this.state.marks || []
              let per_unit = parseFloat(tabItem.menu.koef || 1) * parseFloat(tabItem.menu.ex_good2.qtt || 0) * 10000
              const is_liter = tabItem.menu.ex_good2.unit === 3 ? 1 : 0
              let need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit
              if (is_liter && tabItem.qtt) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * parseInt(tabItem.qtt2 || 0) / parseFloat(tabItem.qtt || 1) //Приблизно
              const idx_ = marks.findIndex(el => el.code === tabItem.mark2)
              if (idx_ !== -1) {
                if (is_liter) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * per_unit * 1000 / marks[idx_].vol //Точно
                if (marks[idx_].qtt + need_qtt > 10000) {
                  this.msg(localestr('Перерозхід по акцизній марці!'))
                  return
                }
              }
              this.modMarks(order.uid, order.id, tabItem.mark2, tabItem.menu.ex_good2.good, need_qtt)
              tabItem.qtt2 = parseInt(tabItem.qtt2) + need_qtt
            }
            if (tabItem.mark3) {
              let marks = this.state.marks || []
              let per_unit = parseFloat(tabItem.menu.koef || 1) * parseFloat(tabItem.menu.ex_good3.qtt || 0) * 10000
              const is_liter = tabItem.menu.ex_good3.unit === 3 ? 1 : 0
              let need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit
              if (is_liter && tabItem.qtt) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * parseInt(tabItem.qtt3 || 0) / parseFloat(tabItem.qtt || 1) //Приблизно
              const idx_ = marks.findIndex(el => el.code === tabItem.mark3)
              if (idx_ !== -1) {
                if (is_liter) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * per_unit * 1000 / marks[idx_].vol //Точно
                if (marks[idx_].qtt + need_qtt > 10000) {
                  this.msg(localestr('Перерозхід по акцизній марці!'))
                  return
                }
              }
              this.modMarks(order.uid, order.id, tabItem.mark3, tabItem.menu.ex_good3.good, need_qtt)
              tabItem.qtt3 = parseInt(tabItem.qtt3) + need_qtt
            }
            if (tabItem.mark4) {
              let marks = this.state.marks || []
              let per_unit = parseFloat(tabItem.menu.koef || 1) * parseFloat(tabItem.menu.ex_good4.qtt || 0) * 10000
              const is_liter = tabItem.menu.ex_good4.unit === 3 ? 1 : 0
              let need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit
              if (is_liter && tabItem.qtt) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * parseInt(tabItem.qtt4 || 0) / parseFloat(tabItem.qtt || 1) //Приблизно
              const idx_ = marks.findIndex(el => el.code === tabItem.mark4)
              if (idx_ !== -1) {
                if (is_liter) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * per_unit * 1000 / marks[idx_].vol //Точно
                if (marks[idx_].qtt + need_qtt > 10000) {
                  this.msg(localestr('Перерозхід по акцизній марці!'))
                  return
                }
              }
              this.modMarks(order.uid, order.id, tabItem.mark4, tabItem.menu.ex_good4.good, need_qtt)
              tabItem.qtt4 = parseInt(tabItem.qtt4) + need_qtt
            }
            if (tabItem.mark5) {
              let marks = this.state.marks || []
              let per_unit = parseFloat(tabItem.menu.koef || 1) * parseFloat(tabItem.menu.ex_good5.qtt || 0) * 10000
              const is_liter = tabItem.menu.ex_good5.unit === 3 ? 1 : 0
              let need_qtt = ((data || 0) - parseFloat(tabItem.qtt || 0)) * per_unit
              if (is_liter && tabItem.qtt) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * parseInt(tabItem.qtt5 || 0) / parseFloat(tabItem.qtt || 1) //Приблизно
              const idx_ = marks.findIndex(el => el.code === tabItem.mark5)
              if (idx_ !== -1) {
                if (is_liter) need_qtt = ((data || 0) - (tabItem.qtt || 0)) * per_unit * 1000 / marks[idx_].vol //Точно
                if (marks[idx_].qtt + need_qtt > 10000) {
                  this.msg(localestr('Перерозхід по акцизній марці!'))
                  return
                }
              }
              this.modMarks(order.uid, order.id, tabItem.mark5, tabItem.menu.ex_good5.good, need_qtt)
              tabItem.qtt5 = parseInt(tabItem.qtt5) + need_qtt
            }
          }
          let price_delta = 0
          if (tabItem.modifiers) tabItem.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
          let price = (parseFloat(tabItem.menu?.price) || 0) + price_delta
          if (!price) price = ((parseFloat(tabItem.amount) || 0) + parseFloat(tabItem.discount || 0)) / (tabItem.qtt || 1)
          tabItem.qtt = data
          let newAmount = tabItem.qtt * price * (100 - disc) / 100 //тут ще може бути знижка
          if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * price * (disc) / 100).toFixed(2)
          if (tabItem.menu?.disable_discount || disc_type) {
            newAmount = tabItem.qtt * price
            tabItem.discount = 0
          }
          tabItem.amount = newAmount.toFixed(2)
          if (parseInt(tabItem.status) < 1) tabItem.status = '1'
          docTable[order.curent] = tabItem
          tasks = this.modTask(order.uid, order.id, tabItem)
        }
        //parseFloat(data)-old_qtt
        //Тут доробити зміну упаковок

      }
      order.docTable = docTable
      if (!docTable.length) order.guest = 1
      order.sum = docTable.reduce((sum, el) => parseInt(el.refuse || 0) ? sum : sum + parseFloat(el.amount || 0), 0)
    } else if (cmd === 'setqtt2') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(docTable[order.curent].status) > 1 && parseInt(docTable[order.curent].status) < 5 && parseInt(this.state.rights.urAdmin) === 0 && parseInt(docTable[order.curent]?.menu?.gravimetric || 0) === 0) return
      if (parseInt(docTable[order.curent].status) > 2 && parseInt(this.state.rights.urAdmin) === 0) return
      if (this.exist_in_jobs(order.uid, order.id, docTable[order.curent].uid, docTable[order.curent].id) && parseInt(this.state.rights.urAdmin) === 0) return
      if (data === 0) return
      let tabItem = docTable[order.curent]
      if (tabItem.menu.mark1) {
        this.modMarks(order.uid, order.id, tabItem.mark1, tabItem.menu.ex_good1.good, (parseFloat(data) - parseFloat(tabItem.qtt)) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good1.qtt || 0)) * 10000)
        tabItem.qtt1 = parseFloat(data) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good1.qtt || 0)) * 10000
      }
      if (tabItem.menu.mark2) {
        this.modMarks(order.uid, order.id, tabItem.mark2, tabItem.menu.ex_good2.good, (parseFloat(data) - parseFloat(tabItem.qtt)) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good2.qtt || 0)) * 10000)
        tabItem.qtt2 = parseFloat(data) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good2.qtt || 0)) * 10000
      }
      if (tabItem.menu.mark3) {
        this.modMarks(order.uid, order.id, tabItem.mark3, tabItem.menu.ex_good3.good, (parseFloat(data) - parseFloat(tabItem.qtt)) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good3.qtt || 0)) * 10000)
        tabItem.qtt3 = parseFloat(data) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good3.qtt || 0)) * 10000
      }
      if (tabItem.menu.mark4) {
        this.modMarks(order.uid, order.id, tabItem.mark4, tabItem.menu.ex_good4.good, (parseFloat(data) - parseFloat(tabItem.qtt)) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good4.qtt || 0)) * 10000)
        tabItem.qtt4 = parseFloat(data) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good4.qtt || 0)) * 10000
      }
      if (tabItem.menu.mark5) {
        this.modMarks(order.uid, order.id, tabItem.mark5, tabItem.menu.ex_good5.good, (parseFloat(data) - parseFloat(tabItem.qtt)) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good5.qtt || 0)) * 10000)
        tabItem.qtt5 = parseFloat(data) * parseFloat(tabItem.menu.koef || 1) * (parseFloat(tabItem.menu.ex_good5.qtt || 0)) * 10000
      }
      let price_delta = 0
      if (tabItem.modifiers) tabItem.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
      let price = (parseFloat(tabItem.menu?.price) || 0) + price_delta
      if (!price) price = ((parseFloat(tabItem.amount) || 0) + parseFloat(tabItem.discount || 0)) / (tabItem.qtt || 1)
      tabItem.qtt = data
      let newAmount = tabItem.qtt * price * (100 - disc) / 100 //тут ще може бути знижка
      if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * price * (disc) / 100).toFixed(2)
      if (tabItem.menu?.disable_discount || disc_type) {
        newAmount = tabItem.qtt * price
        tabItem.discount = 0
      }
      tabItem.amount = newAmount.toFixed(2)
      docTable[order.curent] = tabItem
      tasks = this.modTask(order.uid, order.id, tabItem)
      order.docTable = docTable
      order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
      //потім друкувати
      if (parseInt(this.state.data.const.constChangePrint) === 1) { //друкувати
        setTimeout(() => this.modOrder(idx, 'change_print', null), 200)
      } else if (parseInt(this.state.data.const.constChangePrint) === 2) {
        this.msg(localestr('Друкувати повідомлення?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => this.modOrder(idx, 'change_print', null) },
          { caption: localestr('Ні'), action: () => { } }
        ])
      }
    } else if (cmd === 'change_print') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          return
        }
        else if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            let timer_ = 1
            data.print.forEach(d => {
              if (d.type === 'svg') setTimeout(() => print_rawbt(d), timer_)
              timer_ += 500
            })
          }
          else this.printData(data)

        }
        // const audio = new Audio()
        // audio.preload = 'auto'
        // audio.src = sound1
        // audio.play()
        playSound(this.state.soundMode, sound1);
      } else {
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1 && this.state.status !== 'OffLine') {
          if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          else setTimeout(() => { this.modOrder(idx, cmd, data) }, 200)
          return
        }
        //потім друкувати
        const catHalls = this.state.data['catHalls']
        const catDepartments = this.state.data['catDepartments'] || []
        let docHeader = { ...order }
        delete docHeader.del
        delete docHeader.discount
        delete docHeader.sum
        //delete docHeader.uid
        delete docHeader.news
        delete docHeader.parent
        delete docHeader.curent
        delete docHeader.docTable
        //if(docHeader.author && docHeader.author.fio) docHeader.author=docHeader.author.fio
        if (docHeader.author) docHeader.author = docHeader.author.fio || docHeader.author?.name || ''
        const tbl = docHeader.table
        const hall = catHalls.find(el => tbl && el.id === tbl.owner.id)
        docHeader.hall = hall ? hall?.name : ''
        delete docHeader.table
        docHeader.table = tbl ? tbl?.name : ''
        if (docHeader.docType && parseInt(docHeader.docType) === 1) {
          docHeader.hall = localestr('Доставка')
          docHeader.table = '~' + (docHeader.phone || '').substring(5)
        }
        let department = undefined
        let docTable = order.docTable
        if (docTable.length <= order.curent) return
        if (order.curent === undefined) return
        if (order.curent === -1) return
        //if(parseInt(this.state.rights.urReject)===0&&parseInt(this.state.rights.urAdmin)===0) return
        let tabItem = { uid: docTable[order.curent].uid, id: docTable[order.curent].id, menu: docTable[order.curent].menu?.name, comment: docTable[order.curent].comment, qtt: '' + parseFloat(docTable[order.curent].qtt) }
        const last_dep = docTable[order.curent].menu.department_id
        if (!last_dep) {
          return
        }
        department = catDepartments.find(el => el.id === last_dep)
        const print = { department_id: last_dep, department: { ...department }, ...docHeader, docTable: [tabItem] }
        if (department && department.printer && department.printer.type > 1 && department.printer.templates) this.localPrint(7, print, (d) => { this.modOrder(idx, cmd, d) })
        else load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 7, data: print })), (d) => { this.modOrder(idx, cmd, d) })
      }
      return
    } else if (cmd === 'calc') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      //if(parseInt(docTable[order.curent].status)!==0&&parseInt(this.state.rights.urAdmin)===0) return
      if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0 && parseInt(docTable[order.curent]?.menu?.gravimetric || 0) === 0) return
      if (parseInt(docTable[order.curent].status) > 2 && parseInt(this.state.rights.urAdmin) === 0) return
      let qtt = parseFloat(docTable[order.curent].qtt) || 0
      if (parseInt(docTable[order.curent]?.menu?.gravimetric || 0) === 0) {
        const modal = <Calc value={qtt} caption={localestr('Кількість')} setValue={(val) => { this.modOrder(idx, 'setqtt', val) }} setModal={this.setModal} />
        this.setState({ modal })
      } else {
        const modal = <Calc value={qtt} caption={localestr('Кількість')} setValue={(val) => { this.modOrder(idx, 'setqtt2', val) }} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'setprice') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(parseFloat(docTable[order.curent].menu?.price)) && parseInt(this.state.rights.urAdmin) === 0) return
      if (this.exist_in_jobs(order.uid, order.id, docTable[order.curent].uid, docTable[order.curent].id) && parseInt(this.state.rights.urAdmin) === 0) return
      if (data === 0) return
      let tabItem = docTable[order.curent]
      //tabItem.qtt=data
      let newAmount = tabItem.qtt * (data || 0) * (100 - disc) / 100 //тут ще може бути знижка
      if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * (data || 0) * (disc) / 100).toFixed(2)
      if (tabItem.menu?.disable_discount || disc_type) {
        newAmount = tabItem.qtt * (data || 0)
        tabItem.discount = 0
      }
      tabItem.amount = newAmount.toFixed(2)
      docTable[order.curent] = tabItem
      tasks = this.modTask(order.uid, order.id, tabItem)
      order.docTable = docTable
      order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)

    } else if (cmd === 'price') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(parseFloat(docTable[order.curent].menu?.price)) && parseInt(this.state.rights.urAdmin) === 0) return
      const qtt = parseFloat(docTable[order.curent].qtt) || 1
      const amount = parseFloat(docTable[order.curent].amount) || 0
      const price = parseInt(amount * 100 / qtt) / 100
      const modal = <Calc value={price} caption={localestr('Ціна')} text={localestr('Введіть ціну')} setValue={(val) => { this.modOrder(idx, 'setprice', val) }} setModal={this.setModal} />
      this.setState({ modal })
    } else if (cmd === 'coment') {
      if (data) {
        let docTable = order.docTable
        if (docTable.length <= order.curent) return
        if (order.curent === undefined) return
        if (order.curent === -1) return
        if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
        let tabItem = docTable[order.curent]
        tabItem.comment = data === '-1' ? '' : data
        docTable[order.curent] = tabItem
        tasks = this.modTask(order.uid, order.id, tabItem)
      } else {
        if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
          this.msg(localestr('Чуже замовлення не можна редагувати!'))
          return
        }
        let docTable = order.docTable
        if (docTable.length <= order.curent) return
        if (order.curent === undefined) return
        if (order.curent === -1) return
        if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
        let comment = docTable[order.curent].comment || ''
        const modal = <Keybord value={comment} setValue={(val) => { this.modOrder(idx, 'coment', val) }} setModal={this.setModal} catTexts={this.state.data.catTexts} />
        this.setState({ modal })
      }
    } else if (cmd === 'kitchen') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          jobPrint = this.state.jobPrint.filter((el, idx) => idx !== data.index)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          jobPrint = this.state.jobPrint.filter((el, idx) => idx !== data.index)
          this.setState({ jobPrint })
          return
        }
        else if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            //let timer_=1
            for (let i = 0; i < data.print.length; i++) {
              if (data.print[i].type === 'svg') {
                await print_rawbt(data.print[i])
                await new Promise(resolve => setTimeout(resolve, 3000))
              }
            }
          }
          else this.printData(data)
          const job = this.state.jobPrint.find((el) => el.idx === data.index) || { docTable: [] }
          if (status === 'OKCont') this.modStatus(order, [], 2, job.docTable)
          else this.modStatus(order, tasks, 2, job.docTable)
          jobPrint = this.state.jobPrint.filter((el) => el.idx !== data.index)
          //this.setState({jobPrint})
        }
        else if (status === 'NotPrintable') {
          //this.loadData({status:'OK',data:[]},'getPrintJobs')
          const job = this.state.jobPrint.find((el) => el.idx === data.index) || { docTable: [] }
          this.modStatus(order, tasks, 2, job.docTable)
          jobPrint = this.state.jobPrint.filter((el) => el.idx !== data.index)
          //this.setState({jobPrint})
        }
        else if (data.id) {
          //this.loadData({status:'OK',data:[]},'getPrintJobs') //Перероблено, одразу красити
          const job = this.state.jobPrint.find((el) => el.idx === data.index) || { docTable: [] }
          if (status === 'OKJob') this.modStatus(order, [], 2, job.docTable)
          else this.modStatus(order, tasks, 2, job.docTable)
          jobPrint = this.state.jobPrint.filter((el) => el.idx !== data.index)
          //this.setState({jobPrint})
        }
        if (data.last_upd) order.last_upd = data.last_upd
        // const audio = new Audio()
        // audio.preload = 'auto'
        // audio.src = sound1
        // audio.play()
        playSound(this.state.soundMode, sound1);
      } else {
        if (this.state.status === 'OffLine') {
          timer = 5
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          return
        }
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1 && this.state.status !== 'OffLine') {
          if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          else setTimeout(() => { this.modOrder(idx, cmd, data) }, 300)
          //tasks[taskidx].sended=false
          return
        }
        //потім друкувати
        const catHalls = this.state.data['catHalls']
        const catDepartments = this.state.data['catDepartments'] || []
        let docHeader = { ...order }
        delete docHeader.del
        delete docHeader.discount
        delete docHeader.sum
        //delete docHeader.uid
        delete docHeader.news
        delete docHeader.parent
        delete docHeader.curent
        delete docHeader.docTable
        if (docHeader.author) docHeader.author = docHeader.author.fio || docHeader.author?.name || ''
        const tbl = docHeader.table
        const hall = catHalls.find(el => tbl && tbl.owner && el.id === tbl.owner.id)
        docHeader.hall = hall ? hall?.name : ''
        delete docHeader.table
        docHeader.table = tbl ? tbl?.name : ''
        if (docHeader.docType && parseInt(docHeader.docType) === 1) {
          docHeader.hall = localestr('Доставка')
          docHeader.table = '~' + (docHeader.phone || '').substring(5)
        }
        else if (docHeader.docType && parseInt(docHeader.docType) === 2) {
          docHeader.hall = localestr('Самовивіз')
          docHeader.table = '~' + (docHeader.phone || '').substring(5)
        }
        let prints = [...this.state.jobPrint]
        let docTable = order.docTable.filter(el => parseInt(el.status) === 1)
        docTable = docTable.sort((el1, el2) => (parseInt(el1.menu.department_id) - parseInt(el2.menu.department_id)) || (parseInt(el1.nom) - parseInt(el2.nom)))
        //Перевіримо чи треба показувати вибір черг
        let noms = []
        for (let i = 0; i < docTable.length; i++) {
          if (!noms.includes(docTable[i].nom)) noms.push(docTable[i].nom)
        }
        if (noms.length > 1) {
          //Показати діалог вибору черг
          this.inputSeveral(localestr('Виберіть потрібні черги подачі'), localestr('Черга подачі'), noms.map(el => ({ caption: localestr('Черга подачі') + ' ' + el, value: el })), (d) => { this.modOrder(idx, 'kitchenque', d) })
          return
        }

        let last_dep = -1
        let department = undefined
        let msgs = ''
        const last_i = prints.length
        let can_print = true
        for (let i = 0; i < docTable.length; i++) {
          let el = { ...docTable[i] }
          if (!el.id) can_print = false
          if (el.menu.department_id === null) {
            msgs = msgs + '\n' + el.menu?.name
            continue
          }
          let is_print = false //Перевірка на дублі
          prints.forEach(elm => {
            if (elm.department_id === el.menu.department_id && elm.docTable.find(it => it.id === el.id)) is_print = true
          })
          if (is_print) continue
          if (el.menu.department_id !== last_dep) {
            last_dep = el.menu.department_id
            // eslint-disable-next-line
            department = catDepartments.find(el => el.id === last_dep)
            prints.push({ idx: prints.length, department_id: last_dep, department: { ...department }, ...docHeader, docTable: [], timer: 60 })
          }
          const item = { uid: el.uid, id: el.id, nom: el.nom, menu: el.menu?.name, comment: el.comment, qtt: '' + parseFloat(el.qtt) }
          if (el.modifiers) item.modifiers = el.modifiers.map(mo => { return { comment: ' - ' + mo?.name } })
          prints[prints.length - 1].docTable.push(item)
        }
        //Додатковий принтер
        docTable = docTable.sort((el1, el2) => (parseInt(el1.menu.department2_id) - parseInt(el2.menu.department2_id)) || (parseInt(el1.nom) - parseInt(el2.nom)))
        last_dep = -1
        for (let i = 0; i < docTable.length; i++) {
          let el = { ...docTable[i] }
          if (!el.id) can_print = false
          if (!el.menu.department2_id) continue
          last_dep = el.menu.department2_id
          let is_print = false //Перевірка на дублі
          // eslint-disable-next-line
          prints.forEach(elm => {
            if (elm.department_id === last_dep && elm.docTable.find(it => it.id === el.id)) is_print = true
          })
          if (is_print) continue
          // eslint-disable-next-line
          let idx = prints.findIndex(it => it.department_id === last_dep)
          if (idx === -1) {
            idx = prints.length
            // eslint-disable-next-line
            department = catDepartments.find(el => el.id === last_dep)
            prints.push({ idx: prints.length, department_id: last_dep, department: { ...department }, ...docHeader, docTable: [], timer: 60 })
          }
          const item = { uid: el.uid, id: el.id, nom: el.nom, menu: el.menu?.name, comment: el.comment, qtt: '' + parseFloat(el.qtt), additional: 1 }
          if (el.modifiers) item.modifiers = el.modifiers.map(mo => { return { comment: ' - ' + mo?.name } })
          prints[idx].docTable.push(item)
        }

        if (!can_print && this.state.status !== 'OffLine') {
          setTimeout(() => { this.modOrder(idx, cmd, data) }, 300)
          return
        }
        if (msgs) this.msg(localestr('Для наступних позицій не вказане місце приготування\n') + msgs)
        //this.setState({jobPrint:prints})
        jobPrint = prints
        //let send_print=[]
        for (let i = last_i; i < prints.length; i++) {
          let el = prints[i]
          //пропуск пыдроздылыв без принтера
          // eslint-disable-next-line
          if (el.department && el.department.printer && !el.department.printer.id) setTimeout(() => this.modOrder(idx, cmd, { status: 'NotPrintable', index: i }), 20)
          // eslint-disable-next-line
          else if (el.department && el.department.printer && el.department.printer.type > 1 && el.department.printer.templates) setTimeout(() => this.localPrint(1, el, (d) => { this.modOrder(idx, cmd, { ...d, index: i }) }), 10 * (i + 1))
          // eslint-disable-next-line
          else { if (el.department.printer) delete el.department.printer.templates; load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 1, data: el })), (d) => { this.modOrder(idx, cmd, { ...d, index: i }) }) }
          //else {if(el.department.printer) delete el.department.printer.templates;send_print.push({type:1,data:{...el,index:i}});}
        }
        //Може перероблю щоб все за один раз
        //if(send_print.length) load('action=addJobs&data='+encodeURIComponent(JSON.stringify(send_print)),(d)=>this.modOrder(idx,cmd,d))
        sended = true
        setTimeout(() => sended = null, 1500)
      }
    } else if (cmd === 'kitchenque') {
      if (this.state.status === 'OffLine') {
        timer = 5
        this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
        return
      }

      //перевірити чи збережені дані
      let tasks = this.state.tasks
      let taskidx = tasks.findIndex(el => el.uid === order.uid)
      if (taskidx !== -1 && this.state.status !== 'OffLine') {
        if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
        else setTimeout(() => { this.modOrder(idx, cmd, data) }, 300)
        return
      }
      //потім друкувати
      const catHalls = this.state.data['catHalls']
      const catDepartments = this.state.data['catDepartments'] || []
      let docHeader = { ...order }
      delete docHeader.del
      delete docHeader.discount
      delete docHeader.sum
      //delete docHeader.uid
      delete docHeader.news
      delete docHeader.parent
      delete docHeader.curent
      delete docHeader.docTable
      if (docHeader.author) docHeader.author = docHeader.author.fio || docHeader.author?.name || ''
      const tbl = docHeader.table
      const hall = catHalls.find(el => tbl && tbl.owner && el.id === tbl.owner.id)
      docHeader.hall = hall ? hall?.name : ''
      delete docHeader.table
      docHeader.table = tbl ? tbl?.name : ''
      if (docHeader.docType && parseInt(docHeader.docType) === 1) {
        docHeader.hall = localestr('Доставка')
        docHeader.table = '~' + (docHeader.phone || '').substring(5)
      }
      let prints = [...this.state.jobPrint]
      let docTable = order.docTable.filter(el => parseInt(el.status) === 1 && Array.from(data || []).includes(el.nom)) //тут ще фільтр по чергах
      docTable = docTable.sort((el1, el2) => (parseInt(el1.menu.department_id) - parseInt(el2.menu.department_id)) || (parseInt(el1.nom) - parseInt(el2.nom)))
      cmd = 'kitchen'

      let last_dep = -1
      let department = undefined
      let msgs = ''
      const last_i = prints.length
      let can_print = true
      for (let i = 0; i < docTable.length; i++) {
        let el = { ...docTable[i] }
        if (!el.id) can_print = false
        if (el.menu.department_id === null) {
          msgs = msgs + '\n' + el.menu?.name
          continue
        }
        let is_print = false //Перевірка на дублі
        prints.forEach(elm => {
          if (elm.department_id === el.menu.department_id && elm.docTable.find(it => it.id === el.id)) is_print = true
        })
        if (is_print) continue
        if (el.menu.department_id !== last_dep) {
          last_dep = el.menu.department_id
          // eslint-disable-next-line
          department = catDepartments.find(el => el.id === last_dep)
          prints.push({ idx: prints.length, department_id: last_dep, department: { ...department }, ...docHeader, docTable: [], timer: 60 })
        }
        const item = { uid: el.uid, id: el.id, nom: el.nom, menu: el.menu?.name, comment: el.comment, qtt: '' + parseFloat(el.qtt) }
        if (el.modifiers) item.modifiers = el.modifiers.map(mo => { return { comment: ' - ' + mo?.name } })
        prints[prints.length - 1].docTable.push(item)
      }
      //Додатковий принтер
      docTable = docTable.sort((el1, el2) => (parseInt(el1.menu.department2_id) - parseInt(el2.menu.department2_id)) || (parseInt(el1.nom) - parseInt(el2.nom)))
      last_dep = -1
      for (let i = 0; i < docTable.length; i++) {
        let el = { ...docTable[i] }
        if (!el.id) can_print = false
        if (!el.menu.department2_id) continue
        last_dep = el.menu.department2_id
        let is_print = false //Перевірка на дублі
        // eslint-disable-next-line
        prints.forEach(elm => {
          if (elm.department_id === last_dep && elm.docTable.find(it => it.id === el.id)) is_print = true
        })
        if (is_print) continue
        // eslint-disable-next-line
        let idx = prints.findIndex(it => it.department_id === last_dep)
        if (idx === -1) {
          idx = prints.length
          // eslint-disable-next-line
          department = catDepartments.find(el => el.id === last_dep)
          prints.push({ idx: prints.length, department_id: last_dep, department: { ...department }, ...docHeader, docTable: [], timer: 60 })
        }
        const item = { uid: el.uid, id: el.id, nom: el.nom, menu: el.menu?.name, comment: el.comment, qtt: '' + parseFloat(el.qtt), additional: 1 }
        if (el.modifiers) item.modifiers = el.modifiers.map(mo => { return { comment: ' - ' + mo?.name } })
        prints[idx].docTable.push(item)
      }

      if (!can_print && this.state.status !== 'OffLine') {
        setTimeout(() => { this.modOrder(idx, cmd, data) }, 300)
        return
      }
      if (msgs) this.msg(localestr('Для наступних позицій не вказане місце приготування\n') + msgs)
      //this.setState({jobPrint:prints})
      jobPrint = prints
      for (let i = last_i; i < prints.length; i++) {
        let el = prints[i]
        //пропуск пыдроздылыв без принтера
        // eslint-disable-next-line
        if (el.department && el.department.printer && !el.department.printer.id) setTimeout(() => this.modOrder(idx, cmd, { status: 'NotPrintable', index: i }), 20)
        // eslint-disable-next-line
        else if (el.department && el.department.printer && el.department.printer.type > 1 && el.department.printer.templates) setTimeout(() => this.localPrint(1, el, (d) => { this.modOrder(idx, cmd, { ...d, index: i }) }), 10 * (i + 1))
        // eslint-disable-next-line
        else { delete el.department.printer.templates; load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 1, data: el })), (d) => { this.modOrder(idx, cmd, { ...d, index: i }) }) }
      }
      sended = true
      setTimeout(() => sended = null, 1500)
    } else if (cmd === 'precheck') {
      const today = (new Date()).toISOString().slice(0, 10) //1
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          jobPrint = this.state.jobPrint.filter((el, idx) => idx !== data.index)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          jobPrint = this.state.jobPrint.filter((el, idx) => idx !== data.index)
          this.setState({ jobPrint })
          return
        }
        else if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          //const job=this.state.jobPrint.find((el)=>el.uid===order.uid) || {docTable:[]}
          //this.modStatus(order,tasks,5,job.docTable)
          if (!order.status && (order.date || today).slice(0, 10) <= today) {  //2
            order.status = 1
            let o_idx = tasks.findIndex(el => el.uid === order.uid)
            let task = { uid: order.uid, id: order.id, docTable: [] }
            if (o_idx === -1) o_idx = tasks.length
            else task = { ...tasks[o_idx] }
            task.status = order.status
            tasks[o_idx] = { ...task, timer, status: 0 }
          }
          jobPrint = this.state.jobPrint.filter((el) => el.uid !== order.uid)
          //this.setState({jobPrint})
        }
        else if (data.id) {
          //Перероблено одразу красити
          //const job=this.state.jobPrint.find((el)=>el.uid===order.uid) || {docTable:[]}
          //this.modStatus(order,tasks,5,job.docTable)
          if (!order.status && (order.date || today).slice(0, 10) <= today) order.status = 1
          jobPrint = this.state.jobPrint.filter((el) => el.uid !== order.uid)
          //this.setState({jobPrint})
        }
        // const audio = new Audio()
        // audio.preload = 'auto'
        // audio.src = sound1
        // audio.play()
        playSound(this.state.soundMode, sound1);
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          timer = 5
          if (!this.state.data.const.constPrinterData || parseInt(this.state.data.const.constPrinterData.type) === 1 || !this.state.data.const.constPrinterData.templates) {
            this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
            return
          }
        }
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1 && this.state.status !== 'OffLine') {
          if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          else setTimeout(() => { this.modOrder(idx, cmd, data) }, 200)
          return
        }
        //перевірити чи надрукована кухня
        const printKitchen = this.state.data['const'].constPrintKitchen
        if (printKitchen === '1' && (order.date || today).slice(0, 10) <= today) { //3
          let kitch = order.docTable.filter(el => parseInt(el.status) === 1).length
          if (kitch) {
            if (this.state.modal) return
            this.msg(localestr('Спочатку буде надруковано кухню!'), null, [{ caption: 'OK', action: () => { this.modOrder(idx, cmd, data) } }])
            this.modOrder(idx, 'kitchen', null)
            return
          }
        }
        //потім друкувати
        const catHalls = this.state.data['catHalls']
        let suma=0
        let docHeader = { ...order }
        delete docHeader.del
        delete docHeader.discount
        delete docHeader.sum
        //delete docHeader.uid
        delete docHeader.docTable
        if (docHeader.advance) {  //4
          suma=parseFloat(docHeader.advance)
          docHeader.subsum = suma.toFixed(2)
          docHeader.subname = localestr('Аванс')
        }

        const tbl = docHeader.table
        const hall = catHalls.find(el => tbl && el.id === tbl.owner.id)
        docHeader.hall = hall ? hall?.name : ''
        delete docHeader.table
        docHeader.table = tbl ? tbl?.name : ''
        docHeader.address = docHeader.address || ''
        if (docHeader.docType && parseInt(docHeader.docType) === 1) {
          docHeader.hall = localestr('Доставка')
          docHeader.table = (docHeader.phone || '').substring(0, 10)
        }
        else if (docHeader.docType && parseInt(docHeader.docType) === 2) {
          docHeader.hall = localestr('Самовивіз')
          docHeader.table = (docHeader.phone || '').substring(0, 10)
          docHeader.address = localestr('Самовивіз')
        }
        if (order.discount) {
          docHeader.discount = order.discount.prc
          docHeader.client = order.discount?.name
        }
        const const_grp = parseInt(this.state.data?.const?.constGroupCheck) || 0
        let pays = this.getPays(order.docTable, 1).pays
        if(order.advance) {  //зняти аванс з оплат
          if(pays && pays.length) {
            let adv=order.advance
            for(let i=0;i<pays.length;i++) {
              const sum=parseFloat(pays[i].sum || 0)
              const cor=Math.min(sum, adv)
              pays[i].sum = (sum - cor).toFixed(2)
              adv -= cor
              if(adv<=0) break
            }
            pays = pays.filter(el=>parseFloat(el.sum || 0) > 0)
          }
        }
        if (pays?.length) docHeader.pays = pays
        let prints = [...this.state.jobPrint]
        let docTable = order.docTable.filter(el => !el.refuse || parseInt(el.refuse) === 0)
        docTable = docTable.map(el => {
          let price = parseFloat(el.menu?.price || 0)
          let modifiers = []
          if (el.modifiers) {
            el.modifiers.forEach(mod => {
              if (mod.price) {
                price += mod.price
                if (mod.price > 0) modifiers.push({ ...mod, price: '+' + mod.price.toFixed(2) })
                else modifiers.push({ ...mod, price: mod.price.toFixed(2) })
              }
            })
          }
          if(price===0) price=parseFloat(el.amount || 0) / (parseFloat(el.qtt || 1))
          let grouping = null
          if (const_grp === 1) grouping = el.menu?.department_id
          if (const_grp === 2) grouping = this.getFiscal(el.menu, 1)
          if (modifiers.length) return ({ id: el.id, uid: el.uid, menu: el.menu?.name, menu_id: el.menu?.id, price: price.toFixed(2), qtt: parseFloat(el.qtt || 0), amount: (parseFloat(el.amount || 0) + parseFloat(el.discount || 0)), discount: parseFloat(el.discount || 0), grouping, modifiers })
          return ({ id: el.id, uid: el.uid, menu: el.menu?.name, menu_id: el.menu?.id, price: price.toFixed(2), qtt: parseFloat(el.qtt || 0), amount: (parseFloat(el.amount || 0) + parseFloat(el.discount || 0)), discount: parseFloat(el.discount || 0), grouping })
        })
        //Згорнути таблицю
        const objTable = docTable.reduce((accumulator, item) => {
          const key = item.menu_id + '~' + item.price
          if (!accumulator[key]) {
            accumulator[key] = { ...item }
          } else {
            accumulator[key].qtt += item.qtt || 0
            accumulator[key].amount += item.amount || 0
            accumulator[key].discount += item.discount || 0
          }
          return accumulator
        }, {})
        docTable = Object.values(objTable)
        //Групування
        let newTable = []
        if (const_grp) {
          let catNames = this.state.data['catDepartments'] || []
          if (const_grp === 2) catNames = this.state.data['catDevices'] || []

          let ttl = 0
          let old_grp = null
          docTable.sort((a, b) => { return (a.grouping > b.grouping) ? 1 : ((a.grouping < b.grouping) ? -1 : 0) })
          for (let i = 0; i < docTable.length; i++) {
            const currentItem = docTable[i];
            if (old_grp !== currentItem.grouping) {
              if (old_grp !== null) {
                // eslint-disable-next-line no-loop-func
                const elem = catNames.find(el => el.id === old_grp) || ({ name: '' })
                newTable.push({
                  payName: 'Разом по ' + elem?.name,
                  sum: ttl.toFixed(2)
                })
              }
              ttl = 0
              old_grp = currentItem.grouping
              // eslint-disable-next-line no-loop-func
              const elem = catNames.find(el => el.id === old_grp) || ({ name: '' })
              newTable.push({
                payName: elem?.name,
                sum: ''
              })
            }
            newTable.push(currentItem)
            ttl += parseFloat(currentItem.amount) || 0
          }
          if (ttl) {
            const elem = catNames.find(el => el.id === old_grp) || ({ name: '' })
            newTable.push({
              payName: 'Разом по ' + elem?.name,
              sum: ttl.toFixed(2)
            })
          }
        } else newTable = docTable

        const fnd = prints.findIndex(el => el.id === docHeader.id && el.type === 2) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 2, ...docHeader, docTable: [], timer: 60 })
        let sum = 0
        let sumd = 0
        newTable.forEach(el => {
          sum += parseFloat(el.amount || 0)
          sumd += parseFloat(el.discount || 0)
          el.amount = parseFloat(el.amount || 0).toFixed(2)
          el.discount = parseFloat(el.discount || 0).toFixed(2)
          prints[prints.length - 1].docTable.push({ ...el })
        })
        prints[prints.length - 1].sumt = sum.toFixed(2)
        prints[prints.length - 1].sumd = sumd.toFixed(2)
        prints[prints.length - 1].sum = (sum - sumd - suma).toFixed(2)
        let pos = (docHeader.finish_to || '').indexOf('#')
        if (pos !== -1) {
          prints[prints.length - 1].address += ' ' + (docHeader.finish_to.substring(pos + 1, docHeader.finish_to.length) + 'хв' || '')
        }
        else prints[prints.length - 1].address += ' ' + (docHeader.finish_to || '')
        //----додаткові реквізити з констант
        if (this.state.data.const) {
          if (this.state.data.const.constPrinterData) prints[prints.length - 1].printer = { ...this.state.data.const.constPrinterData }
          if (this.state.data.const.sysFirm) prints[prints.length - 1].sysFirm = this.state.data.const.sysFirm
          if (this.state.data.const.constAdress) prints[prints.length - 1].constAdress = this.state.data.const.constAdress
          if (this.state.data.const.constPhone) prints[prints.length - 1].constPhone = this.state.data.const.constPhone
        }
        if (this.state.printer) prints[prints.length - 1].printer = { ...this.state.printer }
        //prints[prints.length-1].docTable.push({id:el.id,menu:el.menu?.name,comment:el.comment,qtt:parseFloat(el.qtt)})
        //this.setState({jobPrint:prints})
        jobPrint = prints
        if (prints[prints.length - 1].printer && prints[prints.length - 1].printer.type > 1 && prints[prints.length - 1].printer.templates) {
          this.localPrint(2, prints[last_i], (d) => { this.modOrder(idx, cmd, { ...d, index: last_i }) })
        }
        else {
          if (prints[prints.length - 1].printer) delete prints[prints.length - 1].printer.templates
          load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 2, data: prints[last_i] })), (d) => { this.modOrder(idx, cmd, { ...d, index: last_i }) })
        }
      }
    } else if (cmd === 'discount') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      if (data) {
        let use_disc = false
        if (data?.use) use_disc = true
        let disc_bal = 0
        if (data?.balance) disc_bal = data.balance
        if (parseInt(data) === -1) order.discount = ''
        else order.discount = data
        if (!order.discount) disc = 0
        else if (order.discount === undefined) disc = 0
        else { disc = order.discount.prc; disc_mode = order.discount.mode || 0; disc_type = order.discount.type || 0; }
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        if (order.discount) task.discount = order.discount
        else task.discount = { id: null }
        let t_docTable = [...task.docTable]
        let docTable = order.docTable
        for (let i = 0; i < docTable.length; i++) {
          let tabItem = docTable[i]
          let price_delta = 0
          if (tabItem.modifiers) tabItem.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
          let newAmount = ((parseFloat(tabItem.menu?.price) || 0) + price_delta) * parseFloat(tabItem.qtt)
          if (!newAmount) newAmount = (parseFloat(tabItem.amount) || 0) + (parseFloat(tabItem.discount) || 0)
          let newDiscount = 0
          if (disc && !disc_type) newDiscount = newAmount * disc / 100
          else if (disc_type === 2 || (use_disc && disc_bal > 0)) {
            newDiscount = disc_bal
          }
          if (newDiscount > newAmount) newDiscount = newAmount
          if (disc_type) disc_bal -= newDiscount
          if (tabItem.menu?.disable_discount) newDiscount = 0
          newAmount -= newDiscount
          if (disc_mode) newDiscount = 0
          if (tabItem.amount === newAmount.toFixed(2) && tabItem.discount === newDiscount.toFixed(2)) continue

          /*if(disc&&!disc_mode) {
            let disc_sum=Math.round(tabItem.qtt*price*(disc))
            tabItem.discount=(disc_sum/100).toFixed(2)
            newAmount=Math.round(tabItem.qtt*price*100-disc_sum)/100
          }
          else tabItem.discount=0
          if(tabItem.menu.disable_discount||disc_type) {
            newAmount=tabItem.qtt*price
            tabItem.discount=0
          }*/
          tabItem.discount = newDiscount
          tabItem.amount = newAmount.toFixed(2)
          docTable[i] = tabItem
          let t_idx = t_docTable.findIndex(el => el.uid === tabItem.uid)
          let item = {}
          if (t_idx === -1) t_idx = t_docTable.length
          else item = { ...t_docTable[t_idx] }
          item = { ...item, ...tabItem }
          t_docTable[t_idx] = item
        }
        order.docTable = docTable
        order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
        task.docTable = t_docTable
        tasks[o_idx] = { ...task, timer, status: 0 }

      } else {
        const modal = <Discount value={order.discount} setValue={(val) => { this.modOrder(idx, 'discount', val) }} setModal={this.setModal} data={this.state.data['catDiscounts']} fld={this.state.data['fldDiscounts']} />
        this.setState({ modal })
      }
    } else if (cmd === 'discount_sum') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      if (data || data === 0) {
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, discount: '', docTable: [] }
        order.discount = ''
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        let docTable = order.docTable
        let t_docTable = [...task.docTable]
        /*let base_dsc=0
        for(let i=0;i<docTable.length;i++){
          let tabItem=docTable[i]
          if(!tabItem.menu.disable_discount) base_dsc+=(parseFloat(tabItem.amount)||0)+(parseFloat(tabItem.discount)||0)
        }
        if(!base_dsc){
          this.msg(localestr('Для цього замовлення не можна зробити знижку!'))
          return
        }
        const koef=data*100/base_dsc
        let discount=data*100
        for(let i=0;i<docTable.length;i++){
          let tabItem=docTable[i]
          if(tabItem.menu.disable_discount) continue
          let price_delta=0
          if(tabItem.modifiers) tabItem.modifiers.forEach(el=>price_delta+=parseFloat(el.price)||0)
          let newAmount=((parseFloat(tabItem.menu.price)||0)+price_delta)*parseFloat(tabItem.qtt)
          if(!newAmount) newAmount=(parseFloat(tabItem.amount)||0)+(parseFloat(tabItem.discount)||0)
          let newDiscount=Math.round(newAmount*koef)
          if(newAmount*100>newDiscount) newDiscount++
          if(newDiscount>discount) newDiscount=discount
          if(newDiscount>newAmount*100) newDiscount=newAmount*100
          discount-=newDiscount
          newAmount=newAmount-newDiscount/100
          tabItem.discount=newDiscount/100
          tabItem.amount=newAmount.toFixed(2)
          docTable[i]=tabItem
          let t_idx=t_docTable.findIndex(el=>el.uid===tabItem.uid) 
          let item={}
          if(t_idx===-1) t_idx=t_docTable.length
          else item={...t_docTable[t_idx]}
          item={...item,...tabItem}
          t_docTable[t_idx]=item
        }*/
        let discount = data
        for (let i = 0; i < docTable.length; i++) {
          let tabItem = docTable[i]
          if (tabItem.menu?.disable_discount) continue
          let price_delta = 0
          if (tabItem.modifiers) tabItem.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
          let newAmount = ((parseFloat(tabItem.menu?.price) || 0) + price_delta) * parseFloat(tabItem.qtt)
          if (!newAmount) newAmount = (parseFloat(tabItem.amount) || 0) + (parseFloat(tabItem.discount) || 0)
          let newDiscount = discount
          if (newDiscount > newAmount) newDiscount = newAmount
          newAmount -= newDiscount
          discount -= newDiscount
          if (tabItem.amount === newAmount.toFixed(2) && tabItem.discount === newDiscount.toFixed(2)) continue
          tabItem.discount = newDiscount
          tabItem.amount = newAmount.toFixed(2)
          docTable[i] = tabItem
          let t_idx = t_docTable.findIndex(el => el.uid === tabItem.uid)
          let item = {}
          if (t_idx === -1) t_idx = t_docTable.length
          else item = { ...t_docTable[t_idx] }
          item = { ...item, ...tabItem }
          t_docTable[t_idx] = item
        }
        order.docTable = docTable
        order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
        task.docTable = t_docTable
        tasks[o_idx] = { ...task, timer, status: 0 }
      } else {
        let amount_dsc = 0
        let base_dsc = 0
        let docTable = order.docTable
        for (let i = 0; i < docTable.length; i++) {
          let tabItem = docTable[i]
          amount_dsc += parseFloat(tabItem.discount)
          if (!tabItem.menu?.disable_discount) base_dsc += parseFloat(tabItem.amount)
        }
        if (!base_dsc) {
          this.msg(localestr('Для цього замовлення не можна зробити знижку!'))
          return
        }
        const modal = <Calc value={amount_dsc} caption={localestr('Сума знижки')} text={localestr('Введіть суму знижки')} setValue={(val) => { this.modOrder(idx, 'discount_sum', val) }} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'reject') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(this.state.rights.urReject) === 0 && parseInt(this.state.rights.urAdmin) === 0) return
      let tabItem = docTable[order.curent]
      if (parseInt(tabItem.status) > 5 && parseInt(this.state.rights.urAdmin) === 0) return
      //let need_print=false
      if (!tabItem.refuse && parseInt(tabItem.status) === 2) {
        //Ще не готово, друкуємо відміну
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1 && this.state.status !== 'OffLine') {
          if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          else setTimeout(() => { this.modOrder(idx, cmd, data) }, 100)
          return
        }
        //потім друкувати
        if (parseInt(this.state.data.const.constTurnPrint || 0) === 0) { //не друкувати
          this.modOrder(idx, 'reject_after', data)
          return
        } else if (parseInt(this.state.data.const.constTurnPrint) === 1) { //друкувати
          this.modOrder(idx, 'reject_print', data)
          return
        } else if (parseInt(this.state.data.const.constTurnPrint) === 2) {
          this.msg(localestr('Друкувати відмову?'), localestr('Друк'), [
            { caption: localestr('Так'), action: () => this.modOrder(idx, 'reject_print', data) },
            { caption: localestr('Ні'), action: () => this.modOrder(idx, 'reject_after', data) }
          ])
          return
        }
      } else if (parseInt(tabItem.status) === 4) {
        //Якщо вже є відміна, повідомляємо що скасувати її не можна
        this.msg(localestr('Відмову на приготування вже не можна скасувати!'))
        return
      } else {
        if (tabItem.refuse) { tabItem.refuse = null; tabItem.reason = null }
        else tabItem.refuse = 1
      }
      docTable[order.curent] = tabItem
      order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
      tasks = this.modTask(order.uid, order.id, tabItem)
    } else if (cmd === 'reject_after') {
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(this.state.rights.urReject) === 0 && parseInt(this.state.rights.urAdmin) === 0) return
      let tabItem = docTable[order.curent]
      if (data) {
        //if(data.no_product) tabItem.status='4'
        tabItem.refuse = 1
        tabItem.reason = data
      } else {
        tabItem.status = '4'
        tabItem.refuse = 1
      }
      docTable[order.curent] = tabItem
      order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
      tasks = this.modTask(order.uid, order.id, tabItem)
    } else if (cmd === 'reject_print') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          return
        }
        else if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            let timer_ = 1
            data.print.forEach(d => {
              if (d.type === 'svg') setTimeout(() => print_rawbt(d), timer_)
              timer_ += 500
            })
          }
          else this.printData(data)

        }
        let docTable = order.docTable
        if (docTable.length <= data.index) return
        if (data.index === undefined) return
        if (data.index === -1) return
        if (parseInt(this.state.rights.urReject) === 0 && parseInt(this.state.rights.urAdmin) === 0) return
        let tabItem = docTable[data.index]
        if (data.reason) {
          //if(data.reason.no_product) tabItem.status='4'
          tabItem.refuse = 1
          tabItem.reason = data.reason
        } else {
          //tabItem.status='4'
          tabItem.refuse = 1
        }
        docTable[data.index] = tabItem
        order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
        tasks = this.modTask(order.uid, order.id, tabItem)
        // const audio = new Audio()
        // audio.preload = 'auto'
        // audio.src = sound1
        // audio.play()
        playSound(this.state.soundMode, sound1);
      } else {
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1 && this.state.status !== 'OffLine') {
          if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          else setTimeout(() => { this.modOrder(idx, cmd, data) }, 100)
          return
        }
        //потім друкувати
        const catHalls = this.state.data['catHalls']
        const catDepartments = this.state.data['catDepartments'] || []
        let docHeader = { ...order }
        delete docHeader.del
        delete docHeader.discount
        delete docHeader.sum
        //delete docHeader.uid
        delete docHeader.news
        delete docHeader.parent
        delete docHeader.curent
        delete docHeader.docTable
        if (docHeader.author) docHeader.author = docHeader.author.fio || docHeader.author?.name || ''
        const tbl = docHeader.table
        const hall = catHalls.find(el => el.id === tbl.owner.id)
        docHeader.hall = hall ? hall?.name : ''
        delete docHeader.table
        docHeader.table = tbl ? tbl?.name : ''
        if (docHeader.docType && parseInt(docHeader.docType) === 1) {
          docHeader.hall = localestr('Доставка')
          docHeader.table = '~' + (docHeader.phone || '').substring(5)
        }
        let department = undefined
        let msgs = ''
        let docTable = order.docTable
        if (docTable.length <= order.curent) return
        if (order.curent === undefined) return
        if (order.curent === -1) return
        if (parseInt(this.state.rights.urReject) === 0 && parseInt(this.state.rights.urAdmin) === 0) return
        let tabItem = { uid: docTable[order.curent].uid, id: docTable[order.curent].id, menu: docTable[order.curent].menu?.name, comment: docTable[order.curent].comment, qtt: '' + parseFloat(docTable[order.curent].qtt) }
        const last_dep = docTable[order.curent].menu.department_id
        if (!last_dep) {
          this.msg(localestr('Не вказане місце приготування\nПродовжити?') + msgs, localestr('Помилка'), [
            { caption: localestr('Так'), action: () => this.modOrder(idx, 'reject_after', data) },
            { caption: localestr('Ні'), action: () => { } }
          ])
          return
        }
        department = catDepartments.find(el => el.id === last_dep)
        const print = { department_id: last_dep, department: { ...department }, ...docHeader, docTable: [tabItem] }
        if (department && department.printer && !department.printer.id) setTimeout(() => this.modOrder(idx, 'reject_after', data), 10)
        else if (department && department.printer && department.printer.type > 1 && department.printer.templates) this.localPrint(6, print, (d) => { this.modOrder(idx, cmd, { ...d, index: order.curent }) })
        else load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 6, data: print })), (d) => { this.modOrder(idx, cmd, { ...d, index: order.curent }) })
      }
    } else if (cmd === 'reject2') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (!data) return
      if (parseInt(this.state.rights.urReject) === 0 && parseInt(this.state.rights.urAdmin) === 0) return
      //перевірити чи збережені дані
      let tasks = this.state.tasks
      let taskidx = tasks.findIndex(el => el.uid === order.uid)
      if (taskidx !== -1 && this.state.status !== 'OffLine') {
        if (!tasks[taskidx].sended) this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
        else setTimeout(() => { this.modOrder(idx, cmd, data) }, 100)
        return
      }
      if (data.no_product === 2) { //Друкувати
        const catHalls = this.state.data['catHalls']
        const catDepartments = this.state.data['catDepartments'] || []
        let docHeader = { ...order }
        delete docHeader.del
        delete docHeader.discount
        delete docHeader.sum
        delete docHeader.news
        delete docHeader.parent
        delete docHeader.curent
        delete docHeader.docTable
        if (docHeader.author) docHeader.author = docHeader.author.fio || docHeader.author?.name || ''
        const tbl = docHeader.table
        const hall = catHalls.find(el => tbl && el.id === tbl.owner.id)
        docHeader.hall = hall ? hall?.name : ''
        delete docHeader.table
        docHeader.table = tbl ? tbl?.name : ''
        if (docHeader.docType && parseInt(docHeader.docType) === 1) {
          docHeader.hall = localestr('Доставка')
          docHeader.table = '~' + (docHeader.phone || '').substring(5)
        }
        let department = undefined
        let msgs = ''
        let tabItem = { uid: docTable[order.curent].uid, id: docTable[order.curent].id, menu: docTable[order.curent].menu?.name, comment: docTable[order.curent].comment, qtt: '' + parseFloat(docTable[order.curent].qtt) }
        const last_dep = docTable[order.curent].menu.department_id
        if (!last_dep) {
          this.msg(localestr('Не вказане місце приготування\nПродовжити?') + msgs, localestr('Помилка'), [
            { caption: localestr('Так'), action: () => this.modOrder(idx, 'reject_after', data) },
            { caption: localestr('Ні'), action: () => { } }
          ])
          return
        }
        department = catDepartments.find(el => el.id === last_dep)
        const print = { department_id: last_dep, department: { ...department }, ...docHeader, docTable: [tabItem] }
        if (department && department.printer && !department.printer.id) setTimeout(() => this.modOrder(idx, 'reject_after', data), 10)
        else if (department && department.printer && department.printer.type > 1 && department.printer.templates) this.localPrint(6, print, (d) => { this.modOrder(idx, 'reject_print', { ...d, index: order.curent, reason: data }) })
        else load('action=addJobs&data=' + encodeURIComponent(JSON.stringify({ type: 6, data: print })), (d) => { this.modOrder(idx, 'reject_print', { ...d, index: order.curent, reason: data }) })
      } else {
        this.modOrder(idx, 'reject_after', data)
        return
      }
    } else if (cmd === 'close') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        } else if (status === 'error') {
          //this.msg(localestr(data.msg),localestr('Помилка'))
          if (data.id && data.payType && data.fiscal !== 0) this.msg(localestr(data.msg), localestr('Помилка'), [
            { caption: localestr('Повторити'), action: () => load('action=closeOrder&data=' + JSON.stringify({ id: data.id, date: data.date.substring(0, 19), payType: data.payType, fiscal: data.fiscal, print: data.print, printer: data.printer }), (d) => { this.modOrder(idx, 'close', d) }) },
            { caption: localestr('Не фіскально'), action: () => load('action=closeOrder&data=' + JSON.stringify({ id: data.id, date: data.date.substring(0, 19), payType: data.payType, fiscal: 2, print: data.print, printer: data.printer }), (d) => { this.modOrder(idx, 'close', d) }) },
            { caption: localestr('Закрити'), action: () => { } }
          ])
          else this.msg(localestr(data.msg), localestr('Помилка'))
          return
        }
        if (data.msg) this.msg(data.msg)
        if (data.printed) {
          if (data.printed.status === 'error') this.msg(localestr(data.printed.msg), localestr('Помилка'))
          if (data.printed.print) {
            if (data.printed.printer_type && parseInt(data.printed.printer_type) === 2) {
              let timer_ = 1
              data.printed.print.forEach(d => {
                if (d.type === 'svg') setTimeout(() => print_rawbt(d), timer_)
                timer_ += 500
              })
            }
            else this.printData(data.printed)
          }
          if (data.printed.id) {
            //завдання друку
            let prints = [...this.state.jobPrint]
            prints.push({ type: 3, timer: 30, job_id: data.printed.id })
          }
        }
        const orders = this.state.orders.filter(el => el.id !== data.data.id)
        const windows = this.state.windows.filter(el => el.data.id !== data.data.id || el.wndType === 'tablesTab' || el.wndType === 'deliveryTab' || el.wndType === 'pickupTab')
        //const activeWindow=Math.min(this.state.activeWindow,windows.length-1)
        const activeWindow = Math.min(0, windows.length - 1)
        this.setState({ windows, orders, activeWindow })
        this.setCurentDB(orders)
        //const audio = new Audio()
        //audio.preload = 'auto'
        //audio.src = sound2
        //audio.play()
        playSound(this.state.soundMode, sound2);
        return

      } else if (order.id) {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1) {
          this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          return
        }

        if (order.docTable.length === 0 && parseInt(order.advance) > 0) {
          this.msg(localestr('Замовлення має передоплату!\nЗакрити замовлення можна лише після скасування передоплати!'))
          return
        }

        if (order.docTable.length === 0) load('action=remOrder&data=' + JSON.stringify({ id: order.id, marked: 1, last_upd: order.last_upd }), (d) => { this.modOrder(idx, 'close', d) })
        else load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '0', online: order.online, fiscal: 2, print: false }), (d) => { this.modOrder(idx, 'close', d) })
        //this.msg(localestr('Документ містить дані!\nМожна закрити лише пустий документ!'))
        return
      }
      else {
        const orders = this.state.orders.filter(el => el.uid !== order.uid)
        const windows = this.state.windows.filter(el => el.data.uid !== order.uid || el.wndType === 'tablesTab' || el.wndType === 'deliveryTab' || el.wndType === 'pickupTab')
        tasks = this.state.tasks.filter(el => el.uid !== order.uid)
        //const activeWindow=Math.min(this.state.activeWindow,windows.length-1)
        const activeWindow = Math.min(0, windows.length - 1)
        this.setState({ windows, orders, tasks, activeWindow })
        this.setCurentDB(orders)
        return
      }
    } else if (cmd === 'cash') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      //перевірити чи онлайн
      if (this.state.status === 'OffLine') {
        this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
        timer = 5
        return
      }
      //перевірити чи збережені дані
      let tasks = this.state.tasks
      let taskidx = tasks.findIndex(el => el.uid === order.uid)
      if (taskidx !== -1) {
        this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
        return
      }
      let fiscal = 2
      if (this.state.data.const) {
        if (this.state.data.const.constFisCash === 3) fiscal = order.userFisSet || 2  //fiscal=localStorage.getItem('user_fiscal')||order.userFisSet||0
        else fiscal = this.state.data.const.constFisCash || 0
        fiscal = parseInt(fiscal)
      }
      //Тут без закриття для доставки
      const tip = data || 0 //чайові
      if (this.state?.data?.const?.constXprs && order.docType === 1) {
        const id = order.id
        //loaddat('action=modOrder&data='+JSON.stringify({id,header:{id,payType:0,pay_data:null,fiscal,status:3,tip}}),(d)=>{this.modOrder(idx,'set_status',d)})
        loaddat('action=modOrder&data=' + JSON.stringify({ id, header: { id, payType: 0, fiscal, status: 3, tip } }), (d) => { this.modOrder(idx, 'set_status', d) })
        return
      }
      //чи друкувати
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      let print = true
      if (parseInt(this.state.data.const.constDocPrint) !== 2) {
        print = parseInt(this.state.data.const.constDocPrint) === 1
        loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '0', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
      }
      /*else if (fiscal===2){
        this.msg(localestr('Друкувати чек?'),localestr('Друк'),[
          {caption:localestr('Так'),action:()=>{print=true;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'0',fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}},
          {caption:localestr('Ні'),action:()=>{print=false;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'0',fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}}
        ]) 
      }*/
      else {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '0', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '0', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
      return
    } else if (cmd.substring(0, 4) === 'card') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      let fiscal = 0
      if (this.state.data.const) {
        if (this.state.data.const.constFisCard === 3) fiscal = order.userFisSet || localStorage.getItem('user_fiscal') || 0
        else fiscal = this.state.data.const.constFisCard || 0
        fiscal = parseInt(fiscal)
      }
      //Тут без закриття для доставки
      const tip = data || 0 //чайові
      const sum1 = cmd.substring(4)
      console.log(order)
      if (this.state?.data?.const?.constXprs && order.docType === 1) {
        const id = order.id
        if (sum1) loaddat('action=modOrder&data=' + JSON.stringify({ id, header: { id, payType: 5, sum1, sum2: (parseFloat(order.sum) - parseFloat(sum1)).toFixed(2), sum3: 0, fiscal, status: 3, tip } }), (d) => { this.modOrder(idx, 'set_status', d) })
        else loaddat('action=modOrder&data=' + JSON.stringify({ id, header: { id, payType: 1, fiscal, status: 3, tip } }), (d) => { this.modOrder(idx, 'set_status', d) })
        return
      }
      //чи друкувати
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      let print = true
      if (parseInt(this.state.data.const.constDocPrint) !== 2) {
        print = parseInt(this.state.data.const.constDocPrint) === 1
        /*if (fiscal===2)
          load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'1',fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})
        else*/
        if (sum1) loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '5', sum1, sum2: (parseFloat(order.sum) - parseFloat(sum1)).toFixed(2), sum3: 0, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        else loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '1', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        return
      }
      /*else if (fiscal===2){
        this.msg(localestr('Друкувати чек?'),localestr('Друк'),[
          {caption:localestr('Так'),action:()=>{print=true;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'1',fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}},
          {caption:localestr('Ні'),action:()=>{print=false;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'1',fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}}
        ]) 
      }*/
      else {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '1', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '1', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
    } else if (cmd.substring(0, 6) === 'online') {  //Тут також закриття оплаченого в закладі
      //якщо тип оплати -1 і фіскалізацію -1 не змінює, або якщо вони не передаються
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      let fiscal = 0
      //let payType=2
      let online = 2
      const fis_id = cmd.substring(6)
      if (this.state.data.const) {
        if (this.state.data.const.constFisCard === 3) {
          if (fis_id === '') {
            this.msg(localestr('Закрити чек фіскально?'), localestr('Питання'), [
              { caption: localestr('Так'), action: () => { this.modOrder(idx, 'online1', data) } },
              { caption: localestr('Ні'), action: () => { this.modOrder(idx, 'online2', data) } }
            ])
            return
          }
          else fiscal = parseInt(fis_id)
        }
        else fiscal = this.state.data.const.constFisCard || 0
        fiscal = parseInt(fiscal)
      }
      if (fis_id === '3') {
        fiscal = -1
        //payType=-1
      }
      //чи друкувати
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      let print = true
      if (parseInt(this.state.data.const.constDocPrint) !== 2) {
        print = parseInt(this.state.data.const.constDocPrint) === 1
        loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), online, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
      }
      /*else if (fiscal===2){
        this.msg(localestr('Друкувати чек?'),localestr('Друк'),[
          {caption:localestr('Так'),action:()=>{print=true;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'2',online,fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}},
          {caption:localestr('Ні'),action:()=>{print=false;load('action=closeOrder&data='+JSON.stringify({id:order.id,date:order.date.substring(0,19),payType:'2',online,fiscal,print,printer}),(d)=>{this.modOrder(idx,'close',{...d,print})})}}
        ]) 
      }*/
      else {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), online, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), online, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
      return
    } else if (cmd.substring(0, 4) === 'cert') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      const cert_id = cmd.substring(4)
      let fiscal = 0
      if (this.state.data.const) {
        if (this.state.data.const.constFisCert === 3) fiscal = order.userFisSet || localStorage.getItem('user_fiscal') || 0
        else fiscal = this.state.data.const.constFisCert || 0
        fiscal = parseInt(fiscal)
      }
      //Тут без закриття для доставки
      const tip = data || 0 //чайові
      if (this.state?.data?.const?.constXprs && order.docType === 1) {
        const id = order.id
        //loaddat('action=modOrder&data='+JSON.stringify({id,header:{id,payType:0,pay_data:null,fiscal,status:3}}),(d)=>{this.modOrder(idx,'set_status',d)})
        loaddat('action=modOrder&data=' + JSON.stringify({ id, header: { id, payType: 4, cert: cert_id, fiscal, status: 3, tip } }), (d) => { this.modOrder(idx, 'set_status', d) })
        return
      }
      //чи друкувати
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      let print = true
      if (parseInt(this.state.data.const.constDocPrint) !== 2) {
        if (fiscal === 2)
          load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        else
          loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        return
      }
      else if (fiscal === 2) {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
      else {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '4', cert: cert_id, tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
    } else if (cmd === 'cashless') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      let fiscal = 2
      if (this.state.data.const) {
        if (this.state.data.const.constFisLess === 3) fiscal = order.userFisSet || localStorage.getItem('user_fiscal') || 0
        else fiscal = this.state.data.const.constFisLess || 0
        fiscal = parseInt(fiscal)
      }
      //Тут без закриття для доставки
      const tip = data || 0 //чайові
      if (this.state?.data?.const?.constXprs && order.docType === 1) {
        const id = order.id
        //loaddat('action=modOrder&data='+JSON.stringify({id,header:{id,payType:1,pay_data:null,fiscal,status:3,tip}}),(d)=>{this.modOrder(idx,'set_status',d)})
        loaddat('action=modOrder&data=' + JSON.stringify({ id, header: { id, payType: 6, fiscal, status: 3, tip } }), (d) => { this.modOrder(idx, 'set_status', d) })
        return
      }
      //чи друкувати
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      let print = true
      if (parseInt(this.state.data.const.constDocPrint) !== 2) {
        if (fiscal === 2)
          load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        else
          loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) })
        return
      }
      else if (fiscal === 2) {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; load('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
      else {
        this.msg(localestr('Друкувати чек?'), localestr('Друк'), [
          { caption: localestr('Так'), action: () => { print = true; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } },
          { caption: localestr('Ні'), action: () => { print = false; loaddat('action=closeOrder&data=' + JSON.stringify({ id: order.id, date: order.date.substring(0, 19), payType: '6', tip, fiscal, print, printer }), (d) => { this.modOrder(idx, 'close', { ...d, print }) }) } }
        ])
      }
    } else if (cmd === 'tip') {
      if (this.state.rights.urTip) {
        const modal = <Calc caption={localestr("Чайові")} text={localestr("Введіть суму\nотриманих чайових")} value={0} setValue={(val) => { data(val) }} setModal={this.setModal} />
        setTimeout(() => this.setState({ modal }), 300)
      } else if (data) data(null)

    } else if (cmd === 'pay') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSclose)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }

      //перевірити чи онлайн
      if (this.state.status === 'OffLine') {
        this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
        timer = 5
        return
      }
      //перевірити чи збережені дані
      let tasks = this.state.tasks
      let taskidx = tasks.findIndex(el => el.uid === order.uid)
      if (taskidx !== -1) {
        this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
        return
      }
      //перевірити чи надрукована кухня
      const printKitchen = this.state.data['const'].constPrintKitchen
      if (printKitchen === "1") {
        let kitch = order.docTable.filter(el => parseInt(el.status) === 1).length
        if (kitch) {
          if (this.state.modal) return
          this.msg(localestr('Спочатку друкую кухню!'), null, [{ caption: 'OK', action: () => { this.modOrder(idx, cmd, data) } }])
          this.modOrder(idx, 'kitchen', null)
          return
        }
      }
      if (!data.no_question) {
        if (this.state?.data?.const?.constXprs && order.docType === 1 && order.status < 2) {
          this.msg(localestr("Замовлення ще не передане в доставку!\nПередати його в доставку?"), null, [
            { caption: 'Так', action: () => { this.modOrder(idx, 'delivery', null) } },
            { caption: 'Ні', action: () => { this.modOrder(idx, cmd, { no_question: true }) } }])
          return
        }
      }

      let fiscal = 0
      if (this.state.data.const) {
        if (this.state.data.const.constFisCard === 3) fiscal = order.userFisSet || 0 //fiscal=order.userFisSet||localStorage.getItem('user_fiscal')||0
        else fiscal = this.state.data.const.constFisCard || 0
        fiscal = parseInt(fiscal)
      }
      const p_obj = this.getPays(order.docTable, fiscal)
      const pays = p_obj.pays
      const ttl = p_obj.ttl
      let cashless = null
      let advance = parseFloat(order.advance || 0)
      if (order.discount && order.discount.cashless) cashless = { ...order.discount }
      //показати меню оплат
      const consts = { ...this.state.data.const }
      if(this.state.terminal) consts.constTerminal = this.state.terminal
      //console.log(this.state.windows[idx].data)
      //const modal=<PayForm orderId={(order?.id ?? null)} ttlsum={ttl} pays={pays} consts={this.state.data.const} userFisSet={parseInt(order.userFisSet||2)} action={val=>this.modOrder(idx,val,data)} setFiscal={d=>this.modOrder(idx,(d===1?'fiscal0':'fiscal1'),data)} setModal={this.setModal} cashless={cashless} msg={this.msg}/>
      const modal = <PayForm orderId={(order?.id ?? null)} ttlsum={ttl} pays={pays} consts={consts} userFisSet={parseInt(order.userFisSet || 2)} action={val => this.modOrder(idx, 'tip', (d) => { this.modOrder(idx, val, d) })} setFiscal={d => this.modOrder(idx, (d === 1 ? 'fiscal0' : 'fiscal1'), data)} setModal={this.setModal} cashless={cashless} msg={this.msg} advance={advance} />
      this.setState({ modal })
    } else if (cmd.substring(0, 2) === 'q_') {
      cmd = cmd.substring(2)
      if (order.author.id === this.state.user_id) this.modOrder(idx, cmd, data)
      else this.msg(localestr('Ви збираєтесь закрити замовлення користувача ') + (order.author?.name || '') + "!\n" + localestr('Продовжити?'), null, [{ caption: localestr('Так'), action: () => { setTimeout(() => this.modOrder(idx, cmd, data), 250) } }, { caption: localestr('Ні'), action: () => { } }])
      return
    } else if (cmd === 'table') {
      if (data) {
        order.table = data.table
        let tasks = this.state.tasks
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.table = order.table
        if (!order.author) task.author = { id: this.state.user_id, name: this.state.user }
        else if (!order.author.id) task.author = { id: this.state.user_id, name: this.state.user }
        tasks[o_idx] = { ...task, timer, status: 0 }
      } else {
        if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
          this.msg(localestr('Чуже замовлення не можна редагувати!'))
          return
        }


        const data = { user_id: this.state.user_id, hall: this.state.hall, catHalls: this.state.data.catHalls, orders: this.state.orders, rights: this.state.rights }
        const actions = { tblClick: (tbl) => { this.modOrder(idx, cmd, tbl); this.setModal('') } }
        const modal = <Tabfrm data={data} actions={actions} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'address') {
      if (data) {
        order.phone = data.phone
        order.address = data.address
        order.name = data?.name
        order.finish_to = data.finish_to
        if (!data.finish_to && data.wait) {
          if (isNumeric(data.wait)) {
            const now = new Date()
            now.setMinutes(now.getMinutes() + parseInt(data.wait))
            order.finish_to = now.toLocaleTimeString('uk-UA', { hour12: false, hour: '2-digit', minute: '2-digit' }).substring(0, 5) + "#" + parseInt(data.wait)
          }
        }
        let tasks = this.state.tasks
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.phone = order.phone
        task.address = order.address
        task.name = order?.name;
        task.finish_to = order.finish_to;
        if (data.pickup && order.docType !== 2) {
          task.docType = 2
          order.docType = 2
          //удалити послугу доставки, якщо є
          if (this.state.data.const.constDelivery) {
            const t_idx = order.docTable.findIndex(itm => itm.menu.id === this.state.data.const.constDelivery)
            if (t_idx !== -1) {
              order.curent = t_idx
              this.msg(localestr('Видалити доставку з чека?'), localestr('Питання'), [
                { caption: localestr('Так'), action: () => this.modOrder(idx, 'setqtt', 0) },
                { caption: localestr('Ні'), action: () => { } }
              ])
            }
          }
        }
        if (!data.pickup && order.docType !== 1 && !data?.table) {
          task.docType = 1
          order.docType = 1
          //Додати доставку якщо нема
          if (this.state.data.const.constDelivery) {
            const t_idx = order.docTable.findIndex(itm => itm.menu.id === this.state.data.const.constDelivery)
            let deliv = null
            if (this.state.data.catMenu) deliv = this.state.data.catMenu.find(itm => itm.id === this.state.data.const.constDelivery)

            if (t_idx === -1 && deliv && !this.state.data.const.constXprs) this.msg(localestr('Додати доставку?'), localestr('Питання'), [
              { caption: localestr('Так'), action: () => this.modOrder(idx, 'add', deliv) },
              { caption: localestr('Ні'), action: () => { } }
            ])
          }
        }
        if (data?.table && Object.keys(data.table)) {
          order.table = data?.table
          task.table = order?.table;
          task.docType = 0
          order.docType = 0
        }
        if (!order.author) task.author = { id: this.state.user_id, name: this.state.user }
        else if (!order.author.id) task.author = { id: this.state.user_id, name: this.state.user }
        tasks[o_idx] = { ...task, timer, status: 0 }
      } else {
        if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
          this.msg(localestr('Чуже замовлення не можна редагувати!'))
          return
        }
        //const data={phone:order.phone,address:order.address,name:order.discount?order.discount?.name:'', finish_to: order.finish_to, pickup:false}
        let data = { phone: order.phone, address: order.address, name: order?.name, finish_to: order.finish_to, pickup: false, ...order }
        let pos = (data.finish_to || '').indexOf('#')
        if (pos !== -1) {
          data.wait = data.finish_to.substring(pos + 1)
          data.finish_to = ''
        }
        /*const actions={tblClick:(tbl)=>{this.modOrder(idx,cmd,tbl);this.setModal('')}}
        const modal=<Tabfrm data={data} actions={actions} setModal={this.setModal}/>
        this.setState({modal})*/
        this.inputDelivery(data, (d) => this.modOrder(idx, cmd, d))
      }
    } else if (cmd === 'pickup') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      //const data={phone:order.phone,address:order.address,name:order.discount?order.discount?.name:'', finish_to: order.finish_to, pickup:true}
      let data = { phone: order.phone, address: order.address, name: order?.name, finish_to: order.finish_to, pickup: true };
      let pos = (data.finish_to || '').indexOf('#')
      if (pos !== -1) {
        data.wait = data.finish_to.substring(pos + 1)
        data.finish_to = ''
      }
      if (order?.table && Object.keys(order.table)) {
        data = { ...data, table: { ...order.table } }
      }
      this.inputDelivery(data, (d) => this.modOrder(idx, 'address', d))
    } else if (cmd === 'banquet') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      //const data={phone:order.phone,address:order.address,name:order.discount?order.discount?.name:'', finish_to: order.finish_to, pickup:true}
      let data = { phone: order.phone, address: order.address, name: order?.name, finish_to: order.finish_to, pickup: true };
      let pos = (data.finish_to || '').indexOf('#')
      if (pos !== -1) {
        data.wait = data.finish_to.substring(pos + 1)
        data.finish_to = ''
      }
      if (order?.table && Object.keys(order.table)) {
        data = { ...data, table: { ...order.table } }
      }
      this.inputBanquet(data, (d) => this.modOrder(idx, 'address', d))
    } else if (cmd.match(/^ex_mark[1-5]_auto$/)) {
      const markNum = parseInt(cmd.substring(7, 8));
      const markKey = `mark${markNum}`;
      const qttKey = `qtt${markNum}`;
      const goodKey = `ex_good${markNum}`;
      const modalNum = markNum === 1 ? '' : markNum;
      const setModalKey = markNum === 1 ? 'setModal' : `setModal${markNum}`;

      if (data) {
        let docTable = order.docTable;
        if (docTable.length <= order.curent) return;
        if (order.curent === undefined) return;
        if (order.curent === -1) return;
        if (!data) return;

        if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
          let marks = this.state.marks || [];
          let tabItem = { ...docTable[order.curent] };
          const is_liter = tabItem.menu[goodKey].unit === 3 ? 1 : 0;
          let need_qtt = (parseFloat(tabItem.qtt || 0)) * (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu[goodKey].qtt || 0)) * 10000;
          const idx_ = marks.findIndex(el => el.code === data);

          if (idx_ !== -1) {
            const old_mark = tabItem.excise_mark;
            const old_markN = tabItem[markKey];
            tabItem[markKey] = marks[idx_].code;
            if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol;
            if (!tabItem[qttKey]) tabItem[qttKey] = need_qtt;
            tabItem.excise_mark = '';

            for (let i = 1; i < markNum; i++) {
              const prevMarkKey = `mark${i}`;
              if (tabItem[prevMarkKey] && old_mark.indexOf(tabItem[prevMarkKey], 0) > -1) {
                if (tabItem.excise_mark) tabItem.excise_mark += ';' + tabItem[prevMarkKey];
                else tabItem.excise_mark = tabItem[prevMarkKey];
              }
            }

            if (this.state.data.const.constFisMarks === 3) tabItem[markKey] = '';
            else if (this.state.data.const.constFisMarks === 2 && !tabItem.excise_mark) tabItem.excise_mark = marks[idx_].code;
            else if (this.state.data.const.constFisMarks === 2) tabItem.excise_mark += ';' + marks[idx_].code;

            for (let i = markNum + 1; i <= 5; i++) {
              const nextMarkKey = `mark${i}`;
              if (tabItem[nextMarkKey] && old_mark.indexOf(tabItem[nextMarkKey], 0) > -1) {
                if (tabItem.excise_mark) tabItem.excise_mark += ';' + tabItem[nextMarkKey];
                else tabItem.excise_mark = tabItem[nextMarkKey];
              }
            }

            docTable[order.curent] = tabItem;
            this.modMarks(order.uid, order.id, old_markN, tabItem.menu[goodKey].good, -need_qtt);
            this.modMarks(order.uid, order.id, tabItem[markKey], tabItem.menu[goodKey].good, need_qtt, marks[idx_].vol);
            tasks = this.modTask(order.uid, order.id, tabItem);
          }
        }
      } else {
        let docTable = order.docTable;
        if (docTable.length <= order.curent) return;
        if (order.curent === undefined) return;
        if (order.curent === -1) return;

        let ask_mark = true;
        let marks = this.state.marks || [];
        if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
          if (this.state.data.const.constFisMarks) {
            if (this.state.data.const.constFisMarks === 3) ask_mark = false;
            else {
              let tabItem = docTable[order.curent];
              const is_liter = tabItem.menu[goodKey].unit === 3 ? 1 : 0;
              let need_qtt = (parseFloat(tabItem.qtt || 0)) * (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu[goodKey].qtt || 0)) * 10000;
              const idx_ = marks.findIndex(el => parseInt(el.good) === parseInt(tabItem.menu[goodKey].good) && el.qtt <= (10000 - need_qtt * (is_liter ? 1000 / el.vol : 1)));

              if (idx_ !== -1) {
                tabItem[markKey] = marks[idx_].code;
                if (is_liter) need_qtt = need_qtt * 1000 / marks[idx_].vol;
                tabItem[qttKey] = need_qtt;
                const old_marks = tabItem.excise_mark || '';
                tabItem.excise_mark = '';

                for (let i = 1; i < markNum; i++) {
                  const prevMarkKey = `mark${i}`;
                  if (tabItem[prevMarkKey] && old_marks.indexOf(tabItem[prevMarkKey], 0) > -1) {
                    if (tabItem.excise_mark) tabItem.excise_mark += ';' + tabItem[prevMarkKey];
                    else tabItem.excise_mark = tabItem[prevMarkKey];
                  }
                }

                if (this.state.data.const.constFisMarks === 3) tabItem[markKey] = '';
                else if (this.state.data.const.constFisMarks === 2 && !tabItem.excise_mark) tabItem.excise_mark = marks[idx_].code;
                else if (this.state.data.const.constFisMarks === 2) tabItem.excise_mark += ';' + marks[idx_].code;

                for (let i = markNum + 1; i <= 5; i++) {
                  const nextMarkKey = `mark${i}`;
                  if (tabItem[nextMarkKey] && old_marks.indexOf(tabItem[nextMarkKey], 0) > -1) {
                    if (tabItem.excise_mark) tabItem.excise_mark += ';' + tabItem[nextMarkKey];
                    else tabItem.excise_mark = tabItem[nextMarkKey];
                  }
                }

                ask_mark = false;
                docTable[order.curent] = tabItem;
                this.modMarks(order.uid, order.id, marks[idx_].code, tabItem.menu[goodKey].good, need_qtt, marks[idx_].vol);
                tasks = this.modTask(order.uid, order.id, tabItem);
              }
            }
          }
        }

        if (ask_mark) {
          let excise_mark = docTable[order.curent][markKey] || '';
          const is_liter = docTable[order.curent].menu[goodKey].unit === 3 ? 1 : 0;
          const modal = <Keybord2 caption={localestr('Акцизна марка') + ' ' + docTable[order.curent].menu[goodKey]?.name} value={excise_mark} is_liter={is_liter} setValue={(val) => { this.modOrder(idx, `ex_mark${markNum}`, val) }} setModal={this[setModalKey]} />;
          this.setState({ [`modal${modalNum}`]: modal });
          return;
        }
      }

    } else if (cmd.match(/^ex_mark[1-5]$/)) {

      const markNum = parseInt(cmd.substring(7));
      const markKey = `mark${markNum}`;
      const modalNum = markNum === 1 ? '' : markNum;
      const setModalKey = markNum === 1 ? 'setModal' : `setModal${markNum}`;
      const qttKey = `qtt${markNum}`;
      const goodKey = `ex_good${markNum}`;

      if (data) {
        let docTable = order.docTable;
        if (docTable.length <= order.curent) return;
        if (order.curent === undefined) return;
        if (order.curent === -1) return;

        let ask_mark = true;
        if (data.substring(0, 1) === '!') {
          ask_mark = false;
          data = data.substring(1);
        }

        let tabItem = { ...docTable[order.curent] };
        const is_liter = tabItem.menu[goodKey].unit === 3 ? 1 : 0;
        let vol = 1000;
        const pos = data.indexOf(';');
        if (is_liter) {
          if (pos !== -1) vol = parseInt(data.substring(pos + 1)) || 1000;
        }
        if (pos !== -1) data = data.substring(0, pos);

        const old_marks = tabItem.excise_mark || '';
        const old_mark = tabItem[markKey];
        tabItem[markKey] = data === '-1' ? '' : data;
        tabItem.excise_mark = '';

        if (tabItem[markKey]) {
          let marks = this.state.marks || [];
          if (ask_mark && this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
            let need_qtt = (parseFloat(tabItem.qtt || 0)) * (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu[goodKey].qtt || 0)) * 10000;
            if (is_liter) need_qtt = need_qtt * 1000 / vol;
            const idx_ = marks.findIndex(el => el.code === tabItem[markKey]);
            if (idx_ !== -1) {
              if (marks[idx_].qtt >= 10000) {
                this.msg(localestr('Марка ') + marks[idx_].code + localestr(' вже повністю використана!'), localestr('Акцизна марка'), [{ caption: 'OK', action: () => this.modOrder(idx, cmd, '-1') }, { caption: localestr('Ввести'), action: () => this.modOrder(idx, cmd, '!' + data) }]);
                return;
              } else if (marks[idx_].qtt + need_qtt > 10000) {
                this.msg(localestr('Не вистачає залишку ') + marks[idx_].code + localestr(' для вказаної кількості!'), localestr('Акцизна марка'), [{ caption: 'OK', action: () => this.modOrder(idx, cmd, '-1') }, { caption: localestr('Ввести'), action: () => this.modOrder(idx, cmd, '!' + data) }]);
                return;
              }
            }

            for (let i = 1; i <= 5; i++) {
              const currentMarkKey = `mark${i}`;
              if (tabItem[currentMarkKey] && i === markNum) {
                if (this.state.data.const.constFisMarks === 3) tabItem[currentMarkKey] = '';
                else if (this.state.data.const.constFisMarks === 2 && !tabItem.excise_mark) tabItem.excise_mark = tabItem[currentMarkKey];
                else if (this.state.data.const.constFisMarks === 2) tabItem.excise_mark += ';' + tabItem[currentMarkKey];
                else if (idx_ === -1 && !tabItem.excise_mark) tabItem.excise_mark = tabItem[currentMarkKey];
                else if (idx_ === -1) tabItem.excise_mark += ';' + tabItem[currentMarkKey];
                else if (!marks[idx_].qtt && !tabItem.excise_mark) tabItem.excise_mark = tabItem[currentMarkKey];
                else if (!marks[idx_].qtt) tabItem.excise_mark += ';' + tabItem[currentMarkKey];
              } else if (tabItem[currentMarkKey] && old_marks && old_marks.indexOf(tabItem[currentMarkKey], 0) > -1) {
                if (tabItem.excise_mark) tabItem.excise_mark += ';' + tabItem[currentMarkKey];
                else tabItem.excise_mark = tabItem[currentMarkKey];
              }
            }

            this.modMarks(order.uid, order.id, old_mark, tabItem.menu[goodKey].good, -tabItem[qttKey]);
            this.modMarks(order.uid, order.id, tabItem[markKey], tabItem.menu[goodKey].good, need_qtt, vol);
            tabItem[qttKey] = tabItem[markKey] ? need_qtt : null;
          }
        }

        docTable[order.curent] = tabItem;
        tasks = this.modTask(order.uid, order.id, tabItem);
      } else {
        let docTable = order.docTable;
        if (docTable.length <= order.curent) return;
        if (order.curent === undefined) return;
        if (order.curent === -1) return;

        let ask_mark = true;
        let marks = this.state.marks || [];
        if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
          if (this.state.data.const.constFisMarks) {
            if (this.state.data.const.constFisMarks === 3) ask_mark = false;
            else {
              let tabItem = docTable[order.curent];
              const is_liter = tabItem.menu[goodKey].unit === 3 ? 1 : 0;
              const need_qtt = (parseFloat(tabItem.qtt || 0)) * (parseFloat(tabItem.menu.koef || 1)) * (parseFloat(tabItem.menu[goodKey].qtt || 0)) * 10000;
              const menu_choise = marks.filter(el => el.good === tabItem.menu[goodKey].good && el.qtt <= 10000 - need_qtt * (is_liter ? 1000 / el.vol : 1));
              if (menu_choise.length) {
                const is_liter = docTable[order.curent].menu[goodKey].unit === 3 ? 1 : 0;
                let btns = menu_choise.map(el => ({ caption: el.code + (is_liter ? ' (' + el.vol / 1000 + localestr('л)') : '') + "\n" + localestr('використано ') + (el.qtt / 100).toFixed(1) + ' %', action: () => this.modOrder(idx, cmd, el.code + (is_liter ? ';' + el.vol : '')) }));
                btns.push({ caption: localestr('Ввести нову'), action: () => { this.setState({ [`modal${modalNum}`]: <Keybord2 caption={localestr('Акцизна марка') + ' ' + docTable[order.curent].menu[goodKey]?.name} value={''} is_liter={is_liter} setValue={(val) => { this.modOrder(idx, cmd, val) }} setModal={this[setModalKey]} /> }) } });
                this.msg_arr(localestr('Акцизні марки'), tabItem.menu[goodKey]?.name, btns);
                return;
              }
            }
          }
        }

        if (ask_mark) {
          let excise_mark = docTable[order.curent][markKey] || '';
          const is_liter = docTable[order.curent].menu[goodKey].unit === 3 ? 1 : 0;

          const modal = <Keybord2 caption={localestr('Акцизна марка') + ' ' + docTable[order.curent].menu[goodKey]?.name} value={excise_mark} is_liter={is_liter} setValue={(val) => { this.modOrder(idx, cmd, val) }} setModal={this[setModalKey]} />;
          this.setState({ [`modal${modalNum}`]: { ...modal } });
          return;
        }
      }

    } else if (cmd === 'break') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'));
        return;
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urBreack)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'));
        return;
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      if (data) {
        if (!data.first || !data.second) return;

        data.first.sum = data.first.docTable.reduce((sum, el) =>
          el.refuse ? sum : sum + parseFloat(el.amount || 0), 0);
        data.second.sum = data.second.docTable.reduce((sum, el) =>
          el.refuse ? sum : sum + parseFloat(el.amount || 0), 0);

        const orders = [...this.state.orders];
        let windows = [...this.state.windows];
        let tasks = [...this.state.tasks];

        this.compareOrder(data.first, orders, tasks, 1);

        if (!data.second.uid) {
          data.second.uid = uid();
          data.second.break = true;
          delete data.second.id;
          data.second.author = { id: this.state.user_id, name: this.state.user };
          data.second.date = (new Date()).toISOString().substring(0, 19);
          let gst = 0
          let oldgst = 0
          data.second.docTable = data.second.docTable.map((el, idx) => {
            if (oldgst !== el.guest) {
              oldgst = el.guest
              gst++
            }
            return { ...el, guest: gst, act: 'add', uid: uid(idx), id: null }
          });
          data.second.guests = gst
          tasks.push({ timer: 50, status: 0, ...data.second, act: 'break' });
          orders.push(data.second);
          /*windows.push({
              caption: `${data.second.table?.name} ${data.second.table.owner?.name} *`,
              wndType: 'orderTab',
              data: data.second
          });*/
          windows = this.setWindows(orders)
        } else {
          this.compareOrder(data.second, orders, tasks, 50);

          const oidx2 = orders.findIndex(el => el.uid === data.second.uid);
          if (oidx2 !== -1) { orders[oidx2] = data.second; orders[oidx2].break = true; }

          const widx = windows.findIndex(el => el.data.uid === data.second.uid);
          if (widx !== -1) windows[widx].data.docTable = data.second.docTable;
        }

        const oidx1 = orders.findIndex(el => el.uid === data.first.uid);
        const tidx = tasks.findIndex(el => el.uid === data.first.uid);

        if (oidx1 !== -1) { orders[oidx1] = data.first; orders[oidx1].slave = data.second.uid; }
        if (tidx !== -1) tasks[tidx].slave = data.second.uid;
        if (idx !== undefined) windows[idx].data.docTable = data.first.docTable;
        this.setState({ windows, orders, tasks });
        this.setCurentDB(orders);
        return;
      }

      const modal = (
        <BreakCheck
          orders={(this.state.orders || []).filter(el => el.author.id === this.state.user_id || this.state.rights.urAdmin || this.state.rights.urOrder)}
          marks={this.state.marks || []}
          value={order}
          setValue={(val) => { this.modOrder(idx, 'break', val) }}
          setModal={this.setModal}
          setModal2={this.setModal2}
        />
      );
      this.setState({ modal });

    } else if (cmd === 'fiscal0') {
      order.userFisSet = 1
      localStorage.setItem('user_fiscal', 1)
    } else if (cmd === 'fiscal1') {
      order.userFisSet = 2
      localStorage.setItem('user_fiscal', 2)
    } else if (cmd === 'fiscal2') {
      order.userFisSet = 0
      localStorage.setItem('user_fiscal', 0)
    } else if (cmd === 'guests') {
      if (data) {
        let new_data = data
        let add = null
        if (('' + data).includes('-')) {
          const parts = data.split('-', 2)
          new_data = parseInt(parts[0]) || 0
          add = parts[1]
        }
        let need_save = true
        if (new_data - 1 === (order.guest || 1)) {
          //Додали одного гостя
          order.guest = new_data
          if (order.guests < new_data) order.guests = new_data
          else need_save = false
        } else order.guests = new_data
        order.curent = 99
        if (add) order.additional = add
        if (!order.docTable?.length) order.guest = 1
        if (need_save) {
          let tasks = this.state.tasks
          let o_idx = tasks.findIndex(el => el.uid === order.uid)
          let task = { uid: order.uid, id: order.id, docTable: [] }
          if (o_idx === -1) o_idx = tasks.length
          else task = { ...tasks[o_idx] }
          task.guests = order.guests
          if (add) task.additional = add
          tasks[o_idx] = { ...task, timer, status: 0 }
        }
      } else {
        const modal = <Calc value={parseInt(order.guests)} caption={localestr('Гостей')} text={localestr("Введіть кількість \nперсон за столиком")} setValue={(val) => { this.modOrder(idx, 'guests', val) }}
          add_value={order.additional} add_data={this.state.data.additional} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'g_coment') {
      if (data) {
        order.comment = data === '-1' ? '' : data
        let tasks = this.state.tasks
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.comment = order.comment
        tasks[o_idx] = { ...task, timer, status: 0 }
      } else {
        let comment = order.comment || ''
        const modal = <Keybord value={comment} setValue={(val) => { this.modOrder(idx, 'g_coment', val) }} setModal={this.setModal} catTexts={this.state.data.catTexts} />
        this.setState({ modal })
      }
    } else if (cmd === 'author') {
      if (data) {
        order.author = data
        let tasks = this.state.tasks
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.author = order.author
        tasks[o_idx] = { ...task, timer: 1, status: 0 }
      } else {
        if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
          this.msg(localestr('Чуже замовлення не можна редагувати!'))
          return
        }
        //менюшка з вибором, або ввести нову
        let btns = this.state.data.catUsers.filter(el => el.id !== order.author.id).map(el => ({ caption: el?.name, action: () => this.modOrder(idx, cmd, el) }))
        this.msg_arr(localestr('Передати замовлення'), localestr('Передати'), btns)
        return
      }
    } else if (cmd === 'modifiers') {
      if (order.online > 1 || order.status > 2) {
        this.msg(localestr('Оплачене замовлення не можна редагувати!'))
        return
      }
      if (order.status > 1 && order.courier) {
        this.msg(localestr('Передане в доставку замовлення не можна редагувати!'))
        return
      }
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (!parseInt(this.state.rights.urAdmin) && parseInt(this.state.rights.urBlockOrder) && order.status > 0) {
        this.msg(localestr('Замовлення не можна редагувати після друку рахунка!'));
        return;
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
      const good = docTable[order.curent].menu
      if (!good) return
      if (!good.modifiers) return
      if (data) {
        let tabItem = docTable[order.curent]
        let price_delta = 0
        data.forEach(el => price_delta += parseFloat(el.price) || 0)
        //if(price_delta){
        let price = (parseFloat(tabItem.menu?.price) || 0)
        if (!price) price = ((parseFloat(tabItem.amount) || 0) + parseFloat(tabItem.discount || 0)) / (tabItem.qtt || 1)
        price += price_delta
        let newAmount = tabItem.qtt * price * (100 - disc) / 100
        if (disc && !disc_mode) tabItem.discount = parseFloat(tabItem.qtt * price * (disc) / 100).toFixed(2)
        else tabItem.discount = 0
        if (tabItem.menu?.disable_discount || disc_mode) {
          newAmount = tabItem.qtt * price
          tabItem.discount = 0
        }
        tabItem.amount = newAmount.toFixed(2)
        //}
        tabItem.modifiers = data
        docTable[order.curent] = tabItem
        tasks = this.modTask(order.uid, order.id, tabItem)
        order.docTable = docTable
        order.sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0)
      }
      else {
        const modal6 = <Modifiers value={docTable[order.curent].modifiers || null} setValue={(val) => { this.modOrder(idx, 'modifiers', val) }} setModal={this.setModal6} data={good.modifiers} />
        this.setState({ modal6 })
      }
    } else if (cmd === 'setnom') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
      if (data) {
        let tabItem = docTable[order.curent]
        tabItem.nom = data
        docTable[order.curent] = tabItem
        tasks = this.modTask(order.uid, order.id, tabItem)
        order.docTable = docTable
      } else {
        let docTable = order.docTable
        let max_nom = 1
        docTable.forEach(el => { if (el.nom > max_nom) max_nom = el.nom })
        max_nom++
        let btns = []
        for (let i = 1; i <= max_nom; i++) btns.push({ caption: localestr('Черга подачі №') + i, action: () => this.modOrder(idx, 'setnom', i) })
        this.msg_arr('', localestr('Черга подачі'), btns)
      }
    } else if (cmd === 'guest') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      let docTable = order.docTable
      if (docTable.length <= order.curent) return
      if (order.curent === undefined) return
      if (order.curent === -1) return
      if (parseInt(docTable[order.curent].status) > 1 && parseInt(this.state.rights.urAdmin) === 0) return
      if (data) {
        let new_table = docTable.map(el => ({ ...el, old_guest: el.guest }))
        new_table[order.curent].guest = data
        new_table = new_table.sort((a, b) => {
          if (a.guest > b.guest) return 1
          if (a.guest < b.guest) return -1
          if (a.nom > b.nom) return 1
          if (a.nom < b.nom) return -1
          if (a.uid > b.uid) return 1
          if (a.uid < b.uid) return -1
          return 0
        })
        let tabItem = { ...docTable[order.curent] }
        let gst = 0
        let oldgst = 0
        for (let i = 0; i < new_table.length; i++) {
          if (oldgst !== new_table[i].guest) {
            oldgst = new_table[i].guest
            gst++
          }
          new_table[i].guest = gst
          if (new_table[i].guest !== new_table[i].old_guest) tasks = this.modTask(order.uid, order.id, new_table[i])
          if (new_table[i].uid === tabItem.uid) order.curent = i

        }
        /*if(gst!==order.guests) {
          let o_idx=tasks.findIndex(el=>el.uid===order.uid) 
          if(o_idx!==-1) tasks[o_idx].guests=gst
          order.guests=gst
        }*/
        if (!order.guest) order.guest = 1
        if (gst > order.guest) order.guest = gst
        if (gst > order.guests) {
          let o_idx = tasks.findIndex(el => el.uid === order.uid)
          if (o_idx !== -1) tasks[o_idx].guests = gst
          order.guests = gst
        }
        order.docTable = new_table

        /*let tabItem={...docTable[order.curent]}
        tabItem.guest=data
        docTable[order.curent]=tabItem
        tasks=this.modTask(order.uid,order.id,tabItem)
        if(data>order.guests) {
          let o_idx=tasks.findIndex(el=>el.uid===order.uid) 
          if(o_idx!==-1) tasks[o_idx].guests=data
          order.guests=data
        }
  
        order.docTable=docTable*/
      } else {
        let max_nom = order.guests
        max_nom++
        let btns = []
        for (let i = 1; i <= max_nom; i++) btns.push({ caption: localestr('Гість ') + i, action: () => this.modOrder(idx, 'guest', i) })
        this.msg_arr('', localestr('Гість'), btns)
      }
    } else if (cmd === 'delivery') {
      let deliv = null
      if (this.state.data.catMenu) deliv = this.state.data.catMenu.find(itm => itm.id === this.state.data.const.constDelivery)
      if (data) {
        if (order.status === 2) {
          this.msg(localestr('Замовлення вже було передано в доставку!'));
          return;
        }
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }

        //Додати доставку якщо треба
        if (data.delivery) {
          const tabItem = { uid: uid(), act: 'add', menu: deliv, qtt: 1, amount: data.delivery.toFixed(2), status: '2', nom: 1, guest: order.guests }
          task.docTable.push(tabItem)
          order.docTable.push(tabItem)
        }
        //Змінити статус на 2
        task.order_status = 2
        task.not_reset = 1
        order.status = 2
        //Додати курєра і його винагороду
        task.courier = data.courier
        order.courier = data.courier
        task.reward = data.reward
        order.reward = data.reward
        tasks[o_idx] = { ...task, timer: 0, status: 0 }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані
        let tasks = this.state.tasks
        let taskidx = tasks.findIndex(el => el.uid === order.uid)
        if (taskidx !== -1) {
          this.sendTask(order.uid, () => { this.modOrder(idx, cmd, data) })
          return
        }
        //перевірити чи надрукована кухня
        const printKitchen = this.state.data['const'].constPrintKitchen
        if (printKitchen === "1") {
          let kitch = order.docTable.filter(el => parseInt(el.status) === 1).length
          if (kitch) {
            if (this.state.modal) return
            this.msg(localestr('Спочатку буде надруковано кухню!'), null, [{ caption: 'OK', action: () => { this.modOrder(idx, cmd, data) } }])
            this.modOrder(idx, 'kitchen', null)
            return
          }
        }

        //Показати вікно з вибором чи добавити доставку, сумою, винагородою і курєром
        let need_delivery = true
        if (!this.state.data.const.constDelivery) need_delivery = false
        else if (order.docTable.findIndex(itm => itm.menu.id === this.state.data.const.constDelivery) !== -1) need_delivery = false
        if (!deliv) need_delivery = false
        let couriers = []
        if (this.state.data?.catUsers) couriers = this.state.data.catUsers.filter(el => el.urXprs)
        const modal = <DeliveryForm need_delivery={need_delivery} couriers={couriers} action={(d) => this.modOrder(idx, cmd, d)} setModal={this.setModal} setModal2={this.setModal2} />
        this.setState({ modal })
        return
      }
    } else if (cmd === 'courier') {
      if (order.author && order.author.id !== this.state.user_id && !parseInt(this.state.rights.urAdmin) && !parseInt(this.state.rights.urNSedit)) {
        this.msg(localestr('Чуже замовлення не можна редагувати!'))
        return
      }
      if (data) {
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.courier = data
        order.courier = data
        //тут би ще імя курєра дописати
        tasks[o_idx] = { ...task, timer: 0, status: 0 }
        //tasks=this.modTaskHead(order.uid,order.id,{courier:data})
      } else {
        if (!this.state.data.catUsers) return
        //let btns=[]
        let couriers = []
        if (this.state.data?.catUsers) couriers = this.state.data.catUsers.filter(el => el.urXprs)
        let btns = couriers.map(el => ({ caption: el.name, action: () => this.modOrder(idx, 'courier', el.id) }))
        //for(let i=1;i<=max_nom;i++) btns.push({caption:localestr('Черга подачі №')+i,action:()=>this.modOrder(idx,'courier',i)})  
        btns.push({ caption: localestr('Змінити винагороду'), action: () => this.modOrder(idx, 'reward', null) })
        this.msg_arr('', localestr('Кур\'єр'), btns)
      }
    } else if (cmd === 'set_status') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          return
        }
        if (data.msg) this.msg(data.msg)
        order.status = data.data?.header?.status
        order.payType = data.data?.header?.payType
        order.last_upd = data.data?.last_upd
      } else {
        return
      }
    } else if (cmd === 'reward') {
      if (data) {
        order.reward = data
        let tasks = this.state.tasks
        let o_idx = tasks.findIndex(el => el.uid === order.uid)
        let task = { uid: order.uid, id: order.id, docTable: [] }
        if (o_idx === -1) o_idx = tasks.length
        else task = { ...tasks[o_idx] }
        task.reward = order.reward
        tasks[o_idx] = { ...task, timer, status: 0 }
      } else {
        const modal = <Calc text={localestr("Введіть суму\nвинагороди кур'єру")} value={parseInt(order.reward)} setValue={(val) => { this.modOrder(idx, 'reward', val) }} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'advance') {
      //Показати вікно з клієнтом і полем ввести аванс
      //відправити на сервер команду на створення ордера
      //Після відповіді сервера вписати у замовлення аванс
      //Ордер має провестися і при проведенні має вписати аванс у замовлення
      if (data) {
        const userCashAccount = parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox
        load('action=addStatementItem&data=' + encodeURIComponent(JSON.stringify({ account: userCashAccount, operation: 4, correspond: order.discount ? order.discount.id : null, article: 0, amount: data, docum: 1000000000 + parseInt(order.id) })), (d) => { this.modOrder(idx, 'set_advance', { ...d }) })
      } else {
        if (order.advance) {
          this.msg(localestr('Для цього замовлення вже введено аванс!'))
          return
        }
        if (!order.id) {
          this.msg(localestr('Замовлення ще не збережено!'))
          return
        }
        const modal = <Calc value={0} caption={localestr('Сума авансу')} text={localestr('Введіть суму авансу')} setValue={(val) => { this.modOrder(idx, 'advance', val) }} setModal={this.setModal} />
        this.setState({ modal })
      }
    } else if (cmd === 'set_advance') {
      //console.log('set_advance', data)
      if (data.status === 'error') {
        this.msg(localestr(data.msg), localestr('Помилка'))
        return
      }
      order.advance = data.amount
      this.msg(localestr('Операція успішна!'))
    } else {
      this.msg('Команда ' + cmd + ' не реалізована')
    }

    //if(cmd!=='kitchen' && cmd!=='precheck') order.last_upd=(new Date()).toISOString()
    /*if(cmd!=='kitchen' && cmd!=='kitchenque' && cmd!=='precheck')*/ order.update = (new Date()).toISOString()
    const orders = this.state.orders.map(el => { if (el.uid === order.uid) return order; else return el })
    const windows = this.state.windows.map((el, index) => {
      if (index === idx) {
        return { ...el, data: order, caption: this.getOrderCaption(order) }
      } else return el
    })
    this.setState({ windows, orders, tasks, jobPrint, stoplist })
    this.setCurentDB(orders)

    //Logger.log(cmd, order,  {tasks,jobPrint},   'modOrder кінець')
    //Logger.exportLogs();
  }

  modTask = (uid, id, data, timer = 5) => {
    // Беремо задачі
    let tasks = this.state.tasks
    // Шукаємо задачу по uid
    let o_idx = tasks.findIndex(el => el.uid === uid && el.sended !== true)
    let task = { uid, id, docTable: [] }
    if (o_idx === -1) o_idx = tasks.length
    else task = { ...tasks[o_idx] }
    let docTable = [...task.docTable]
    // Шукаємо рядок у таблиці
    let t_idx = docTable.findIndex(el => el.uid === data.uid)
    let item = {}
    if (t_idx === -1) t_idx = docTable.length
    else item = docTable[t_idx]
    // Оновлюємо рядок
    item = { ...item, ...data }
    docTable[t_idx] = item
    // Видаляємо рядки, позначені для видалення, якщо вони нові
    docTable = docTable.filter(el => el.act !== 'del' || el.id)
    task.docTable = docTable
    tasks[o_idx] = { ...task, timer, status: 0 }
    return tasks
  }

  modTask2 = (uid, id, data, tasks, timer = 10, act = null) => {
    // Шукаємо задачу по id або uid
    let o_idx = -1
    if (id) o_idx = tasks.findIndex(el => el.id === id && el.sended !== true)
    else o_idx = tasks.findIndex(el => el.uid === uid && el.sended !== true)
    let task = { uid, id, docTable: [] }
    if (o_idx === -1) o_idx = tasks.length
    else task = { ...tasks[o_idx] }
    let docTable = [...task.docTable]
    // Шукаємо рядок по id або uid
    let t_idx = -1
    if (data.id) t_idx = docTable.findIndex(el => el.id === data.id)
    else t_idx = docTable.findIndex(el => el.uid === data.uid)
    let item = {}
    if (t_idx === -1) t_idx = docTable.length
    else item = docTable[t_idx]
    // Оновлюємо рядок
    item = { ...item, ...data }
    docTable[t_idx] = item
    // Видаляємо рядки, позначені для видалення, якщо вони нові
    docTable = docTable.filter(el => el.act !== 'del' || el.id)
    task.docTable = docTable
    if (act) task.act = act
    tasks[o_idx] = { ...task, timer, status: 0 }
  }

  modTaskHead = (uid, id, data, timer = 5) => {
    // Беремо задачі
    let tasks = this.state.tasks
    // Шукаємо задачу по uid
    let o_idx = tasks.findIndex(el => el.uid === uid)
    let task = { uid, id, ...data }
    if (o_idx === -1) o_idx = tasks.length
    else task = { ...tasks[o_idx], ...data }
    // Оновлюємо задачу з таймером
    tasks[o_idx] = { ...task, timer }
    return tasks
  }

  sendTask = (uid, action) => {
    if (busy) {
      setTimeout(() => this.sendTask(uid, action), 100)
      busy = false
      return
    }
    let tasks = [...this.state.tasks]
    let task_idx = tasks.findIndex(el => el.uid === uid)
    if (task_idx === -1) return
    let task = { ...tasks[task_idx] }
    if (task.sended) {
      //task.sended=undefined
      //tasks[task_idx]=task
      //this.setState({tasks})
      return
    }
    task.sended = true
    //перевірити щоб була заповнена шапка
    //Logger.log('sendTask', task,  {uid,action},   'modOrder кінець')
    let order = this.state.orders.find(el => el.uid === uid)

    if (!task.id) {
      //const order=this.state.orders.find(el=>el.uid===uid) 
      if (order) {
        if (!task.date) task.date = order.date
        if (!task.table) if (order.table) task.table = order.table
        if (!task.discount) if (order.discount) task.discount = order.discount
        if (!task.docType) task.docType = order.docType
        if (!task.phone) if (order.phone) task.phone = order.phone
        if (!task.address) if (order.address) task.address = order.address
        if (!task.author) task.author = order.author
      }
    } else {
      //const order=this.state.orders.find(el=>el.uid===uid) 
      if (order) {
        if (!task.last_upd) task.last_upd = order.last_upd
        if (!task.update) task.update = order.update
      }
    }
    tasks[task_idx] = task
    let task2 = null
    if (task.slave) { //Здвоєне завдання
      let task_idx = tasks.findIndex(el => el.uid === task.slave)
      if (task_idx !== -1) {
        task2 = { ...tasks[task_idx] }
        task2.sended = true
        if (!task2.id) {
          const order = this.state.orders.find(el => el.uid === task2.uid)
          if (order) {
            if (!task2.date) task2.date = order.date
            if (!task2.table) if (order.table) task2.table = order.table
            if (!task2.discount) if (order.discount) task2.discount = order.discount
            if (!task2.docType) task2.docType = order.docType
            if (!task2.phone) if (order.phone) task2.phone = order.phone
            if (!task2.address) if (order.address) task2.address = order.address
            if (!task2.author) task2.author = order.author
          }
        }
        tasks[task_idx] = task2
      }
    }
    this.setState({ tasks })

    let header = { ...task }
    delete header.uid
    delete header.timer
    delete header.sum
    delete header.status
    if (header.table) header.table = { id: header.table.id }
    if (header.discount) header.discount = { id: header.discount.id }
    delete header.docTable
    if (header.order_status) header.status = header.order_status
    let table = [...task.docTable]
    table = table.map(el => {
      const new_el = { ...el }
      if (new_el.menu) new_el.menu = { id: new_el.menu.id }
      return new_el
    })
    if (task2) {
      let header2 = { ...task2 }
      delete header2.uid
      delete header2.timer
      delete header2.sum
      delete header2.status
      if (header2.table) header2.table = { id: header2.table.id }
      if (header2.discount) header2.discount = { id: header2.discount.id }
      delete header2.docTable
      let table2 = [...task2.docTable]
      table2 = table2.map(el => {
        const new_el = { ...el }
        if (new_el.menu) new_el.menu = { id: new_el.menu.id }
        return new_el
      })
      load('action=modOrder&data=' + encodeURIComponent(JSON.stringify({ header, table, header2, table2 })), (d) => { this.runTask(uid, d, action) })
    } else load('action=modOrder&data=' + encodeURIComponent(JSON.stringify({ header, table })), (d) => { this.runTask(uid, d, action) })
    sended = true
    setTimeout(() => sended = null, 1500)
    timer = 5
    //Logger.exportLogs();
  }

  runTask = (uid, data, act) => {
    const status = data.status;
    let tasks = [...this.state.tasks];
    let orders = [...this.state.orders];
    let jobPrint = [...this.state.jobPrint];
    const idx = tasks.findIndex(el => el.uid === uid);

    //Logger.log('runTask',  tasks[idx],  {uid, data, act},   'modOrder кінець')

    if (status === 'error') {
      this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'));
      if (idx !== -1) {
        tasks[idx] = { ...tasks[idx], timer: 10, status: 2, sended: undefined };
        this.setState({ tasks });
      }
      return;
    } else if (status === 'OffLine') {
      if (idx !== -1) {
        tasks[idx] = { ...tasks[idx], timer: 10, sended: undefined };
      }
      timer = 5;
      this.setState({ status, tasks });
      if (act) act();
      return;
    } else if (status === 'modOk') {
      if (data.msg) this.msg(data.msg, localestr('Повідомлення'));

      //Блокуємо можливість оновлювати стейт доки не виконається цей код
      busy = true
      setTimeout(() => busy = false, 150)

      let chng = false;
      const last_upd = data.data?.last_upd;
      const header = data.data || {};
      const docTable = data.data?.table || [];
      const header2 = data.data2 || {};
      const slave = idx !== -1 ? tasks[idx].slave : null;

      let orderIdx = orders.findIndex(el => el.uid === uid);
      //Попробуємо пошукати по id
      if (orderIdx === -1) {
        if (act) act();
        if (idx !== -1) tasks.splice(idx, 1);
        this.setState({ tasks });
        //Logger.log('runTask',  tasks[idx],  {uid, data, act},   'не знайдено ордер')
        //Logger.exportLogs();
        return;
      } else delete orders[orderIdx].slave

      if (last_upd) {
        orders[orderIdx].last_upd = last_upd;
        chng = true;
      }

      if (header.reset_status) orders[orderIdx].status = 0

      //Logger.log('runTask',  idx,  {uid, data, act, tasks:[...tasks]},   'До зміни ордера')
      if (idx !== -1) tasks.splice(idx, 1);

      const jobIdx = jobPrint.findIndex(el => el.uid === uid);
      if (!orders[orderIdx].id && header.id) {
        chng = true;
        const duplicateIdx = orders.findIndex((el, i) => el.id === header.id && i > orderIdx);
        //const duplicateIdx = orders.findIndex(el => el.id === header.id && el.id !== orderIdx);
        if (duplicateIdx !== -1) {
          orders.splice(duplicateIdx, 1);
          /*const newOrderIdx = orders.findIndex(el => el.uid === uid);
          if(newOrderIdx !== -1) {
            orderIdx=newOrderIdx
            orders[orderIdx].id = header.id;
            orders[orderIdx].uid = header.id;
          }*/
        }// else {
        orders[orderIdx].id = header.id;
        orders[orderIdx].uid = header.id;
        //}
        if (jobIdx !== -1) {
          jobPrint[jobIdx].id = header.id;
          jobPrint[jobIdx].uid = header.id;
        }
        tasks = tasks.map(el => (el.uid === uid ? { ...el, uid: header.id, id: header.id } : { ...el }))
      }

      // Оновлюємо res_marks
      res_marks = res_marks.map(el =>
        el.ord_uid === uid && !el.ord_id && header.id
          ? { ...el, ord_uid: header.id, ord_id: header.id }
          : el
      );

      // Оновлюємо таблицю замовлення
      orders[orderIdx].docTable = orders[orderIdx].docTable.map(row => {
        if (!row.id) {
          let tableIdx = docTable.findIndex(el => el.uid === row.uid);
          //if (tableIdx === -1) tableIdx = docTable.findIndex(el => el.id === row.uid);
          if (tableIdx !== -1) {
            chng = true;
            return { ...row, id: docTable[tableIdx].id, uid: docTable[tableIdx].id };
          }
        }
        return row;
      });

      // Додаємо або оновлюємо рядки таблиці
      docTable.forEach(tableRow => {
        const rowIdx = orders[orderIdx].docTable.findIndex(el => el.id === tableRow.id || el.uid === tableRow.uid);
        const catMenu = this.state.data['catMenu'] || [];
        const menu = catMenu.find(dt => dt.id === tableRow.menu);
        if (rowIdx !== -1 && tableRow.act === 'upd') {
          orders[orderIdx].docTable[rowIdx] = { ...orders[orderIdx].docTable[rowIdx], ...tableRow, menu };
          chng = true;
        } else if (rowIdx === -1 && tableRow.act === 'upd') {
          orders[orderIdx].docTable.push({ ...tableRow, menu });
          chng = true;
        } else if (rowIdx === -1 && tableRow.act !== 'del') {
          orders[orderIdx].docTable.push({ ...tableRow });
          chng = true;
        }
      });

      // Оновлюємо jobPrint
      if (jobIdx !== -1) {
        jobPrint[jobIdx].docTable = jobPrint[jobIdx].docTable.map(row => {
          if (!row.id) {
            const tableIdx = docTable.findIndex(el => el.uid === row.uid);
            if (tableIdx !== -1) {
              chng = true;
              return { ...row, id: docTable[tableIdx].id, uid: docTable[tableIdx].id };
            }
          }
          return row;
        });
      }

      // Якщо є зв’язана задача
      if (slave && header2) {
        const docTable2 = data.data2?.table || [];
        const slaveTaskIdx = tasks.findIndex(el => el.uid === slave);
        if (slaveTaskIdx !== -1) tasks.splice(slaveTaskIdx, 1);

        let slaveOrderIdx = orders.findIndex(el => el.uid === slave);
        if (slaveOrderIdx !== -1) {
          if (last_upd) {
            orders[slaveOrderIdx].last_upd = last_upd;
            delete orders[slaveOrderIdx].break;
            chng = true;
          }

          const slaveJobIdx = jobPrint.findIndex(el => el.uid === slave);
          if (!orders[slaveOrderIdx].id && header2.id) {
            chng = true;
            const duplicateIdx = orders.findIndex((el, i) => el.id === header2.id && i > slaveOrderIdx);
            //const duplicateIdx = orders.findIndex(el => el.id === header2.id && el.id !==slaveOrderIdx);
            if (duplicateIdx !== -1) {
              orders.splice(duplicateIdx, 1);
              /*const newSlaveIdx = orders.findIndex(el => el.uid === slave);
              orders[newSlaveIdx].id = header2.id;
              orders[newSlaveIdx].uid = header2.id;*/
            } //else {
            orders[slaveOrderIdx].id = header2.id;
            orders[slaveOrderIdx].uid = header2.id;
            //}
            if (slaveJobIdx !== -1) {
              jobPrint[slaveJobIdx].id = header2.id;
              jobPrint[slaveJobIdx].uid = header2.id;
            }
            tasks = tasks.map(el => (el.uid === slave ? { ...el, uid: header2.id, id: header2.id } : { ...el }))
          }

          res_marks = res_marks.map(el =>
            el.ord_uid === slave && !el.ord_id && header2.id
              ? { ...el, ord_uid: header2.id, ord_id: header2.id }
              : el
          );

          // Оновлюємо таблицю замовлення
          orders[slaveOrderIdx].docTable = orders[slaveOrderIdx].docTable.map(row => {
            if (!row.id) {
              const tableIdx = docTable2.findIndex(el => el.uid === row.uid);
              if (tableIdx !== -1) {
                chng = true;
                return { ...row, id: docTable2[tableIdx].id, uid: docTable2[tableIdx].id };
              }
            }
            return row
          })

          // Додаємо або оновлюємо рядки таблиці
          docTable2.forEach(tableRow => {
            const rowIdx = orders[slaveOrderIdx].docTable.findIndex(el => el.id === tableRow.id || el.uid === tableRow.uid);
            const catMenu = this.state.data['catMenu'] || [];
            const menu = catMenu.find(dt => dt.id === tableRow.menu);
            if (rowIdx !== -1 && tableRow.act === 'upd') {
              orders[slaveOrderIdx].docTable[rowIdx] = { ...orders[slaveOrderIdx].docTable[rowIdx], ...tableRow, menu };
              chng = true;
            } else if (rowIdx === -1 && tableRow.act === 'upd') {
              orders[slaveOrderIdx].docTable.push({ ...tableRow, menu });
              chng = true;
            } else if (rowIdx === -1 && tableRow.act !== 'del') {
              orders[slaveOrderIdx].docTable.push({ ...tableRow });
              chng = true;
            }
          });


          if (slaveJobIdx !== -1) {
            jobPrint[slaveJobIdx].docTable = jobPrint[slaveJobIdx].docTable.map(row => {
              if (!row.id) {
                const tableIdx = docTable2.findIndex(el => el.uid === row.uid);
                if (tableIdx !== -1) {
                  chng = true;
                  return { ...row, id: docTable2[tableIdx].id, uid: docTable2[tableIdx].id };
                }
              }
              return row;
            });
          }
        }
      }

      // Якщо були зміни - оновлюємо стан
      if (chng) {
        const windows = this.setWindows(orders);
        this.setState({ orders, windows, tasks, jobPrint });
        this.setCurentDB(orders);
      } else {
        this.setState({ tasks });
      }
      // Виконуємо дію з затримкою
      if (act) setTimeout(() => act(), 80);
      //Logger.log('runTask',  [...orders],  {uid, tasks:tasks},   'Після зміни ордера')
    }
    //Logger.exportLogs();
  };

  modMarks = (ord_uid, ord_id, code, good, qtt, vol = 1000) => {
    if (!code) return
    if (!qtt) return
    let marks = [...this.state.marks || []]
    if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
      let last_upd = (new Date()).toISOString().substring(0, 19) + 'Z'
      let idx = marks.findIndex(el => el.code === code)
      if (idx === -1) marks.push({ code, good, vol, qtt, last_upd })
      else { marks[idx].qtt = (marks[idx].qtt || 0) + qtt; marks[idx].last_upd = last_upd; vol = marks[idx].vol }
      this.setMarksDB(marks)
      this.setState({ marks })
      idx = res_marks.findIndex(el => el.ord_uid === ord_uid && el.code === code && !el.sended)
      if (idx === -1) res_marks.push({ uid: uid(), ord_uid, ord_id, code, good, vol, qtt, last_upd })
      else { res_marks[idx].qtt = (res_marks[idx].qtt || 0) + qtt; res_marks[idx].last_upd = last_upd }
    }
  }

  setWindows = (orders) => {
    let windows = []
    if (this.state.rights.urAdmin || this.state.rights.urOrder)
      windows = orders.map(el => { return { caption: this.getOrderCaption(el), wndType: 'orderTab', data: el } })
    else
      windows = orders.filter(el => el.author.id === this.state.user_id).map(el => { return { caption: this.getOrderCaption(el), wndType: 'orderTab', data: el } })
    if (this.state.rights && (this.state.rights.urPickup || this.state.rights.urAdmin)) windows.unshift({ caption: localestr('Самовивіз'), wndType: 'pickupTab', data: { uid: 'pcp' } })
    if (this.state.rights && (this.state.rights.urDelivery || this.state.rights.urAdmin)) windows.unshift({ caption: localestr('Доставка'), wndType: 'deliveryTab', data: { uid: 'dlv' } })
    if (this.state.rights && (this.state.rights.urBanquet || this.state.rights.urAdmin)) windows.unshift({ caption: localestr('Попередні'), wndType: 'banquetTab', data: { uid: 'bnq' } })
    if (this.state.rights && (this.state.rights.urInner_work || this.state.rights.urAdmin)) windows.unshift({ caption: localestr('Столи'), wndType: 'tablesTab', data: { uid: 'tbl' } })
    return windows
  }

  showOrder = id => {
    const windows = [...this.state.windows]
    const idx = windows.findIndex(el => el.data?.uid === id)
    if (idx !== -1) {
      windows[idx].data.news = false
      this.setState({ activeWindow: idx, windows })
    }
  }

  getOnlineOrder = (id, data, call) => {
    if (data) {
      const status = data.status
      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'))
        return
      } else if (status === 'OffLine') {
        this.setState({ status })
        return
      } else if (status === 'UsrChoise') {
        this.setLogin(data)
        return
      }
      this.setState({ pause_msg: 3 })
      load('action=getCurrentData&data=' + JSON.stringify({ update: this.state.update, date: new Date() }), (d) => { this.loadData(d, 'getCurrentData'); setTimeout(() => { this.showOrder(id) }, 200) })
    } else {
      push_id = null
      let data = id;
      if (call) data = JSON.stringify({ call: true, id })
      load('action=getOnlineOrder&data=' + data, (d) => { this.getOnlineOrder(id, d) })
    }
  }

  updOnlineOrder = (id, data, call) => {
    if (data) {
      const status = data.status
      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'))
        return
      } else if (status === 'OffLine') {
        this.setState({ status })
        return
      } else if (status === 'UsrChoise') {
        this.setLogin(data)
        return
      }
      this.setState({ pause_msg: 3 })
    } else {
      push_id = null
      load('action=updOnlineOrder&data=' + id, (d) => { this.updOnlineOrder(id, d); setTimeout(() => { this.showOrder(id) }, 200) })
    }
  }

  showOnlineOrder = ord => {
    if (this.state.modal) return
    if (ord?.callType) {
      let text = '';
      if (ord.callType === 1 && !ord.userId) {
        text = `Гості викликають офіціанта до столика ${ord?.name ?? ''}`;
      } else if (ord.callType === 1 && Number(ord.userId) === Number(this.state.user_id)) {
        text = `Будь ласка, підійдіть до столика ${ord?.name ?? ''}`;
      } else if (ord.callType === 2 && Number(ord.userId) === Number(this.state.user_id)) {
        text = `Гості просять рахунок, підійдіть до столика  ${ord?.name ?? ''}`;
      } else if (ord.callType === 3 && Number(ord.userId) === Number(this.state.user_id)) {
        text = `Кур'єр виконав замовлення № ${ord.tableId ?? ''}`;
        if (ord.text) text = ord.text
      }
      let cont = <div> {text} </div>
      push_id = ord.id
      this.msg_sound(cont, localestr('Виклик офіціанта'), sound4, [{ caption: localestr('Підтвердити'), action: () => this.getOnlineOrder(ord.id, null, true) }])
    } else {
      let header = ''
      if (ord.docType === 0) header += ord.table.owner?.name + ' ' + localestr('стіл') + ' ' + ord.table?.name
      if (ord.docType === 1) header += localestr('Доставка') + ' ' + (ord.address || '') + "\n" + localestr('Телефон') + ' ' + ord.phone + ' ' + ord?.name
      if (ord.docType === 2) header += localestr('Самовивіз') + ' ' + localestr('Телефон') + ' ' + ord.phone + ' ' + ord?.name
      if (ord.comment) header += "\n" + ord.comment
      if (ord.author?.id) header += "\n" + localestr('Гості зробили додаткове замовлення')

      let total = 0
      let items = (ord.docTable || []).map((el, idx) => {
        let menu = (this.state.data.catMenu || []).find(it => it.id === el.menu)
        if (!menu) menu = { name: el.menu_name || '' }
        total += parseFloat(el.amount)
        return <tr key={idx}><td style={{ width: '100%' }}>{menu?.name}</td><td style={{ minWidth: '50px', textAlign: 'right' }}>{el.qtt}</td><td style={{ minWidth: '60px', textAlign: 'right' }}>{el.amount}</td></tr>
      })

      let cont = <div><div style={{ fontSize: 'large', fontWeight: '500' }}>{header}</div><table><tbody>{items}</tbody></table>
        <div style={{ display: 'flex', fontWeight: '500', margin: '2px' }}><div style={{ width: '100%' }}>{localestr('Разом')}</div><div>{total.toFixed(2)}</div></div></div>
      push_id = ord.id
      if (ord.author?.id) this.msg_sound(cont, localestr('Онлайн замовлення') + ' №' + ord.id, sound4, [{ caption: localestr('Ознайомитись'), action: () => this.updOnlineOrder(ord.id) }, { caption: localestr('Пізніше'), action: () => { this.setState({ pause_msg: 36 }) } }])
      else this.msg_sound(cont, localestr('Онлайн замовлення') + ' №' + ord.id, sound4, [{ caption: localestr('Взяти'), action: () => this.getOnlineOrder(ord.id) }, { caption: localestr('Пізніше'), action: () => { this.setState({ pause_msg: 36 }) } }])
    }
  }

  loadData = (data, idx) => {
    if (idx === '') {
      this.setState({ status: 'loading' });
      loaddat("action=getStartData", (d) => { this.loadData(d, 'startData'); });
    } else if (idx === 'startData') {
      const status = data.status;
      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'));
        this.setState({ status: 'Stop' });
        return;
      } else if (status === 'OffLine') {
        this.setState({ status });
        this.getStartDB();
        return;
      } else if (status === 'UsrChoise') {
        this.setLogin(data);
        return;
      }

      //let newData = this.state.data;
      let newData = { ...this.state.data };
      newData['catHalls'] = data.catHalls;
      const allTables = data.catTables;
      let newHalls = [];
      if (newData['catHalls']) {
        newHalls = newData['catHalls'].map((col) => {
          const tables = allTables.filter(el => String(el.owner.id) === String(col.id));
          col['tables'] = tables;
          return col;
        });
        newData['catHalls'] = newHalls;
      }

      newData['catMenu'] = data.catMenu;
      newData['fldMenu'] = data.fldMenu;
      newData['catDiscounts'] = data.catDiscounts;
      newData['fldDiscounts'] = data.fldDiscounts;
      newData['catDevices'] = data.catDevices;
      newData['catDepartments'] = data.catDepartments;
      newData['const'] = data.const;
      newData['catReasons'] = data.catReasons;
      newData['catTexts'] = data.catTexts;
      newData['catUsers'] = data.catUsers;
      newData['printers'] = data.printers || null;
      newData['catCashAccs'] = data.catCashAccs;
      newData['catArticles'] = data.catArticles;
      newData['catCounterparties'] = data.catCounterparties;
      newData['cities'] = data.cities;
      newData['additional'] = data.additional;

      const goods = data.catMenu;
      const modifiers = data.modifiers || [];
      for (let i = 0; i < modifiers.length; i++) {
        const item = modifiers[i];
        if (item.isfolder) {
          let moded = goods.filter(el => String(el.parent?.id) === String(item.id));
          if (item.child) {
            for (let k = 0; k < item.child.length; k++) {
              moded = moded.concat(goods.filter(el => String(el.parent?.id) === String(item.child[k])));
            }
          }
          for (let k = 0; k < moded.length; k++) {
            if (!moded[k].modifiers) moded[k].modifiers = [];
            moded[k].modifiers = moded[k].modifiers.concat(item.modifiers);
          }
        } else {
          const idx = goods.findIndex(el => String(el.id) === String(item.id));
          if (idx === -1) continue;
          if (!goods[idx].modifiers) goods[idx].modifiers = [];
          goods[idx].modifiers = goods[idx].modifiers.concat(item.modifiers);
        }
      }
      newData['catMenu'] = goods;

      this.setState({ status, data: newData, update: undefined });
      this.setStartDB({
        catHalls: newHalls, catMenu: data.catMenu, fldMenu: data.fldMenu, catDiscounts: data.catDiscounts,
        fldDiscounts: data.fldDiscounts, catDevices: data.catDevices, catDepartments: data.catDepartments,
        const: data.const, catReasons: data.catReasons, catTexts: data.catTexts, catUsers: data.catUsers,
        printers: data.printers, catCashAccs: data.catCashAccs, catArticles: data.catArticles,
        catCounterparties: data.catCounterparties, cities: data.cities, additional: data.additional
      });
      this.loadData('', 'startDataOk');
    } else if (idx === 'startDataOk') {
      /*if (!this.state.data || !this.state.data.catHalls || !this.state.data.catHalls.length) {
        setTimeout(() => this.loadData('', ''), 3000);
        return;
      }*/
      this.getCurentDB();
      if (this.state.data?.const?.constExciseMark) this.getMarksDB();
      load('action=getCurrentData&data=' + JSON.stringify({ update: null, date: new Date() }), (d) => {
        this.loadData(d, 'getCurrentData');
      });
    } else if (idx === 'getCurrentData') {
      const status = data.status;
      let activeOrder = null;
      if (this.state.activeWindow && this.state.windows[this.state.activeWindow]?.data?.uid) {
        activeOrder = this.state.windows[this.state.activeWindow].data.uid;
      }

      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'));
        this.setState({ status: 'Stop' });
        timer = 15;
        return;
      } else if (status === 'OffLine') {
        if (this.state.orders.length === 0) this.getCurentDB();
        if (this.state.windows.length === 0) {
          const windows = this.setWindows([]);
          const activeWindow = Math.min(this.state.activeWindow, windows.length - 1);
          this.setState({ status, windows, activeWindow });
        } else {
          this.setState({ status });
        }
        timer = this.state.tasks.length !== 0 ? 3 : 5;
        return;
      } else if (status === 'UsrChoise') {
        this.setState({ status, loginData: data, rights: {}, update: '', windows: [], orders: [], hall: '0', activeWindow: 0, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: [], courierTrn: [] })
        return;
      }

      timer = 15;
      let need_upd = status !== this.state.status
      let marks = this.state.marks; //Оновимо акцизні марки
      if (this.state.data?.const?.constExciseMark) {
        let old_marks = marks || [];
        let new_marks = data.marks || [];
        const date_now = new Date();
        const minus15min = new Date(date_now.setMinutes(date_now.getMinutes() - 15)).toISOString().substring(0, 10);
        old_marks.forEach((el, ind) => {
          const idx = new_marks.findIndex(dt => String(dt.code) === String(el.code));
          if (idx !== -1) {
            if (!new_marks[idx].vol) new_marks[idx].vol = el.vol;
            if (el.last_upd <= new_marks[idx].last_upd || el.last_upd <= minus15min) {
              old_marks[ind] = { ...new_marks[idx] }
              need_upd = true
            }
            new_marks.splice(idx, 1);
          } else if (el.last_upd < minus15min) {
            old_marks[ind].del = true
            need_upd = true
          } else if (!el.id && !el.qtt) {
            old_marks[ind].del = true
            need_upd = true
          }
          else if (!el.id) {
            old_marks[ind].qtt = 0
            need_upd = true
          }
        })
        if (need_upd || new_marks.length) {
          need_upd = true
          marks = old_marks.filter(el => !el.del).concat(new_marks);
          this.setMarksDB(marks);
        }
      }

      const stoplist = data.stoplist || []
      const old_stop = this.state.stoplist || []
      if (!need_upd) { //перевіримо чи треба оновити стоплист
        if (stoplist.length !== old_stop.length) need_upd = true
        else {
          for (let i = 0; i < stoplist.length; i++) {
            if (stoplist[i].good !== old_stop[i].good || stoplist[i].qtt !== old_stop[i].qtt) {
              need_upd = true
              break
            }
          }
        }
      }
      let news = false;
      //Оновлення довідників
      let need_update = false;
      let newData = { ...this.state.data };
      if (data.catMenu) {
        need_update = true;
        newData['fldMenu'] = data.fldMenu || []
        const goods = data.catMenu || []
        const modifiers = data.modifiers || []
        for (let i = 0; i < modifiers.length; i++) {
          const item = modifiers[i];
          if (item.isfolder) {
            let moded = goods.filter(el => String(el.parent.id) === String(item.id));
            if (item.child) {
              for (let k = 0; k < item.child.length; k++) {
                moded = moded.concat(goods.filter(el => String(el.parent.id) === String(item.child[k])));
              }
            }
            for (let k = 0; k < moded.length; k++) {
              if (!moded[k].modifiers) moded[k].modifiers = [];
              moded[k].modifiers = moded[k].modifiers.concat(item.modifiers);
            }
          } else {
            const idx = goods.findIndex(el => String(el.id) === String(item.id));
            if (idx === -1) continue;
            if (!goods[idx].modifiers) goods[idx].modifiers = [];
            goods[idx].modifiers = goods[idx].modifiers.concat(item.modifiers);
          }
        }
        newData['catMenu'] = goods
      }
      if (data.catHalls) {
        need_update = true
        const allTables = data.catTables || []
        newData['catHalls'] = data.catHalls.map((col) => {
          const tables = allTables.filter(el => String(el.owner.id) === String(col.id));
          col['tables'] = tables;
          return col;
        });
      }
      if (data.catDiscounts) {
        need_update = true;
        newData['catDiscounts'] = data.catDiscounts;
        newData['fldDiscounts'] = data.fldDiscounts;
      }
      if (data.catDevices) {
        need_update = true;
        newData['catDevices'] = data.catDevices;
        newData['printers'] = data.printers || null;
      }
      if (data.catDepartments) {
        need_update = true;
        newData['catDepartments'] = data.catDepartments;
      }
      if (data.const) {
        need_update = true;
        newData['const'] = data.const;
      }
      if (need_update) {
        setTimeout(() => this.setState({ data: newData, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] }), 500);
        this.setStartDB({
          catHalls: newData['catHalls'], catMenu: newData['catMenu'], fldMenu: newData['fldMenu'],
          catDiscounts: newData['catDiscounts'], fldDiscounts: newData['fldDiscounts'], catDevices: newData['catDevices'],
          catDepartments: newData['catDepartments'], const: newData['const'], catReasons: newData['catReasons'],
          catTexts: newData['catTexts'], catUsers: newData['catUsers'], printers: newData['printers'],
          catCashAccs: newData['catCashAccs'], catArticles: newData['catArticles'], catCounterparties: newData['catCounterparties'],
          cities: newData['cities']
        });
      }

      //Виклики офіціантів
      //if (data.calls && data.calls.length !== 0 && !push_id && this.state.rights?.urInner_work) {
      if (data.calls && data.calls.length !== 0) {
        for (let i = 0; i < data.calls.length; i++) {
          const call = { ...data.calls[i] }
          if (call.callType < 3 && !this.state.rights?.urInner_work) continue
          if (call.callType && (Number(call.userId) === Number(this.state.user_id) || !call.userId)) {
            if (call.callType === 3) {
              const ord = this.state.orders.find(el => el.id === call.tableId)
              if (ord) call.text = (ord.courier_name || '') + ' ' + localestr('виконав замовлення №') + ord.id + "\n" + (ord.phone || '') + ' ' + (ord.name || '') + "\n" + (ord.address || '') + "\n" + (ord.finish_to ? (localestr('на') + ' ' + ord.finish_to + ' ') : '') + parseFloat(ord.sum).toFixed(2)
            }
            setTimeout(() => this.showOnlineOrder(call), 300)
            break
          }
        }
      }

      //Онлайн замовлення
      let pause_msg = this.state.pause_msg || null
      if (data.onlineOrd?.length && !push_id && !pause_msg) {

        let onlOrder = { ...data.onlineOrd[0] };
        let docTable = data.tables.filter(dt => String(dt.pid) === String(onlOrder.id));
        onlOrder.docTable = docTable;
        setTimeout(() => this.showOnlineOrder(onlOrder), 300)
      }
      if (pause_msg) {
        pause_msg--
        need_upd = true
      }

      if (!data.headers) {
        this.setState({ status, stoplist, marks, windows: this.setWindows(this.state.orders || []), locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] });
        return;
      }

      if (data.headers.length === 0) {
        let orders = [...this.state.orders];
        if (data?.firstFetch) {
          //orders = []
          orders = orders.filter(el => !el.id)
          this.setState({ status, stoplist, orders, marks, windows: this.setWindows(orders), pause_msg, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] })
        } else if (need_upd) this.setState({ status, stoplist, marks, pause_msg, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] })
        else this.setState({ locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] })
        if (data.msg) setTimeout(() => this.msg(data.msg, localestr('Повідомлення')), 250)
        return;
      }

      const catMenu = this.state.data['catMenu'];
      const catDiscounts = this.state.data['catDiscounts'];
      let oldOrders = this.state.orders;
      if (!catMenu) {
        if (need_upd) this.setState({ status, stoplist, marks, windows: this.state.windows.length === 0 ? this.setWindows(this.state.orders) : this.state.windows, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] });
        return;
      }

      let newOrders = data.headers.map(el => {
        let sum = 0;
        const idx = oldOrders.findIndex(dt => String(dt.id) === String(el.id));
        if (idx !== -1) {
          el.parent = oldOrders[idx].parent;
          el.curent = oldOrders[idx].curent;
        }
        let docTable = data.tables.filter(dt => String(dt.pid) === String(el.id));
        sum = docTable.reduce((sum, el) => el.refuse ? sum : sum + parseFloat(el.amount || 0), 0);
        docTable = docTable.map(el => {
          const uid = el.id;
          const menu = catMenu.find(dt => String(dt.id) === String(el.menu));
          return { uid, ...el, menu };
        });
        return el.discount ? { ...el, docTable, sum, discount: catDiscounts.find(dt => String(dt.id) === String(el.discount)) }
          : { docTable, sum, ...el };
      });

      let tasks = this.state.tasks;
      oldOrders.forEach((el, ind) => {
        oldOrders[ind].news = false;
        const idx = newOrders.findIndex(dt => String(dt.id) === String(el.id));
        if (idx !== -1) {
          const task_idx = tasks.findIndex(dt => String(dt.uid) === String(el.uid));
          if (task_idx === -1) {
            if (el.last_upd < newOrders[idx].last_upd) {
              news = true;
              oldOrders[ind] = { ...el, ...newOrders[idx], uid: newOrders[idx].id, news: true };
            } else if (el.last_upd === newOrders[idx].last_upd && el.update > newOrders[idx].last_upd && parseFloat(el.sum) !== parseFloat(newOrders[idx].sum)) {
              const new_docTable = newOrders[idx].docTable.map(dt => {
                const old_dt = el.docTable.find(odt => String(odt.uid) === String(dt.uid));
                if (old_dt) return { ...old_dt };
                return { ...dt, act: 'del' };
              });
              const id = tasks.findIndex(dt => String(dt.uid) === String(el.uid) || String(dt.id) === String(el.id));
              if (id === -1) tasks.push({ timer: el.break ? 50 : 10, status: 0, ...el, docTable: new_docTable });
              else tasks[id] = { timer: el.break ? 50 : 10, status: 0, ...el, docTable: new_docTable };
            } else {
              oldOrders[ind] = { ...el, ...newOrders[idx], uid: newOrders[idx].id };
            }
          } else if (tasks[task_idx].last_upd < newOrders[idx].last_upd) {
            news = true;
            oldOrders[ind] = { ...el, ...newOrders[idx], uid: newOrders[idx].id, news: true };
            tasks.splice(task_idx, 1);
          }
          newOrders.splice(idx, 1);
        } else if (!el.id) {
          const idx = tasks.findIndex(dt => String(dt.uid) === String(el.uid));
          if (idx === -1) tasks.push({ timer: el.break ? 50 : 10, status: 0, ...el });
          else tasks[idx] = { timer: el.break ? 50 : 10, status: 0, ...el };
        } else if (data.firstFetch) {
          oldOrders[ind].del = 1
        }
      });

      newOrders = newOrders.map(el => {
        const uid = el.id;
        if (el.del !== 1) news = true;
        return { uid, ...el, news: true };
      });
      newOrders = oldOrders.concat(newOrders).filter(el => !el.del);

      let onlineMod = null
      for (let i = 0; i < newOrders.length; i++) {
        let kitch_status = 2;
        if (newOrders[i].docTable) {
          for (let k = 0; k < newOrders[i].docTable.length; k++) {
            const tblStatus = parseInt(newOrders[i].docTable[k].status)
            if (tblStatus < 2) kitch_status = 1;
            if (tblStatus === 0 && newOrders[i].author && newOrders[i].author.id === this.state.user_id) {
              if (!onlineMod) onlineMod = { ...newOrders[i], docTable: [] }
              if (onlineMod && onlineMod.uid === newOrders[i].uid) {
                onlineMod.docTable.push({ ...newOrders[i].docTable[k] })
                newOrders[i].docTable[k].status = '1'
              }
            }
          }
          if (!newOrders[i].docTable.length) kitch_status = 1;
        } else kitch_status = 1;
        newOrders[i].kitch_status = kitch_status - 1;
        if (newOrders[i].courier) {
          if (this.state.data?.catUsers) {
            const us = this.state.data.catUsers.find(el => el.id === newOrders[i].courier)
            if (us) newOrders[i].courier_name = us.name
          }
        }
      }

      if (onlineMod) setTimeout(() => this.showOnlineOrder(onlineMod), 300)

      this.setCurentDB(newOrders);
      const windows = this.setWindows(newOrders);
      let activeWindow = Math.min(this.state.activeWindow, windows.length - 1);
      if (this.state.newWindow) {
        const idx = windows.findIndex(el => String(el.data?.uid) === String(this.state.newWindow));
        if (idx !== -1) activeWindow = idx;
      } else if (activeOrder) {
        const idx = windows.findIndex(el => String(el.data?.uid) === String(activeOrder));
        if (idx !== -1) activeWindow = idx;
        else activeWindow = 0;
      }
      res_marks = res_marks.filter(el => newOrders.findIndex(d => String(d.uid) === String(el.uid)) !== -1);
      this.setState({ status, stoplist, update: data.update, windows, activeWindow, orders: newOrders, newWindow: null, tasks, marks, locations: { ...this.state?.locations, users: data?.locations || [] }, courierOrd: data?.courierOrd || [], courierTrn: data?.courierTrn || [] });

      if (data.onlineOrd?.length && !push_id) {
        news = true;
        let onlOrder = { ...data.onlineOrd[0] };
        let docTable = (data.tables || []).filter(dt => String(dt.pid) === String(onlOrder.id));
        onlOrder.docTable = docTable;
        setTimeout(() => this.showOnlineOrder(onlOrder), 250)
      }

      if (news) {
        // const audio = new Audio();
        // audio.preload = 'auto';
        // audio.src = sound3;
        // audio.play();
        playSound(this.state.soundMode, sound3)
      }
    } else if (idx === 'offCurendData') {
      const windows = this.setWindows(this.state.orders);
      const activeWindow = Math.min(this.state.activeWindow, windows.length - 1);
      this.setState({ windows, activeWindow });
    } else if (idx === 'getPrintJobs') {
      const status = data.status;
      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'));
        return;
      } else if (status === 'OffLine') return;
      else if (status === 'UsrChoise') {
        this.setLogin(data);
        return;
      }

      const srvJobs = data.data;
      let jobPrint = this.state.jobPrint;
      let ids = '';
      let errtxt = '';
      let needUpd = false;

      srvJobs.forEach(el => {
        const fnd = jobPrint.findIndex(jb => String(jb.job_id) === String(el.id));
        if (fnd === -1) ids = ids + ',' + el.id;
        else if (jobPrint[fnd].timer <= 0) {
          errtxt = errtxt + '|' + localestr('Принтер') + ' ' + el.device + ' ' + localestr('не відповідає тривалий час');
          ids = ids + ',' + el.id;
          jobPrint.splice(fnd, 1);
          needUpd = true;
        }
        else if (el.err_msg) {
          errtxt = errtxt + '|' + el.err_msg;
          ids = ids + ',' + el.id;
          if (fnd !== -1) jobPrint.splice(fnd, 1);
          needUpd = true;
        }
        else jobPrint[fnd].finded = true
      });
      const newJobPrint = jobPrint.filter(el => !el.job_id || el.finded)
      if (newJobPrint.length < jobPrint.length) {
        jobPrint = newJobPrint
        needUpd = true
      }

      if (ids) load('action=delJobs&data=' + ids.substring(1), () => { });
      if (errtxt) this.msg(errtxt.substring(1).replace('|', '\n'), localestr('Помилка'));
      if (needUpd) this.setState({ jobPrint: jobPrint.map(el => ({ ...el, finded: undefined })) });
      timer = 5;
    } else if (idx === 'setMarks') {
      const status = data.status;
      const srvMarks = data.data || [];
      const orders = this.state.orders;

      if (status === 'error') {
        this.msg(localestr('Помилка: ') + data.msg, localestr('Помилка'));
        return;
      } else if (status === 'OffLine') {
        res_marks.forEach((el, ind) => {
          const idx = srvMarks.findIndex(dt => String(dt.uid) === String(el.uid));
          if (idx !== -1) res_marks[ind].sended = false;
        });
        return;
      } else {
        res_marks = res_marks.filter(el => {
          const idx = srvMarks.findIndex(dt => String(dt.uid) === String(el.uid));
          const idx2 = orders.findIndex(dt => String(dt.id) === String(el.ord_id));
          return idx === -1 && idx2 !== -1;
        });
      }
    }
  };

  setLogin = async (data) => {
    const status = data.status
    let loginData = {}
    if (status === 'UsrChoise') {
      loginData = data
      //this.setState({status,loginData,rights:{},update:'',windows:[{caption:'Столи',wndType:'tablesTab'}],hall:'0',activeWindow:0})
      this.setState({ status, loginData, rights: {}, update: '', windows: [], orders: [], hall: '0', activeWindow: 0 })
      const d = new Date('2020-01-01')
      this.modUserDB(this.state.user_id, 0, 0, 0, d, -1)
    } else if (status === 'setPass') {
      loginData = { pass: data.pass, ...this.state.loginData }
      this.setState({ loginData })
    } else if (status === 'OK') {
      if (data.need_subscript) {
        if ('serviceWorker' in navigator && 'PushManager' in window) {
          if (process.env.NODE_ENV === 'production') {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
            const reg = await navigator.serviceWorker.register(swUrl, { scope: '/pos/' })
            if (reg.active) {
              let permissionResult = Notification.permission
              if (Notification.permission === 'default') {
                permissionResult = await Notification.requestPermission()
              }
              if (permissionResult === 'granted' && data.push_pub_key) {
                let subscription = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.push_pub_key) })
                if (subscription) {
                  const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];
                  const jsonSubscription = subscription.toJSON();
                  subscription = JSON.stringify(Object.assign(jsonSubscription, { contentEncoding }))
                  load('action=subscribeUser&data=' + subscription, () => { })
                }
              }
            }
          }
        }
      }
      const user = data.user
      let hall = String(data.hallId)
      let cashAcc = String(data.cashAcc)
      let terminal = data.terminal
      apiKey = String(data.GOOGLE_MAPS_KEY)
      if (hall === '0' || data.urHall === 1) {
        const c_user = localStorage.getItem('user') || ''
        const c_hall = localStorage.getItem('hall') || hall
        if (c_user === user) hall = c_hall
      }
      const rights = { urAdmin: data.urAdmin, urBanquet: data.urBanquet, urAdvance: data.urAdvance, urDiscount: data.urDiscount, urDiscSum: data.urDiscSum, urHall: data.urHall, 
        urOrder: data.urOrder, urInner_work: data.urInner_work, urDelivery: data.urDelivery, urPickup: data.urPickup, urTable: data.urTable, urReject: data.urReject, urFiscal: data.urFiscal, 
        urClose: data.urClose, urCashTransactions: data.urCashTransactions, urCashOpp0: data.urCashOpp0, urCashOpp1: data.urCashOpp1, urCashOpp2: data.urCashOpp2, urCashOpp3: data.urCashOpp3, 
        urCashOpp4: data.urCashOpp4, urCashRep: data.urCashRep, urReport: data.urReport, urUnclose: data.urUnclose, urNSedit: data.urNSedit, urNSclose: data.urNSclose, urBreack: data.urBreack, 
        urNoModifiers: data.urNoModifiers, urBlockOrder: data.urBlockOrder, urGuests: data.urGuests, urTip: data.urTip }
      localStorage.setItem('user', user)
      let pass = undefined
      let code = undefined
      if (data.login === 1) pass = this.state.loginData.pass
      if (data.login === 2) code = this.state.loginData.pass
      this.setUserDB(data.userId, user, data.user_fio, rights, hall,cashAcc, terminal, pass, code)
      this.setState({ status: 'OnLine', user, rights, hall, cashAcc, terminal, user_id: data.userId, user_fio: data.user_fio })
      if (data.msg) this.msg(data.msg)
    } else if (status === 'setDBOk') {
      this.setState({ hall: data.hall, cashAcc: data.cashAcc, terminal: data.terminal, newWindow: data.activeWnd, printer: data.printer })
      const dat1 = new Date(data.date)
      dat1.setDate(dat1.getDate() + 1)
      const dat2 = new Date()
      if (dat1 < dat2) this.loadData('', '')
      else setTimeout(this.getStartDB, 100)
      //load('action=getCurrentData&data='+JSON.stringify({update:this.state.update,date:new Date()}),(d)=>{this.loadData(d,'getCurrentData')})
      timer = 5
    } else if (status === 'OffLine') {
      if (data.key === 'init') {
        if (!data.data) this.getVlUsersDB(this.state.user)
        else this.OffLogin(data.data)
      } else if (data.key === 'LoginOk') {
        const user = data.data.user
        const hall = data.data.hall
        const cashAcc = data.data.cashAcc
        const terminal = data.data.terminal
        const rights = data.data.rights
        localStorage.setItem('user', user)
        this.setState({ status: 'OffLine', user, rights, hall, cashAcc, terminal, user_id: data.data.id })
        let pass = data.data.pass
        let code = data.data.code
        this.setUserDB(data.data.id, user, data.data.fio, rights, hall, cashAcc, terminal, pass, code)
      } else if (data.key === 'logoff') {
        this.setState({ status: '', user: '', rights: {}, hall: '', cashAcc: '', terminal: '' })
        this.getVlUsersDB()
      } else {
      }

    } else if (status === 'info') {
      this.msg(data.msg)
    } else if (status === 'error') {
      this.setState({ status: 'error' })
      this.msg(localestr(data.msg), localestr('Помилка'))
    }
  }

  runCmd = (cmd, data) => {
    if (cmd === 'prnRep1') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ jobPrint })
          return
        }
        if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          let jobPrint = this.state.jobPrint
          jobPrint.splice(data.index, 1)
          this.setState({ jobPrint })
        }
        else if (data.id) {
          //вставити id у завдання
          let jobPrint = this.state.jobPrint
          jobPrint[data.index].job_id = data.id
          this.setState({ jobPrint })
        }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані і зберегти хоча б одне замовлення
        let tasks = this.state.tasks
        if (tasks.length !== 0) {
          this.sendTask(tasks[0].uid, () => { this.runCmd(cmd, data) })
          return
        }
        //потім друкувати
        let prints = [...this.state.jobPrint]
        const fnd = prints.findIndex(el => el.type === 4) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 4, timer: 30 })
        this.setState({ jobPrint: prints })
        //load('action=prnReport1',(d)=>{this.runCmd(cmd,{...d,index:last_i})})

        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        let act = () => report('action=prnReport1', (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport1&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        const act2 = () => report('action=prnReport1&data=' + JSON.stringify({ printer: { id: 999999, name: 'screen', type: 3, marked: 0 } }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        this.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act2() }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
      }
    } else if (cmd === 'prnRep2') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ jobPrint })
          return
        }
        if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          let jobPrint = this.state.jobPrint
          jobPrint.splice(data.index, 1)
          this.setState({ jobPrint })
        }
        else if (data.id) {
          //вставити id у завдання
          let jobPrint = this.state.jobPrint
          jobPrint[data.index].job_id = data.id
          this.setState({ jobPrint })
        }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані і зберегти хоча б одне замовлення
        let tasks = this.state.tasks
        if (tasks.length !== 0) {
          this.sendTask(tasks[0].uid, () => { this.runCmd(cmd, data) })
          return
        }
        //потім друкувати
        let prints = [...this.state.jobPrint]
        const fnd = prints.findIndex(el => el.type === 4) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 4, timer: 30 })
        this.setState({ jobPrint: prints })
        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        let act = () => report('action=prnReport2', (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport2&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport2&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        const act2 = () => report('action=prnReport2&data=' + JSON.stringify({ printer: { id: 999999, name: 'screen', type: 3, marked: 0 } }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        this.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act2() }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
      }
    } else if (cmd === 'prnRep3') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ jobPrint })
          return
        }
        if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          let jobPrint = this.state.jobPrint
          jobPrint.splice(data.index, 1)
          this.setState({ jobPrint })
        }
        else if (data.id) {
          //вставити id у завдання
          let jobPrint = this.state.jobPrint
          jobPrint[data.index].job_id = data.id
          this.setState({ jobPrint })
        }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані і зберегти хоча б одне замовлення
        let tasks = this.state.tasks
        if (tasks.length !== 0) {
          this.sendTask(tasks[0].uid, () => { this.runCmd(cmd, data) })
          return
        }
        //потім друкувати
        let prints = [...this.state.jobPrint]
        const fnd = prints.findIndex(el => el.type === 4) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 4, timer: 30 })
        this.setState({ jobPrint: prints })
        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        let act = () => report('action=prnReport3', (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport3&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport3&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        const act2 = () => report('action=prnReport3&data=' + JSON.stringify({ printer: { id: 999999, name: 'screen', type: 3, marked: 0 } }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        this.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act2() }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
      }
    } else if (cmd === 'prnRep4') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ jobPrint })
          return
        }
        if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          let jobPrint = this.state.jobPrint
          jobPrint.splice(data.index, 1)
          this.setState({ jobPrint })
        }
        else if (data.id) {
          //вставити id у завдання
          let jobPrint = this.state.jobPrint
          jobPrint[data.index].job_id = data.id
          this.setState({ jobPrint })
        }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані і зберегти хоча б одне замовлення
        let tasks = this.state.tasks
        if (tasks.length !== 0) {
          this.sendTask(tasks[0].uid, () => { this.runCmd(cmd, data) })
          return
        }
        //потім друкувати
        let prints = [...this.state.jobPrint]
        const fnd = prints.findIndex(el => el.type === 4) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 4, timer: 30 })
        this.setState({ jobPrint: prints })
        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        let act = () => report('action=prnReport4', (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport4&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport4&data=' + JSON.stringify({ printer }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        const act2 = () => report('action=prnReport4&data=' + JSON.stringify({ printer: { id: 999999, name: 'screen', type: 3, marked: 0 } }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        this.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act2() }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
      }
    } else if (cmd === 'prnRep5') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ status, jobPrint })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          const jobPrint = this.state.jobPrint.filter((el) => el.type !== 4)
          this.setState({ jobPrint })
          return
        }
        if (data.print) {
          if (data.printer_type && parseInt(data.printer_type) === 2) {
            data.print.forEach(d => {
              if (d.type === 'svg') print_rawbt(d)
            })
          }
          else this.printData(data)
          let jobPrint = this.state.jobPrint
          jobPrint.splice(data.index, 1)
          this.setState({ jobPrint })
        }
        else if (data.id) {
          //вставити id у завдання
          let jobPrint = this.state.jobPrint
          jobPrint[data.index].job_id = data.id
          this.setState({ jobPrint })
        }
      } else {
        //перевірити чи онлайн
        if (this.state.status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          timer = 5
          return
        }
        //перевірити чи збережені дані і зберегти хоча б одне замовлення
        let tasks = this.state.tasks
        if (tasks.length !== 0) {
          this.sendTask(tasks[0].uid, () => { this.runCmd(cmd, data) })
          return
        }
        //потім друкувати
        let prints = [...this.state.jobPrint]
        const fnd = prints.findIndex(el => el.type === 4) //перевірити чи є таке саме завдання
        if (fnd !== -1) return
        const last_i = prints.length
        prints.push({ type: 4, timer: 30 })
        this.setState({ jobPrint: prints })
        let tz = (new Date()).getTimezoneOffset()
        tz = -(tz / 60)
        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        let act = () => report('action=prnReport5', (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport5&data=' + JSON.stringify({ printer, tz }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        if (printer) act = () => report('action=prnReport5&data=' + JSON.stringify({ printer, tz }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        const act2 = () => report('action=prnReport5&data=' + JSON.stringify({ printer: { id: 999999, name: 'screen', type: 3, marked: 0 }, tz }), (d) => { this.runCmd(cmd, { ...d, index: last_i }) })
        this.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act2() }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
      }
    } else if (cmd === 'showRRO') {
      if (!data) return
      const actions = { msg: this.msg, inputRange: this.inputRange, inputNumber: this.inputNumber, loaddata: this.load_data }
      let printer = null
      if (this.state.printer) printer = { ...this.state.printer }
      if (parseInt(data.device) === 4) {
        if (!this.state.modal) {
          const modal = <CatDevices4Viev data={data} actions={actions} setModal={this.setModal} ws={ws} printer={printer} />
          this.setState({ modal })
        } else if (!this.state.modal2) {
          const modal2 = <CatDevices4Viev data={data} actions={actions} setModal={this.setModal2} ws={ws} printer={printer} />
          this.setState({ modal2 })
        } else if (!this.state.modal3) {
          const modal3 = <CatDevices4Viev data={data} actions={actions} setModal={this.setModal3} ws={ws} printer={printer} />
          this.setState({ modal3 })
        } else {
          const modal4 = <CatDevices4Viev data={data} actions={actions} setModal={this.setModal4} ws={ws} printer={printer} />
          this.setState({ modal4 })
        }
      } else if (parseInt(data.device) === 5) {
        if (!this.state.modal) {
          const modal = <CatDevices5Viev data={data} actions={actions} setModal={this.setModal} ws={ws} printer={printer} />
          this.setState({ modal })
        } else if (!this.state.modal2) {
          const modal2 = <CatDevices5Viev data={data} actions={actions} setModal={this.setModal2} ws={ws} printer={printer} />
          this.setState({ modal2 })
        } else if (!this.state.modal3) {
          const modal3 = <CatDevices5Viev data={data} actions={actions} setModal={this.setModal3} ws={ws} printer={printer} />
          this.setState({ modal3 })
        } else {
          const modal4 = <CatDevices5Viev data={data} actions={actions} setModal={this.setModal4} ws={ws} printer={printer} />
          this.setState({ modal4 })
        }
      }
    } else if (cmd === 'chnPrinter') {
      if (data) {
        let printer = data
        if (this.state.data['const'] && this.state.data['const'].constPrinter && parseInt(this.state.data['const'].constPrinter) === parseInt(data.id)) printer = null
        this.setState({ printer })
        this.modUserDB(this.state.user_id, null, null, null, null, printer)
      } else {
        //менюшка з вибором
        if (!this.state.data) return
        if (!this.state.data['printers']) return
        if (!this.state.data['printers'].length) return
        let btns = this.state.data['printers'].map(el => ({ caption: el?.name, action: () => this.runCmd(cmd, el) }))
        this.msg_arr('', localestr('Чековий принтер'), btns)
      }
    } else if (cmd === 'getOrderList') {
      if (data) {
        const status = data.status
        if (status === 'OffLine') {
          this.msg(localestr('Відсутня мережа!\nВідновіть звязок і повторіть спробу!'))
          this.setState({ status })
          return
        } else if (status === 'error') {
          this.msg(localestr(data.msg), localestr('Помилка'))
          return
        }
        const actions = { msg: this.msg, loaddata: this.load_data, updateStatus: () => { this.tick(true) } }
        let printer = null
        if (this.state.printer) printer = { ...this.state.printer }
        if (!this.state.modal) {
          const modal = <CheckList data={data.data} actions={actions} setModal={this.setModal} printer={printer} rights={this.state.rights} />
          this.setState({ modal })
        } else if (!this.state.modal2) {
          const modal2 = <CheckList data={data.data} actions={actions} setModal={this.setModal2} printer={printer} rights={this.state.rights} />
          this.setState({ modal2 })
        } else if (!this.state.modal3) {
          const modal3 = <CheckList data={data.data} actions={actions} setModal={this.setModal3} printer={printer} rights={this.state.rights} />
          this.setState({ modal3 })
        } else {
          const modal4 = <CheckList data={data.data} actions={actions} setModal={this.setModal4} printer={printer} rights={this.state.rights} />
          this.setState({ modal4 })
        }
      } else {
        load('action=getOrderList', (d) => { this.runCmd(cmd, d) })
      }
    } else if (cmd === 'chnTheme') {
      let arr_theme;
      switch (data) {
        case "1": arr_theme = Object.entries(THEME1); break;
        case "2": arr_theme = Object.entries(THEME2); break;
        case "3": arr_theme = Object.entries(THEME3); break;
        // new themes
        case "00": arr_theme = Object.entries(THEME_0); break;
        case "02": arr_theme = Object.entries(THEME_2); break;
        case "03": arr_theme = Object.entries(THEME_3); break;
        default: arr_theme = Object.entries(THEME_0);
      }
      for (let i = 0; i < arr_theme.length; i++) document.documentElement.style.setProperty(arr_theme[i][0], arr_theme[i][1]);
      localStorage.setItem("theme", data);
    } else if (cmd === 'setTabsMode') {
      const tabsMode = localStorage.getItem('tabsMode') || '0';
      const mode = tabsMode === '0' ? '1' : '0';
      localStorage.setItem('tabsMode', mode);
      this.setState({ tabsMode: mode });
    } else if (cmd === 'setSoundMode') {
      const soundMode = localStorage.getItem('soundMode') || '0';
      const mode = soundMode === '0' ? '1' : '0';
      this.setState({ soundMode: mode });
    }
    // касові операції
    else if (cmd === 'addOtherAdmission') {
      const actions = { msg: this.msg, loaddata: this.load_data }
      const modal = <NewStatement type={"OtherAdmission"} actions={actions} msg={this.msg} caption={"Інші поступлення"} setModal={this.setModal}
        departments={this.state.data.catDepartments} cashAccounts={this.state.data.catCashAccs} articles={this.state.data.catArticles}
        counterparties={this.state.data.catCounterparties} userCashAccount={parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox} />;
      this.setState({ modal });
    } else if (cmd === 'addOtherExpense') {
      const actions = { msg: this.msg, loaddata: this.load_data }
      const modal = <NewStatement type={"OtherExpense"} actions={actions} msg={this.msg} caption={"Інші видатки"} setModal={this.setModal}
        departments={this.state.data.catDepartments} cashAccounts={this.state.data.catCashAccs} articles={this.state.data.catArticles}
        counterparties={this.state.data.catCounterparties} userCashAccount={parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox} />;
      this.setState({ modal });
    } else if (cmd === 'getTransfer') {
      const actions = { msg: this.msg, loaddata: this.load_data }
      const modal = <NewStatement type={"_Transfer"} actions={actions} msg={this.msg} caption={'Отримання з іншої каси'} setModal={this.setModal}
        departments={this.state.data.catDepartments} cashAccounts={this.state.data.catCashAccs} articles={this.state.data.catArticles}
        counterparties={this.state.data.catCounterparties} userCashAccount={parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox} />;
      this.setState({ modal });
    } else if (cmd === 'addTransfer') {
      const actions = { msg: this.msg, loaddata: this.load_data }
      const modal = <NewStatement type={"Transfer"} actions={actions} msg={this.msg} caption={"Передача до каси/на рахунок"} setModal={this.setModal}
        departments={this.state.data.catDepartments} cashAccounts={this.state.data.catCashAccs} articles={this.state.data.catArticles}
        counterparties={this.state.data.catCounterparties} userCashAccount={parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox} />;
      this.setState({ modal });
    } else if (cmd === 'addSupplierPayment') {
      const actions = { msg: this.msg, loaddata: this.load_data }
      const modal = <NewStatement type={"SupplierPayment"} actions={actions} msg={this.msg} caption={"Оплата постачальнику"} setModal={this.setModal}
        departments={this.state.data.catDepartments} cashAccounts={this.state.data.catCashAccs} articles={this.state.data.catArticles}
        counterparties={this.state.data.catCounterparties} userCashAccount={parseInt(this.state.cashAcc) ? this.state.cashAcc : this.state.data.const.constCashbox} />;
      this.setState({ modal });
    } else console.log(cmd)
  }

  load_data = (formData, data, action) => {
    if (formData) {
      this.setState({ status: 'loading' })
      loaddat(formData, d => this.load_data(undefined, d, action))
    } else if (data.status === 'error') {
      this.setState({ status: 'OnLine' })
      this.msg(data.msg, localestr('Помилка'))
    } else {
      if (data.msg) {
        this.msg(data.msg, localestr('Інформація'))
      }
      if (data.print) { //Друк
        if (data.printer_type && parseInt(data.printer_type) === 2) {
          data.print.forEach(d => {
            if (d.type === 'svg') print_rawbt(d)
          })
        }
        else this.printData(data)
      }
      this.setState({ status: 'OnLine' })
      action(data)
    }
  }

  connectDB = (f) => {
    const request = window.indexedDB.open('rest_base', 1)
    request.onerror = (err) => { this.msg(err, localestr('Помилка')) }
    request.onsuccess = () => { db = request.result; f() }
    request.onupgradeneeded = (e) => {
      const db = e.currentTarget.result
      switch (e.oldVersion) {
        case 0: {
          db.createObjectStore('users', { keyPath: 'id' })
          db.createObjectStore('StartData', { keyPath: 'id' })
          db.createObjectStore('CurData', { keyPath: 'id' })
          //db.createObjectStore('Templates', {keyPath: 'key'})
          //start.createIndex('user', 'user', { unique: true })
          break
        }
        default: {
          break
        }
      }
      this.connectDB(f)
    }
  }

  OffLogin = async (data) => {
    let res = []
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return res
    }
    const tx = db.transaction('users')
    const store = tx.objectStore('users')
    const ret = store.getAll()
    await new Promise((resolve, reject) => {
      ret.onsuccess = () => {
        res = ret.result
        resolve()
      }
      ret.onerror = () => {
        resolve()
      }
    })
    await tx.complete
    let login = 1
    let result = res.filter(el => { return el.user === data.user && el.pass === data.pass })
    if (!result.length) login = 2
    if (!result.length) result = res.filter(el => { return el.user === data.user && el.code === data.pass })
    if (result.length) this.setLogin({ status: 'OffLine', key: 'LoginOk', data: { login, ...result[0] } })
  }

  getUserIdDB = async (id) => {
    let res = ''
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return res
    }
    const tx = db.transaction('users')
    const store = tx.objectStore('users')
    const ret = store.get(id)
    await new Promise((resolve, reject) => {
      ret.onsuccess = () => {
        res = ret.result
        resolve()
      }
      ret.onerror = () => {
        resolve()
      }
    })
    await tx.complete
    return res
  }

  getVlUsersDB = async (inUser = '') => {
    let res = []
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return res
    }
    const tx = db.transaction('users')
    const store = tx.objectStore('users')
    if ('getAll' in store) {
      const ret = store.getAll()
      await new Promise((resolve, reject) => {
        ret.onsuccess = () => {
          res = ret.result
          resolve()
        }
        ret.onerror = () => {
          resolve()
        }
      })
      await tx.complete
    } else {
      const ret = store.openCursor()
      await new Promise((resolve, reject) => {
        ret.onsuccess = (evt) => {
          const cursor = evt.target.result
          if (cursor) {
            res.push({ name: cursor.value })
            cursor.continue()
          } else
            resolve()
        }
        ret.onerror = () => {
          resolve()
        }
      })
    }
    const user = res.find(el => el.user === inUser)
    if (user) {
      if (user.lastLogin) {
        const dat1 = new Date(user.lastLogin)
        dat1.setDate(dat1.getDate() + 1)
        const dat2 = new Date()
        if (dat1 > dat2) this.setLogin({ status: 'OffLine', key: 'init', data: { user: user.user, pass: user.pass || user.code } })
        else
          this.setLogin({ status: 'UsrChoise', users: res.map(el => { return { name: el.user } }) })
      }
      else
        this.setLogin({ status: 'UsrChoise', users: res.map(el => { return { name: el.user } }) })
    } else
      this.setLogin({ status: 'UsrChoise', users: res.map(el => { return { name: el.user } }) })
  }

  setUserDB = async (id, user, fio, rights, hall, cashAcc, terminal, pass, code, date = 0, activeWnd = 0, printer = null) => {
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    const oldUser = await this.getUserIdDB(id)
    if (oldUser) {
      if (!user) user = oldUser.user
      if (!fio) fio = oldUser.fio
      if (!rights) rights = oldUser.rights
      if (oldUser.hall) hall = oldUser.hall
      if (!pass) pass = oldUser.pass
      if (!code) code = oldUser.code
      if (!date) date = oldUser.date
      if (!activeWnd) activeWnd = oldUser.activeWnd
      if (!printer) printer = oldUser.printer
    }
    const tx = db.transaction('users', 'readwrite')
    const store = tx.objectStore('users')
    const lastLogin = new Date()
    try {
      await store.put({ id, user, fio, rights, hall, cashAcc, terminal, activeWnd, pass, code, date, lastLogin, printer })
      await tx.complete

    } catch (err) {
      console.log('error', err.message)
    }
    this.setLogin({ status: 'setDBOk', id, user, fio, rights, hall, cashAcc, terminal, pass, code, date, activeWnd, printer })
  }

  modUserDB = async (id, hall = 0, date = 0, activeWnd = null, lastLogin = 0, printer = null) => {
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    const oldUser = await this.getUserIdDB(id)
    if (oldUser) {
      const user = oldUser.user
      const fio = oldUser.fio
      const rights = oldUser.rights
      if (!hall) hall = oldUser.hall
      const pass = oldUser.pass
      const code = oldUser.code
      if (!date) date = oldUser.date
      if (!activeWnd) activeWnd = oldUser.activeWnd
      const tx = db.transaction('users', 'readwrite')
      const store = tx.objectStore('users')
      if (!lastLogin) lastLogin = new Date()
      if (printer === -1) printer = oldUser.printer
      try {
        await store.put({ id, user, fio, rights, hall, activeWnd, pass, code, date, lastLogin, printer })
        await tx.complete

      } catch (err) {
        console.log('error', err.message)
      }
    }
  }

  setStartDB = async (d) => {
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    let tx = db.transaction('StartData', 'readwrite')
    let store = tx.objectStore('StartData')
    let data = { id: this.state.user_id, ...d }
    try {
      await store.put(data)
      await tx.complete
    } catch (err) {
      console.log('error', err.message)
      data = undefined
    }
    if (!data) return
    tx = db.transaction('users', 'readwrite')
    store = tx.objectStore('users')
    const usr = await this.getUserIdDB(this.state.user_id)
    if (usr) {
      usr.date = new Date()
      tx = db.transaction('users', 'readwrite')
      store = tx.objectStore('users')
      try {
        await store.put(usr)
        await tx.complete
      } catch (err) {
        console.log('error', err.message)
      }
    }
  }

  getStartDB = async () => {
    let res = undefined
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    const tx = db.transaction('StartData')
    const store = tx.objectStore('StartData')
    const ret = store.get(this.state.user_id)
    await new Promise((resolve, reject) => {
      ret.onsuccess = () => {
        res = ret.result
        resolve()
      }
      ret.onerror = () => {
        resolve()
      }
    })
    await tx.complete
    if (res) {
      delete res.id
      this.setState({ data: res })
    }
    setTimeout(() => this.loadData('', 'startDataOk'), 100)
  }

  setCurentDB = async (d) => {
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    let tx = db.transaction('CurData', 'readwrite')
    let store = tx.objectStore('CurData')
    let data = { id: this.state.user_id, data: d }
    try {
      await store.put(data)
      await tx.complete
    } catch (err) {
      console.log('error', err.message)
      data = undefined
    }
  }

  getCurentDB = async () => {
    let res = undefined
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    const tx = db.transaction('CurData')
    const store = tx.objectStore('CurData')
    const ret = store.get(this.state.user_id)
    await new Promise((resolve, reject) => {
      ret.onsuccess = () => {
        res = ret.result
        resolve()
      }
      ret.onerror = () => {
        resolve()
      }
    })
    await tx.complete
    if (res) {
      const dat = new Date()
      const dat1 = dat.toISOString().substring(0, 10)
      dat.setDate(dat.getDate() - 1)
      const dat2 = dat.toISOString().substring(0, 10)
      const orders = res.data.filter(el => el.date.substring(0, 10) === dat1 || el.date.substring(0, 10) === dat2)
      const windows = this.setWindows(orders)
      const activeWindow = Math.min(this.state.activeWindow, windows.length - 1)
      this.setState({ orders, windows, activeWindow })
    }
  }

  setMarksDB = async (d) => {
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    let tx = db.transaction('CurData', 'readwrite')
    let store = tx.objectStore('CurData')
    const load_data = d.map(el => ({ id: el.id, good: el.good, code: el.code, vol: el.vol, qtt: el.qtt, last_upd: el.last_upd }))
    let data = { id: '0', data: load_data }
    try {
      await store.put(data)
      await tx.complete
    } catch (err) {
      console.log('error', err.message)
      data = undefined
    }
  }

  getMarksDB = async () => {
    let res = undefined
    if (!db) {
      this.msg(localestr('Не вдалося підключитися до локальної бази даних'), localestr('Помилка'))
      return
    }
    const tx = db.transaction('CurData')
    const store = tx.objectStore('CurData')
    const ret = store.get('0')
    await new Promise((resolve, reject) => {
      ret.onsuccess = () => {
        res = ret.result
        resolve()
      }
      ret.onerror = () => {
        resolve()
      }
    })
    await tx.complete
    if (res) {
      const marks = res.data
      this.setState({ marks })
    }
  }

  tick = (update_only = false) => {
    if (this.state.status !== 'OnLine' && this.state.status !== 'OffLine') return
    if (update_only) {
      load('action=getCurrentData&data=' + JSON.stringify({ update: this.state.update, date: new Date() }), (d) => { this.loadData(d, 'getCurrentData') })
      timer = 15
      return
    }
    if (this.state.modal) return
    //зменшуємо час усім завданням на 1
    let tasks = this.state.tasks
    let jobPrint = this.state.jobPrint
    let need_getJobs = false
    for (let i = 0; i < tasks.length; i++) {
      tasks[i].timer--
      if (tasks[i].sended && tasks[i].timer < -3) {  //повисші завдання відправимо повторно
        tasks[i].timer = 1
        tasks[i].sended = false
      }
    }
    for (let i = 0; i < jobPrint.length; i++) {
      if (jobPrint[i].job_id && jobPrint[i].timer < 0) need_getJobs = true
      jobPrint[i].timer--
    }
    jobPrint = jobPrint.filter(el => el.timer > -15)
    this.setState({ tasks, jobPrint })

    if (sended) return
    if (w_s.ws) { w_s.ws.close(1000); w_s.ws = null }//якщо відкритий сокет - закриваємо
    this.saveDiscount() //зберігаємо 1-го клієнта за раз
    //якщо є завдання з нульовим часом відправляємо 
    //for (let i=0; i<tasks.length; i++) if(tasks[i].timer<=0) this.sendTask(tasks[i].uid)
    //переробив, по одно завдання за раз
    if (this.state.status === 'OnLine') {
      for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].timer <= 0) {
          this.sendTask(tasks[i].uid)
          break
        }
      }
    }

    //перевіряємо завдання print успішні і з нульовим часом удаляємо
    if (need_getJobs) {
      //запросити з сервера статус
      //а в колбек процедуру по зачистці
      load('action=getJobs', (d) => { this.loadData(d, 'getPrintJobs') })
    }

    //--акцизні марки--
    if (this.state.data && this.state.data.const && this.state.data.const.constExciseMark) {
      let new_marks = res_marks.filter(el => el.qtt && !el.sended && el.ord_id)
      if (new_marks.length) {
        const orders = this.state.orders
        new_marks = new_marks.filter(el => (orders.findIndex(dt => dt.id === el.ord_id) !== -1))
        load('action=setMarks&data=' + JSON.stringify(new_marks), (d) => { this.loadData(d, 'setMarks') })
        res_marks.forEach((el, ind) => {
          const idx = new_marks.findIndex(dt => dt.uid === el.uid)
          if (idx !== -1) res_marks[ind].sended = 1
          //else if(el.sended>10) res_marks[ind].sended=0
          //else if(el.sended) res_marks[ind].sended++
        })
      }
    }
    //-----------------

    timer--
    if (timer > 0) return
    if (tasks && tasks.length > 0) return
    if (!this.state.modal) push_id = null
    //інакше загружаємо
    load('action=getCurrentData&data=' + JSON.stringify({ update: this.state.update, date: new Date() }), (d) => { this.loadData(d, 'getCurrentData') })
    timer = 15
  }

  setTime = () => {
    const modal = <TimeKeeping setModal={this.setModal} />
    this.setState({ modal })
  }

  beforeClose = (event) => {
    //this.setCurentDB(this.state.orders)
    //this.modUserDB(this.state.user_id,null,null,this.state.windows[this.state.activeWindow].data.uid)
    if (this.state.tasks.length > 0) {
      for (let i = 0; i < this.state.tasks.length; i++) this.sendTask(this.state.tasks[i].uid)
      event.preventDefault()
      event.returnValue = ''
    }
  }

  async componentDidMount() {
    this.connectDB(() => { load("action=init", this.setLogin) })
    const user = localStorage.getItem('user') || ''
    const timekeeping = parseInt(localStorage.getItem('timekeeping') || 0)
    const theme = localStorage.getItem('theme') || null
    if (theme) this.runCmd('chnTheme', theme)
    //const hall=localStorage.getItem('hall') || ''
    //const activeWindow=localStorage.getItem('activeWindow') || 0
    this.setState({ user, timekeeping })
    window.addEventListener('beforeunload', (event) => { this.beforeClose(event) })
    //window.addEventListener('keydown', this.handleKeyPres)
    this.interval = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    //window.removeEventListener('keydown', this.handleKeyPres);
    clearInterval(this.interval)
  }

  render() {
    const { status, user, modal, modal2, modal3, modal4, modal5, modal6, activeWindow, windows, loginData, tasks } = this.state
    const actions = { setLogin: this.setLogin, loadData: this.loadData, runCmd: this.runCmd, sendTask: this.sendTask, setTimekeeping: (timekeeping => { localStorage.setItem('timekeeping', timekeeping); this.setState({ timekeeping }) }) }
    //let curr_wnd=activeWindow
    return (

      !status ? (
        <Loader />
      ) : (
        status === 'UsrChoise' ? (
          <>
            <AuthForm status={status} inUser={user} loginData={loginData} setLogin={this.setLogin} setTime={this.setTime} />
            {modal}
            {modal2}
          </>
        ) : (
          <dataContext.Provider value={{ ws, w_s }}>
            <>
              <Header User={user} status={status} actions={actions} Rights={{ ...this.state.rights, ...this.state.data.const }} catDevices={this.state.data['catDevices']} printers={this.state.data['printers']}
                curr_printer={this.state.printer} Tasks={tasks} wndType={windows.length === 0 ? '' : windows[activeWindow] ? windows[activeWindow].wndType : ''} catList={this.state.data.catMenu}
                addGood={(el) => this.modOrder(activeWindow, 'add', el)} stoplist={this.state.stoplist} timekeeping={this.state.timekeeping} otherSettings={{ tabsMode: this.state.tabsMode, soundMode: this.state.soundMode }} />
              <div className='panel no-print'>
                <TabPanel ActiveTab={activeWindow} Tabs={windows} Tasks={tasks} TabClick={this.tabClick} TabClose={this.tabClose} User={this.state.user_id} TabsMode={this.state.tabsMode} />
                <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>{windows.length === 0 ? '' : windows[activeWindow] ? this.getWnd(windows[activeWindow].wndType, activeWindow) : ''}</div>
              </div>
              {modal}
              {modal2}
              {modal3}
              {modal4}
              {modal5}
              {modal6}
              {status === 'loading' ? (<Loader />) : ('')}
            </>
          </dataContext.Provider>
        )
      )

    )
  }
}

export default App;
